// Spanish translations for Kintsugi TCC
const es = {
  // Common
  "app.name": "Kintsugi TCC",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.less": "menos",
  "common.loading": "Cargando...",
  "common.back": "Volver",
  "common.next": "Siguiente",
  "common.previous": "Anterior",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.or": "o",
  "common.yes": "Sí",
  "common.no": "No",

  // Auth
  "auth.login": "Iniciar sesión",
  "auth.register": "Crear una cuenta",
  "auth.logout": "Cerrar sesión",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.confirmPassword": "Confirmar contraseña",
  "auth.fullName": "Nombre completo",
  "auth.iAm": "Soy...",
  "auth.therapist": "Terapeuta",
  "auth.patient": "Paciente",
  "auth.therapistEmail": "Correo de su terapeuta (opcional)",
  "auth.therapistEmailHint": "Su terapeuta recibirá un correo para activar su cuenta",
  "auth.patientNote": "Nota: Un terapeuta deberá activar su cuenta para acceder a los ejercicios.",
  "auth.loginWith": "Iniciar sesión con Google",
  "auth.registerWith": "Registrarse con Google",
  "auth.noAccount": "¿No tiene cuenta?",
  "auth.hasAccount": "¿Ya tiene cuenta?",
  "auth.createAccount": "Crear mi cuenta",
  "auth.creating": "Creando...",
  "auth.connecting": "Conectando...",
  "auth.startJourney": "Comience su recorrido terapéutico",
  "auth.welcome": "Bienvenido/a",
  "auth.invalidCredentials": "Credenciales inválidas",
  "auth.passwordMismatch": "Las contraseñas no coinciden",
  "auth.passwordMinLength": "La contraseña debe tener al menos 6 caracteres",
  "auth.accountCreated": "¡Cuenta creada con éxito!",
  "auth.loginSuccess": "¡Conexión exitosa!",
  "auth.accountPending": "Su cuenta debe ser activada por su terapeuta.",
  "auth.forgotPasswordLink": "¿Olvidó su contraseña?",
  "auth.forgotPassword": "Contraseña olvidada",
  "auth.forgotPasswordDesc": "Introduzca su correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
  "auth.sendResetLink": "Enviar enlace",
  "auth.resetEmailSent": "¡Correo enviado!",
  "auth.resetEmailSentDesc": "Si existe una cuenta con este correo, recibirá un enlace de restablecimiento en breve. Revise su carpeta de spam.",
  "auth.resetEmailNotReceived": "¿No recibió el correo? Revise su spam o reenvíe el enlace.",
  "auth.resendEmail": "Reenviar correo",
  "auth.backToLogin": "Volver al inicio de sesión",
  "auth.newPassword": "Nueva contraseña",
  "auth.newPasswordDesc": "Elija una nueva contraseña para su cuenta.",
  "auth.passwordReset": "¡Contraseña restablecida!",
  "auth.passwordResetDesc": "Su contraseña se ha restablecido correctamente. Ahora puede iniciar sesión con su nueva contraseña.",
  "auth.resetPassword": "Restablecer contraseña",
  "auth.invitedBy": "Invitación de",
  "auth.invitationNote": "Su cuenta será activada tras la validación de su terapeuta.",
  "auth.invalidInvitationCode": "Código de invitación inválido",
  "auth.passwordPolicy": "Mín. 8 caracteres, 1 mayúscula, 1 minúscula, 1 número",
  "auth.healthDataConsent": "Acepto el tratamiento de mis datos de salud en el marco de mi seguimiento terapéutico, conforme al RGPD.",
  "auth.privacyLink": "Política de privacidad",
  "auth.rateLimited": "Demasiados intentos. Inténtelo de nuevo en 5 minutos.",
  "auth.authError": "Error de autenticación",
  "auth.authenticating": "Autenticando...",
  "auth.autoLogout": "Ha sido desconectado/a por seguridad tras un periodo de inactividad.",

  // Navigation
  "nav.dashboard": "Panel de control",
  "nav.dersQuestionnaire": "Cuestionario DERS",
  "nav.sexualityTcc": "TCC Sexualidad",
  "nav.myDoneExercises": "Mis ejercicios realizados",
  "nav.statistics": "Estadísticas",
  "nav.administration": "Administración",
  "nav.patients": "Pacientes",
  "nav.sessionReports": "Informes de sesión",
  "nav.exercises": "Ejercicios",
  "nav.reminders": "Recordatorios",
  "nav.profile": "Mi Perfil",
  "app.refresh": "Actualizar la aplicación",
  "app.refresh_hint": "Recarga la última versión de la aplicación sin cerrar sesión",
  "app.refresh_now": "Actualizar",
  "app.update_available": "Nueva versión disponible",
  "nav.exercisesSection": "Ejercicios",
  "nav.cbtExercises": "Ejercicios TCC",
  "nav.barkleyParents": "Barkley — Padres",
  "nav.barkleyChildren": "Barkley — Niños",
  "nav.barkleyTeens": "Barkley — Adolescentes",
  "nav.myExercises": "Mis ejercicios",
  "nav.psychoeducation": "Psicoeducación",
  "nav.theoryModules": "Módulos teóricos",
  "nav.addPatient": "Añadir un paciente",
  "nav.meditations": "Meditaciones Video",
  "nav.myMeditations": "Mis Meditaciones",

  // Video Meditations
  "meditations.title": "Meditaciones Video",
  "meditations.subtitle": "Suba y gestione videos de meditación guiada para sus pacientes",
  "meditations.uploadNew": "Subir un video",
  "meditations.dropzoneText": "Haga clic para seleccionar un video",
  "meditations.videoTitle": "Título del video",
  "meditations.titlePlaceholder": "Ej: Respiración guiada 10min",
  "meditations.language": "Idioma",
  "meditations.description": "Descripción (opcional)",
  "meditations.descPlaceholder": "Descripción de la meditación...",
  "meditations.uploading": "Subiendo...",
  "meditations.assembling": "Finalizando...",
  "meditations.chunkInfo": "Envío por partes para soportar archivos grandes",
  "meditations.uploadBtn": "Subir video",
  "meditations.uploadSuccess": "Video subido con éxito!",
  "meditations.uploadError": "Error al subir",
  "meditations.invalidFormat": "Formato no soportado. Use MP4, MOV, AVI, WebM o MKV.",
  "meditations.fileTooLarge": "Archivo demasiado grande (máx 800 MB)",
  "meditations.library": "Biblioteca de videos",
  "meditations.emptyLibrary": "Ningún video subido",
  "meditations.emptyLibraryHint": "Suba su primer video de meditación arriba",
  "meditations.assign": "Asignar",
  "meditations.assignTo": "Asignar a pacientes",
  "meditations.assignHint": "Seleccione los pacientes que tendrán acceso a",
  "meditations.assigned": "Meditación asignada",
  "meditations.unassigned": "Meditación retirada",
  "meditations.searchPatient": "Buscar un paciente...",
  "meditations.noPatients": "Sin pacientes activos",
  "meditations.confirmDelete": "¿Eliminar esta meditación?",
  "meditations.deleted": "Meditación eliminada",
  "meditations.noSupport": "Su navegador no soporta la reproducción de video.",
  "meditations.patientTitle": "Mis Meditaciones",
  "meditations.patientSubtitle": "Videos de meditación guiada asignados por su terapeuta",
  "meditations.viewed": "Vista",
  "meditations.new": "Nuevo",
  "meditations.backToList": "Volver a la lista",
  "meditations.noAssignments": "Ninguna meditación asignada",
  "meditations.noAssignmentsHint": "Su terapeuta le asignará videos de meditación",

  // Session Reports
  "sessions.title": "Informes de sesión",
  "sessions.subtitle": "Gestione sus informes de sesión por paciente",
  "sessions.newReport": "Nuevo informe",
  "sessions.editReport": "Editar el informe",
  "sessions.createFirst": "Crear su primer informe",
  "sessions.noReports": "Ningún informe de sesión",
  "sessions.backToList": "Volver",
  "sessions.patient": "Paciente",
  "sessions.selectPatient": "Seleccionar un paciente",
  "sessions.allPatients": "Todos los pacientes",
  "sessions.sessionType": "Tipo de sesión",
  "sessions.typeInitial": "Entrevista inicial",
  "sessions.typeSuivi": "Sesión de seguimiento TCC",
  "sessions.typeAdo": "Seguimiento TCC niños y adolescentes (12-17)",
  "ado.schoolStress.title": "Mi diario de estrés escolar",
  "ado.schoolStress.desc": "Cada día de clase, 2 minutos: tu estrés, lo que pasó, lo que te dijiste, lo que te ayudó.",
  "ado.exposurePlan.title": "Mi plan de retos en clase",
  "ado.exposurePlan.desc": "Una escalera de retos de más fácil a más difícil, con tu ansiedad antes / después.",
  "nav.grief": "Duelo",
  "library.grief": "Duelo (TCC)",
  "library.psychoedGrief": "Psicoeducación sobre el duelo",
  "psychoed.grief.title": "El proceso del duelo",
  "psychoed.grief.subtitle": "Comprender el duelo, reconocer cuándo se complica y avanzar con el enfoque TCC",
  "psychoed.griefAdo.title": "Vivir un duelo (12-17 años)",
  "psychoed.griefAdo.subtitle": "Comprender lo que te pasa cuando pierdes a alguien, y encontrar cómo seguir adelante sin olvidar",
  "grief.memoryJournal.title": "Diario de recuerdos",
  "grief.memoryJournal.desc": "Exposición graduada a los recuerdos: recuerdo elegido, relato detallado, emoción antes/después, lo que este recuerdo dice del vínculo.",
  "grief.letter.title": "Carta a la persona fallecida",
  "grief.letter.desc": "Escribir lo que no se dijo: arrepentimientos, gratitud, ira, noticias de su vida, luego la respuesta imaginada.",
  "grief.avoidance.title": "Jerarquía de situaciones evitadas",
  "grief.avoidance.desc": "Listar lo que ha evitado desde el fallecimiento, calificar la dificultad, planificar una confrontación gradual y registrar el resultado.",
  "grief.reengagement.title": "Plan de reactivación",
  "grief.reengagement.desc": "Cada semana, un valor, una actividad concreta, los obstáculos anticipados y el balance.",
  "griefScale.navTitle": "Escala de duelo",
  "griefScale.subtitle": "13 preguntas · 3 minutos · seguimiento de su evolución en el tiempo",
  "griefScale.history": "Mi evolución",
  "griefScale.pending": "Su terapeuta le invita a completar esta escala",
  "griefScale.dim1": "Angustia por separación: añoranza, preocupación, soledad.",
  "griefScale.dim2": "Angustia emocional y evitación: aceptación, ira, culpa, evitación, pérdida de sentido.",
  "griefScale.dim3": "Impacto en la vida: actividades y relaciones.",
  "griefScale.monthsLabel": "¿Cuántos meses hace que ocurrió la pérdida? (opcional)",
  "griefScale.start": "Comenzar",
  "griefScale.startAgain": "Volver a hacer la escala",
  "griefScale.submit": "Ver mis resultados",
  "griefScale.saved": "Escala guardada",
  "griefScale.notePlaceholder": "Nota opcional (contexto actual: aniversario, fiestas, trámites…)",
  "griefScale.yourResult": "Su resultado",
  "griefScale.total": "Puntuación total",
  "griefScale.level": "Nivel de aflicción",
  "griefScale.prolongedFlag": "Más de seis meses después de la pérdida con una aflicción intensa que impacta en la vida: hable con su terapeuta, un trabajo específico sobre el duelo puede ayudar.",
  "griefScale.disclaimer": "Herramienta de seguimiento no estandarizada, inspirada en los criterios del duelo prolongado (CIM-11, DSM-5-TR) y las escalas PG-13 / ICG (Prigerson). No constituye un diagnóstico; una aflicción intensa es normal, especialmente en los primeros meses.",
  "griefScale.trend": "Evolución en el tiempo",
  "griefScale.trendHint": "Objetivo: una disminución gradual de las tres dimensiones, en particular del impacto en la vida.",
  "griefScale.needTwo": "Complete la escala al menos dos veces para ver su evolución.",
  "griefScale.lastResult": "Último resultado",
  "griefScale.allResults": "Todos los registros",
  "nav.perfectionism": "Perfeccionismo y excelentismo",
  "perfScale.navTitle": "Cuestionario de perfeccionismo",
  "perfScale.subtitle": "20 preguntas · 5 minutos · seguimiento de tu evolución en el tiempo",
  "perfScale.history": "Mi evolución",
  "perfScale.pending": "Su terapeuta le invita a rellenar este cuestionario",
  "perfScale.dim1": "Excelentismo: apuntar muy alto con flexibilidad.",
  "perfScale.dim2": "Estándares perfeccionistas: exigir la perfección.",
  "perfScale.dim3": "Preocupaciones perfeccionistas: miedo al error, duda, autocrítica.",
  "perfScale.start": "Empezar",
  "perfScale.startAgain": "Volver a hacer el cuestionario",
  "perfScale.notePlaceholder": "Nota opcional (contexto del momento: exámenes, sobrecarga, vacaciones…)",
  "perfScale.submit": "Ver mis resultados",
  "perfScale.saved": "Cuestionario guardado",
  "perfScale.needTwo": "Rellene el cuestionario al menos dos veces para ver su evolución.",
  "perfScale.lastResult": "Último resultado",
  "perfScale.allResults": "Todas las pasaciones",
  "perfScale.yourResult": "Su resultado",
  "perfScale.concerns": "Preocupaciones",
  "perfScale.disclaimer": "Herramienta de seguimiento no normada, inspirada en el modelo del excelentismo y el perfeccionismo (Gaudreau) y el FMPS (Frost). No constituye un diagnóstico; hable de ello con su terapeuta.",
  "perfScale.trend": "Evolución en el tiempo",
  "perfScale.trendHint": "Objetivo: excelentismo estable o en aumento, estándares y preocupaciones perfeccionistas en disminución.",
  "psychoed.scaleTag": "cuestionario",
  "psychoed.perfectionismAdo.title": "Perfeccionismo y excelencia (12-17 años)",
  "psychoed.perfectionismAdo.subtitle": "Apuntar alto sin presionarte: comprender el perfeccionismo y convertirte en «excelentista»",
  "psychoed.recommendedExercises": "Ejercicios recomendados",
  "psychoed.recommendedExercisesHint": "Para poner en práctica este módulo. Su terapeuta también puede asignárselos.",
  "psychoed.newTag": "específico",
  "perf.journal.title": "Diario del perfeccionismo",
  "perf.journal.desc": "Situación, estándar exigido, pensamiento «debo», comportamiento, coste, luego la versión excelentista del estándar.",
  "perf.goodEnough.title": "Experimento «suficientemente bueno»",
  "perf.goodEnough.desc": "Fije un criterio del 80 %, prediga, realice, compare: una exposición a la imperfección.",
  "perf.costBenefit.title": "Análisis coste-beneficio del perfeccionismo",
  "perf.costBenefit.desc": "Beneficios y costes a corto y largo plazo, en cuatro cuadros, luego una conclusión personal.",
  "perf.continuum.title": "Continuo de los estándares",
  "perf.continuum.desc": "Coloque sus exigencias de 0 a 100 y delimite la zona de excelencia y la zona de perfección.",
  "psychoed.perfectionism.title": "Perfeccionismo y excelentismo",
  "psychoed.perfectionism.subtitle": "Apuntar alto sin agotarse: comprender el perfeccionismo y cultivar la excelencia",
  "psychoed.perfectionism.desc": "Módulo de 10 capítulos: perfeccionismo adaptativo/desadaptativo, excelentismo (Gaudreau), círculo vicioso, distorsiones, costes-beneficios, comportamientos de seguridad, autocompasión, plan de mantenimiento.",
  "library.adoTeen": "Seguimiento TCC Adolescentes (12-17 años)",
  "library.perfectionism": "Perfeccionismo y excelentismo",
  "library.psychoedPerfectionism": "Psicoeducación sobre el perfeccionismo",
  "sessions.field.contexte_familial_scolaire": "Contexto familiar y escolar",
  "sessions.field.implication_parents": "Implicación de los padres",
  "sessions.field.developpement_motivation": "Desarrollo / motivación",
  "cr.contexte_familial_scolaire": "Contexto familiar y escolar",
  "cr.implication_parents": "Implicación de los padres",
  "cr.developpement_motivation": "Desarrollo / motivación",
  "sessions.date": "Fecha de sesión",
  "sessions.save": "Guardar",
  "sessions.update": "Actualizar",
  "sessions.edit": "Editar",
  "sessions.delete": "Eliminar",
  "sessions.created": "¡Informe creado!",
  "sessions.updated": "¡Informe actualizado!",
  "sessions.deleted": "Informe eliminado",
  "sessions.confirmDelete": "¿Realmente desea eliminar este informe?",
  "sessions.search": "Buscar...",
  "sessions.exportPdf": "Exportar en PDF",
  "sessions.pdfExported": "¡PDF exportado con éxito!",
  "sessions.selectPatientFirst": "Seleccione un paciente para gestionar los ejercicios",
  "sessions.aiSuggestions": "Sugerencias IA — haga clic para validar",
  "sessions.pendingExercises": "Ejercicios pendientes",
  "sessions.completedExercises": "Ejercicios completados",
  "sessions.exercisesToAssign": "Ejercicios a asignar con este informe",
  "sessions.browseCatalog": "Explorar el catálogo de ejercicios",
  "sessions.searchExercises": "Buscar un ejercicio...",

  // Document import
  "docImport.title": "Generar el informe por IA a partir de un documento",
  "docImport.upload": "Importar un archivo",
  "docImport.formats": "Formatos aceptados: TXT, PDF (máx. 10 MB)",
  "docImport.generate": "Generar el informe",
  "docImport.generating": "Análisis y estructuración del informe por IA...",
  "docImport.generated": "¡Informe generado con éxito!",
  "docImport.error": "Error",
  "docImport.patience": "Esto puede tardar unos segundos",
  "docImport.invalidFormat": "Formato no soportado. Formatos aceptados: TXT, PDF",
  "docImport.fileTooLarge": "El archivo excede el límite de 10 MB",

  // Session report fields
  "sessions.field.informations_generales": "Información general",
  "sessions.field.anamnese": "Anamnesis",
  "sessions.field.evaluation_dsm5": "Evaluación psicopatológica según el DSM-5",
  "sessions.field.hypothese_diagnostic_principal": "Hipótesis diagnóstico principal sospechado",
  "sessions.field.hypotheses_diagnostics_differentiels": "Hipótesis diagnósticos diferenciales a explorar",
  "sessions.field.hypothese_clinique_generale": "Hipótesis clínica general",
  "sessions.field.problematiques": "Problemáticas identificadas",
  "sessions.field.protocole_therapeutique": "Protocolo terapéutico integrado TCC 2ª y 3ª olas",
  "sessions.field.processus_cibles": "Procesos objetivo",
  "sessions.field.strategies_therapeutiques": "Estrategias terapéuticas",
  "sessions.field.evaluations_standardisees": "Evaluaciones estandarizadas a administrar",
  "sessions.field.objectifs_therapeutiques": "Objetivos terapéuticos",
  "sessions.field.recommandations_suivi": "Recomendaciones para el seguimiento",
  "sessions.field.notes_libres": "Notas libres (opcional)",
  "sessions.field.exercices": "Ejercicios",
  "sessions.field.agenda_objectifs": "Agenda / objetivos de sesión",
  "sessions.field.ameliorations_progres": "Mejoras / progresos",
  "sessions.field.revue_semaine": "Revisión de la semana / eventos clave",
  "sessions.field.humeur_symptomes": "Estado de ánimo / síntomas",
  "sessions.field.echelles_administrees": "Escalas administradas",
  "sessions.field.revue_exercices": "Revisión de ejercicios",
  "sessions.field.analyse_chaine": "Análisis en cadena",
  "sessions.field.analyse_chaine_abc": "Análisis en cadena (ABC)",
  "sessions.field.analyse_chaine_sorc": "Análisis en cadena (SORC)",
  "sessions.field.situation_pensees_emotions": "Situación - Pensamientos - Emociones - Comportamientos - Consecuencias",
  "sessions.field.pensees_automatiques": "Pensamientos automáticos / creencias",
  "sessions.field.analyse_tcc": "Análisis TCC / puntos clave",
  "sessions.field.interventions": "Intervenciones",
  "sessions.field.experiences_comportementales": "Experiencias comportamentales / exposición",
  "sessions.field.nouveaux_exercices": "Nuevos ejercicios / tareas",
  "sessions.field.objectifs_smart": "Objetivos SMART / ajuste",
  "sessions.field.plan_prochaine_seance": "Plan / próxima sesión",

  // Dashboard - Therapist
  "therapist.hello": "Hola,",
  "therapist.overview": "Aquí tiene un resumen de su actividad",
  "therapist.activePatients": "Pacientes activos",
  "therapist.totalPatients": "Total pacientes",
  "therapist.pendingExercises": "Ejercicios pendientes",
  "therapist.completedToday": "Completados hoy",
  "therapist.quickActions": "Acciones rápidas",
  "therapist.managePatients": "Gestionar pacientes",
  "therapist.exerciseLibrary": "Biblioteca de ejercicios",
  "therapist.reminders": "Recordatorios",
  "therapist.recentPatients": "Pacientes recientes",
  "therapist.viewAll": "Ver todos",
  "therapist.exerciseOverview": "Resumen de ejercicios por paciente",
  "therapist.searchPatient": "Buscar paciente...",
  "therapist.noPatientFound": "Ningun paciente encontrado",
  "therapist.showMore": "Ver mas",
  "therapist.showLess": "Ver menos",
  "therapist.exerciseReview": "Revisión de ejercicios",
  "therapist.totalEntries": "Total entradas",
  "therapist.activeTypes": "Tipos activos",
  "therapist.completed": "Completados",
  "therapist.pending": "Pendientes",
  "therapist.searchExerciseType": "Buscar tipo de ejercicio...",
  "therapist.noExercisesFound": "No se encontraron ejercicios",
  "therapist.noExerciseData": "Este paciente aún no tiene ejercicios",
  "therapist.allAssignments": "Todos los ejercicios asignados",
  "therapist.entries": "entradas",
  "therapist.types": "tipos",
  "therapist.pending": "Pendiente",
  "therapist.noPatients": "Ningún paciente por el momento",
  "therapist.addFirstPatient": "Añadir su primer paciente",

  // Dashboard - Patient
  "patient.hello": "Hola,",
  "patient.howAreYou": "¿Cómo se siente hoy?",
  "patient.consecutiveDays": "Días consecutivos",
  "patient.moodEntries": "Registros de ánimo",
  "patient.completedExercises": "Ejercicios completados",
  "patient.pendingExercises": "Ejercicios pendientes",
  "patient.moodEvolution": "Evolución de su estado de ánimo",
  "patient.recentEmotions": "Emociones recientes:",
  "patient.yourProgress": "Su progreso",
  "patient.exercisesCompleted": "Ejercicios completados",
  "patient.completedOf": "Ha completado {completed} ejercicios de {total} asignados.",
  "patient.toDo": "Por hacer",
  "patient.allDone": "¡Todo al día!",
  "patient.yourExercises": "Sus ejercicios",
  "patient.noExercisesAssigned": "Aún no se le ha asignado ningún ejercicio. Su terapeuta se los asignará próximamente.",
  "patient.startExercise": "Comenzar",
  "patient.exerciseProgress": "Progreso por ejercicio",
  "patient.assigned": "Asignados",
  "patient.completed": "Completados",
  "patient.standalone": "Entradas libres",
  "patient.noProgress": "Comience sus ejercicios para ver su progreso aquí.",

  // Exercise names
  "exercise.mood": "Seguimiento del ánimo",
  "exercise.mood.desc": "Registre su estado emocional",
  "exercise.emotion_register": "Emociones",
  "exercise.emotion_register.desc": "Regulación emocional mediante cuestionamiento socrático",
  "exercise.gratitude": "Gratitud",
  "exercise.gratitude.desc": "Cultive el agradecimiento",
  "exercise.pomodoro": "Pomodoro",
  "exercise.pomodoro.desc": "Manténgase concentrado y productivo",
  "exercise.meditation": "Meditación",
  "exercise.meditation.desc": "Practique la atención plena",
  "exercise.cognitive_defusion": "Defusión cognitiva",
  "exercise.cognitive_defusion.desc": "Distánciese de sus pensamientos",
  "exercise.self_compassion": "Autocompasión",
  "exercise.self_compassion.desc": "Sea amable consigo mismo",
  "exercise.behavioral_activation": "Activación",
  "exercise.behavioral_activation.desc": "Planifique actividades positivas",
  "exercise.values_exploration": "Valores (ACT)",
  "exercise.values_exploration.desc": "Explore sus valores fundamentales",
  "exercise.needs_exploration": "Necesidades (Maslow)",
  "exercise.needs_exploration.desc": "Identifique sus necesidades esenciales",
  "exercise.problem_solving": "Resolución",
  "exercise.problem_solving.desc": "Resuelva sus dificultades",
  "exercise.qualities_exploration": "Cualidades",
  "exercise.qualities_exploration.desc": "Refuerce su autoestima",
  "exercise.capabilities_exploration": "Capacidades",
  "exercise.capabilities_exploration.desc": "Desarrolle su confianza",
  "exercise.assertiveness": "Asertividad",
  "exercise.assertiveness.desc": "Mejore su comunicación",
  "exercise.self_reinforcement": "Autorrefuerzo",
  "exercise.self_reinforcement.desc": "Celebre sus logros",

  // Profile
  "profile.title": "Mi Perfil",
  "profile.subtitle": "Gestione su información personal",
  "profile.accountInfo": "Información de la cuenta",
  "profile.accountDesc": "Su rol y correo electrónico",
  "profile.editProfile": "Editar perfil",
  "profile.setPassword": "Establecer una contraseña",
  "profile.changePassword": "Cambiar contraseña",
  "profile.setPasswordDesc": "Establezca una contraseña para conectarse con su correo además de Google",
  "profile.changePasswordDesc": "Cambie su contraseña actual",
  "profile.googleNotice": "Se registró con Google. Establezca una contraseña para también poder conectarse con correo y contraseña.",
  "profile.newPassword": "Nueva contraseña",
  "profile.confirmPassword": "Confirmar contraseña",
  "profile.passwordSet": "¡Contraseña establecida!",
  "profile.passwordChanged": "¡Contraseña cambiada!",
  "profile.profileUpdated": "¡Perfil actualizado!",
  "profile.role": "Rol",
  "profile.appearance": "Apariencia",
  "profile.language": "Idioma",
  "profile.darkMode": "Modo oscuro",
  "profile.lightMode": "Modo claro",
  "profile.autoMode": "Auto (sistema)",
  "profile.french": "Français",
  "profile.english": "English",
  "profile.spanish": "Español",

  // Landing
  "landing.hero": "Su espacio de terapia cognitivo-conductual",
  "landing.heroSub": "Ejercicios TCC guiados, seguimiento personalizado y acompañamiento adaptado a su recorrido terapéutico.",
  "landing.getStarted": "Comenzar",
  "landing.learnMore": "Más información",
  "landing.heroTitle": "Ejercicios TCC para sus pacientes",
  "landing.heroDesc": "Una plataforma completa para terapeutas que practican Terapias Cognitivo-Conductuales. Comparta ejercicios personalizados con sus pacientes y siga su progreso.",
  "landing.tryFree": "Probar gratis",
  "landing.assignExercises": "Asigne ejercicios a sus pacientes",
  "landing.trackProgress": "Siga su progreso",
  "landing.evidenceBased": "Herramientas TCC basadas en evidencia",
  "landing.secureConfidential": "Seguro y confidencial",
  "landing.moodTracking": "Seguimiento emocional",
  "landing.exerciseCount": "16 ejercicios TCC",
  "landing.completeTools": "Herramientas terapéuticas completas",
  "landing.completeToolsDesc": "Una biblioteca de ejercicios basados en terapias cognitivo-conductuales, ACT y atención plena.",
  "landing.cta": "Cree su cuenta de terapeuta",
  "landing.ctaDesc": "Comience su prueba gratuita de 14 días. Sin tarjeta de crédito.",
  "landing.ctaButton": "Comenzar gratis",
  "landing.howItWorks": "¿Cómo funciona?",
  "landing.step1Title": "Cree su cuenta de terapeuta",
  "landing.step1Desc": "Regístrese como terapeuta para acceder a todas las herramientas.",
  "landing.step2Title": "Añada sus pacientes",
  "landing.step2Desc": "Invite a sus pacientes y active su cuenta para darles acceso.",
  "landing.step3Title": "Asigne ejercicios",
  "landing.step3Desc": "Elija de nuestra biblioteca de ejercicios TCC y personalícelos.",
  "landing.step4Title": "Siga el progreso",
  "landing.step4Desc": "Consulte las respuestas de sus pacientes y su evolución.",
  "landing.readyToStart": "¿Listo para comenzar?",
  "landing.readyDesc": "Únase a los terapeutas que ya usan Kintsugi TCC para acompañar a sus pacientes.",
  "landing.createFreeAccount": "Crear una cuenta gratuita",
  "landing.footer": "© 2026 Kintsugi TCC — VMLH-TCC EURL. Todos los derechos reservados.",
  "landing.privacy": "Política de privacidad",
  "landing.features": "Funcionalidades",
  "landing.pricing": "Precios",
  "landing.soloTitle": "¿No tiene un terapeuta que le acompañe?",
  "landing.soloDesc": "Acceda de forma autónoma a todos los ejercicios TCC y al programa Barkley TDAH. Sin compromiso, cancele cuando quiera.",
  "landing.soloPrice": "9€/mes",
  "landing.soloCTA": "Registrarme de forma autónoma",
  "landing.soloFeature1": "16+ ejercicios TCC guiados",
  "landing.soloFeature2": "Programa Barkley TDAH completo",
  "landing.soloFeature3": "Seguimiento del ánimo y progreso",
  "landing.soloFeature4": "Psicoeducación interactiva",
  "landing.soloWarning": "Aunque los ejercicios son accesibles de forma autónoma, se recomienda encarecidamente el acompañamiento de un profesional formado en TCC para un seguimiento óptimo y personalizado. El uso de estas herramientas por sí solo no sustituye la atención terapéutica profesional.",

  // Charter
  "charter.acceptLabel": "He leído y acepto la",
  "charter.linkLabel": "Carta del Secreto Profesional",
  "charter.acceptSuffix": " y me comprometo a respetar la confidencialidad de los datos de mis pacientes.",
  "charter.badgeTooltip": "Carta del secreto profesional aceptada",
  "charter.myTherapist": "Mi terapeuta",
  "charter.bannerText": "Por favor, acepte la Carta del Secreto Profesional para mostrar la insignia de confianza a sus pacientes.",
  "charter.acceptBtn": "Aceptar la carta",
  "charter.readCharter": "Leer la carta completa",

  // Owner invitation & Referral
  "owner.inviteTitle": "Invitar a un(a) colega",
  "owner.inviteDesc": "Cree un enlace de invitación para un colega terapeuta. Esta persona tendrá acceso gratuito sin suscripción. Cada terapeuta gestiona sus propios pacientes de forma independiente y confidencial.",
  "owner.colleagueName": "Nombre del colega",
  "owner.createInvite": "Crear invitación",
  "owner.inviteCopied": "Enlace de invitación copiado!",
  "owner.invitationsList": "Invitaciones enviadas",
  "owner.used": "Utilizada",
  "owner.copyLink": "Copiar",
  "referral.title": "Programa de referidos",
  "referral.desc": "Refiera a colegas y gane 1 mes gratis por cada 10 terapeutas referidos que se suscriban (mensual o anual con compromiso).",
  "referral.copyLink": "Copiar enlace",
  "referral.copied": "Enlace de referido copiado!",
  "referral.totalReferred": "Referidos",
  "referral.paying": "Suscriptores",
  "referral.freeMonths": "Meses gratis",
  "referral.progress": "Próximo bonus",
  "auth.ownerInvite": "Invitación de colega",
  "auth.ownerInviteNote": "Ha sido invitado(a) por el propietario de la plataforma. Su acceso será gratuito.",

  // Kintsugi & TCC section
  "landing.kintsugi.sectionTitle": "¿Por qué Kintsugi?",
  "landing.kintsugi.subtitle": "El arte de reconstruirse, elevado por la terapia",
  "landing.kintsugi.paragraph1": "El Kintsugi es un arte japonés ancestral que consiste en reparar cerámicas rotas resaltando las grietas con oro. Lejos de ocultar las heridas, esta filosofía las transforma en algo más bello y más valioso que antes.",
  "landing.kintsugi.paragraph2": "Este es exactamente el enfoque de la Terapia Cognitivo Conductual. La TCC no busca borrar sus dificultades, sino ayudarle a comprenderlas, a superarlas y a salir más fuerte. Cada grieta reparada se convierte en una línea de oro — la prueba de su resiliencia.",
  "landing.kintsugi.value1Title": "Aceptar las grietas",
  "landing.kintsugi.value1Desc": "Como el Kintsugi, la TCC comienza por reconocer el sufrimiento sin negarlo ni minimizarlo.",
  "landing.kintsugi.value2Title": "Reparar con cuidado",
  "landing.kintsugi.value2Desc": "Ejercicios estructurados y validados científicamente para reconstruir los patrones de pensamiento, paso a paso.",
  "landing.kintsugi.value3Title": "Revelar su fuerza",
  "landing.kintsugi.value3Desc": "El resultado no es un regreso al estado original, sino una versión más fuerte, más consciente y más resiliente de uno mismo.",

  // Exercise pages common
  "exercise.newEntry": "Nueva entrada",
  "exercise.history": "Historial",
  "exercise.previousEntries": "Entradas anteriores",
  "exercise.previousExercises": "Ejercicios anteriores",
  "exercise.previousExplorations": "Exploraciones anteriores",
  "exercise.noEntries": "Ninguna entrada por el momento",
  "exercise.save": "Guardar",
  "exercise.saving": "Guardando...",
  "exercise.saved": "¡Guardado!",
  "exercise.completed": "Completado",
  "exercise.pending": "Pendiente",
  "exercise.responses": "Respuesta(s)",
  "exercise.noResponse": "Ninguna respuesta enviada",
  "exercise.entries": "entrada(s)",
  "exercise.downloadPDF": "Descargar PDF",
  "exercise.reflection": "Reflexión (opcional)",
  "exercise.delete": "Eliminar",
  "exercise.deleted": "Entrada eliminada",
  "reinforcement.saved": "¡Logro registrado!",
  "psychoeducation.previous": "Anterior",
  "psychoeducation.next": "Siguiente",

  // Mood tracker
  "mood.title": "Seguimiento del ánimo",
  "mood.subtitle": "Registre su estado emocional diario",
  "mood.howFeel": "¿Cómo se siente?",
  "mood.veryBad": "Muy mal",
  "mood.veryGood": "Muy bien",
  "mood.whatEmotions": "¿Qué emociones siente?",
  "mood.otherEmotion": "Otra emoción o sentimiento...",
  "mood.notes": "Notas (opcional)",
  "mood.notesPlaceholder": "¿Cómo fue su día?",
  "mood.record": "Registrar mi estado de ánimo",
  "mood.recording": "Registrando...",
  "mood.recorded": "¡Estado de ánimo registrado!",
  "mood.selectEmotion": "Seleccione al menos una emoción",
  "mood.errorRecording": "Error al registrar",
  "mood.startTracking": "Comience a seguir su estado de ánimo",
  "mood.veryBadLabel": "Muy mal",
  "mood.notGood": "No bien",
  "mood.okay": "Regular",
  "mood.good": "Bien",
  "mood.veryGoodLabel": "Muy bien",

  // Emotion labels
  "emotion.happy": "Feliz",
  "emotion.calm": "Tranquilo/a",
  "emotion.anxious": "Ansioso/a",
  "emotion.sad": "Triste",
  "emotion.angry": "Enfadado/a",
  "emotion.stressed": "Estresado/a",
  "emotion.hopeful": "Esperanzado/a",
  "emotion.tired": "Cansado/a",
  "emotion.grateful": "Agradecido/a",
  "emotion.frustrated": "Frustrado/a",
  "emotion.peaceful": "En paz",
  "emotion.motivated": "Motivado/a",
  "emotion.joy": "Alegría",
  "emotion.sadness": "Tristeza",
  "emotion.anger": "Ira",
  "emotion.fear": "Miedo",
  "emotion.disgust": "Asco",
  "emotion.surprise": "Sorpresa",
  "emotion.ashamed": "Avergonzado/a",
  "emotion.guilty": "Culpable",
  "emotion.scared": "Asustado/a",
  "emotion.hopeless": "Desesperado/a",
  "emotion.irritated": "Irritado/a",
  "emotion.worried": "Preocupado/a",

  // Thought record
  "thought.title": "Registro de emociones",
  "thought.subtitle": "Regulación emocional mediante cuestionamiento socrático",
  "thought.newRecord": "Nuevo registro",
  "thought.situation": "Situación desencadenante",
  "thought.situationPlaceholder": "Describa la situación que provocó esta emoción...",
  "thought.automaticThoughts": "Emoción sentida",
  "thought.automaticThoughtsPlaceholder": "Describa lo que siente...",
  "thought.emotions": "Tipo de emoción",
  "thought.basicEmotions": "Emociones básicas",
  "thought.commonEmotions": "Otras emociones comunes",
  "thought.customEmotion": "Otra emoción o sentimiento...",
  "thought.intensity": "Intensidad emocional",
  "thought.evidenceFor": "Pruebas a favor",
  "thought.evidenceForPlaceholder": "¿Qué pruebas apoyan este pensamiento?",
  "thought.evidenceAgainst": "Pruebas en contra",
  "thought.evidenceAgainstPlaceholder": "¿Qué pruebas contradicen este pensamiento?",
  "thought.balancedThought": "Pensamiento equilibrado",
  "thought.balancedThoughtPlaceholder": "¿Qué pensamiento más equilibrado podría adoptar?",
  "thought.newIntensity": "Nueva intensidad emocional",
  "thought.socratic.title": "Cuestionamiento socrático",
  "thought.socratic.desc": "Interrogue su emoción para determinar si es proporcional a la situación",
  "thought.socratic.q1": "¿Esta emoción es proporcional a la situación?",
  "thought.socratic.q1placeholder": "Reflexione: ¿la intensidad de su emoción corresponde a los hechos objetivos de la situación?",
  "thought.socratic.q2": "¿Qué le diría a un amigo en esta situación?",
  "thought.socratic.q2placeholder": "Imagine que un amigo cercano vive exactamente la misma situación. ¿Qué le diría?",
  "thought.socratic.q3": "¿Cuáles son los hechos objetivos vs. mis interpretaciones?",
  "thought.socratic.q3placeholder": "Separe los hechos concretos de sus suposiciones o interpretaciones personales...",
  "thought.externalize.title": "Externalización y respuesta adaptada",
  "thought.externalize.desc": "Ponga su emoción a distancia y formule una respuesta constructiva",
  "thought.externalize.letter": "Escriba a su emoción",
  "thought.externalize.letterPlaceholder": "Diríjase directamente a su emoción como si fuera una entidad separada de usted. Ej: 'Querida ansiedad, te reconozco, estás aquí porque... pero tú no eres yo y pasarás...'",
  "thought.externalize.response": "Mi respuesta adaptada",
  "thought.externalize.responsePlaceholder": "¿Cómo desea reaccionar a esta situación de manera constructiva? ¿Qué comportamiento elige adoptar?",
  "thought.reeval.desc": "Después de esta reflexión, ¿cuánto siente aún esta emoción?",
  "thought.recorded": "¡Emoción registrada!",
  "thought.errorRecording": "Error al registrar",
  "thought.yourThought": "Su emoción:",
  "thought.tipTitle": "Consejo",
  "thought.tipText": "Al escribir a su emoción, crea una distancia que permite regularla. La emoción no es usted — es una reacción temporal.",
  "thought.afterReflection": "Después de esta reflexión, ¿cuánto siente aún estas emociones?",
  "thought.noRecords": "Ningún registro",
  "thought.evidenceForTitle": "Pruebas a favor de este pensamiento",
  "thought.evidenceAgainstTitle": "Pruebas en contra de este pensamiento",
  "thought.evidenceForPrompt": "¿Qué hechos apoyan este pensamiento?",
  "thought.evidenceAgainstPrompt": "¿Qué hechos contradicen este pensamiento?",
  "thought.balancedThoughtPrompt": "Formule un pensamiento más matizado y realista...",

  // Gratitude
  "gratitude.title": "Diario de gratitud",
  "gratitude.subtitle": "Cultive el agradecimiento para mejorar su bienestar",
  "gratitude.item": "Gratitud",
  "gratitude.itemPlaceholder": "Algo por lo que está agradecido/a...",
  "gratitude.todayGrateful": "Hoy estoy agradecido/a por...",
  "gratitude.addGratitude": "Añadir una gratitud",
  "gratitude.reflectionLabel": "Reflexión (opcional)",
  "gratitude.reflectionPlaceholder": "¿Qué me enseñan estas gratitudes sobre mi vida?",
  "gratitude.saveGratitudes": "Guardar mis gratitudes",
  "gratitude.pastGratitudes": "Mis gratitudes pasadas",
  "gratitude.errorSaving": "Error al guardar",
  "gratitude.saved": "¡Gratitudes guardadas!",
  "gratitude.addAtLeastOne": "Añada al menos una gratitud",
  "gratitude.startNoting": "Comience a anotar sus gratitudes",

  // Behavioral activation
  "activation.title": "Activación Comportamental",
  "activation.subtitle": "Planifique actividades positivas",
  "activation.activity": "Actividad",
  "activation.category": "Categoría",
  "activation.timeOfDay": "Momento del día",
  "activation.plannedFor": "Planificado para",
  "activation.enjoyment": "Placer esperado",
  "activation.mastery": "Dominio esperado",
  "activation.noActivities": "Ninguna actividad para este día",
  "activation.addActivity": "Añadir una actividad",
  "activation.pageTitle": "Activación comportamental",
  "activation.daysPlanned": "días planificados",
  "activation.saved": "¡Día registrado!",
  "activation.saveDay": "Guardar el día",
  "activation.pageSubtitle": "Planifique actividades positivas para mejorar su ánimo",
  "activation.completedCount": "completadas",
  "activation.addImproveHint": "Añada actividades para mejorar su ánimo",
  "activation.social": "Social",
  "activation.physical": "Físico",
  "activation.creative": "Creativo",
  "activation.wellbeing": "Bienestar",
  "activation.productive": "Productivo",
  "activation.relaxation": "Relajación",
  "activation.morning": "Mañana",
  "activation.afternoon": "Tarde",
  "activation.evening": "Noche",
  "activation.activityPlaceholder": "Ej: Caminar 20 minutos",

  // Meditation
  "meditation.title": "Meditación guiada",
  "meditation.subtitle": "Prácticas de atención plena para su bienestar",
  "meditation.sessionsCompleted": "sesiones completadas",
  "meditation.completed": "¡Sesión de meditación registrada!",
  "meditation.tips": "Consejos para meditar",
  "meditation.tip1": "Cree un espacio tranquilo",
  "meditation.startSession": "Comenzar la sesión",
  "meditation.sessions": "Sesiones anteriores",
  "meditation.breathing": "Respiración consciente",
  "meditation.breathingDesc": "Ejercicio básico para calmar la mente",
  "meditation.bodyScan": "Escaneo corporal",
  "meditation.bodyScanDesc": "Tome conciencia de cada parte de su cuerpo",
  "meditation.gratitudeMed": "Meditación de gratitud",
  "meditation.gratitudeMedDesc": "Cultive un sentimiento de agradecimiento",
  "meditation.innerCalm": "Calma interior",
  "meditation.innerCalmDesc": "Encuentre la paz y la serenidad",
  "meditation.sleepPrep": "Preparación para dormir",
  "meditation.sleepPrepDesc": "Relajación profunda antes de dormir",
  "meditation.minutes": "minutos",
  "meditation.backToMeditations": "Volver a las meditaciones",
  "meditation.tipFindTime": "Encuentre el momento adecuado",
  "meditation.tipFindTimeDesc": "Por la mañana al despertar o por la noche antes de dormir son momentos ideales.",
  "meditation.tipCreateSpace": "Cree un espacio tranquilo",
  "meditation.tipCreateSpaceDesc": "Elija un lugar tranquilo donde no le molesten.",
  "meditation.tipBePatient": "Sea paciente",
  "meditation.tipBePatientDesc": "La meditación mejora con la práctica. Comience con 5 minutos.",

  // Cognitive defusion
  "defusion.title": "Defusión cognitiva",
  "defusion.sessionsCompleted": "ejercicios completados",
  "defusion.completed": "¡Ejercicio de defusión registrado!",
  "defusion.subtitle": "Distánciese de sus pensamientos negativos",
  "defusion.yourThought": "Su pensamiento:",
  "defusion.followSteps": "Siga estos pasos:",
  "defusion.pageSubtitle": "Técnicas ACT para distanciarse de sus pensamientos",
  "defusion.writeThought": "Escriba un pensamiento que le preocupa",
  "defusion.thoughtPlaceholder": "Ej: No soy lo suficientemente bueno/a...",
  "defusion.startExercise": "Comenzar el ejercicio",
  "defusion.backToExercises": "Volver a los ejercicios",
  "defusion.leaves": "Hojas en un arroyo",
  "defusion.leavesDesc": "Visualice sus pensamientos como hojas flotando en el agua",
  "defusion.silly": "Voz cómica",
  "defusion.sillyDesc": "Repita el pensamiento con una voz graciosa para reducir su impacto",
  "defusion.prefix": "'Tengo el pensamiento de que...'",
  "defusion.prefixDesc": "Añada un prefijo para crear distancia con sus pensamientos",
  "defusion.clouds": "Nubes en el cielo",
  "defusion.cloudsDesc": "Sus pensamientos son nubes que pasan por el cielo de su mente",
  "defusion.thankMind": "Gracias, mente",
  "defusion.thankMindDesc": "Agradezca a su mente por sus pensamientos, luego vuelva a centrarse",

  // Self-compassion
  "compassion.title": "Autocompasión",
  "compassion.sessionsCompleted": "ejercicios completados",
  "compassion.completed": "¡Ejercicio de autocompasión registrado!",
  "compassion.subtitle": "Desarrolle la amabilidad hacia usted mismo/a",
  "compassion.pageSubtitle": "Aprenda a ser amable consigo mismo/a",
  "compassion.letter": "Carta de compasión",
  "compassion.letterDesc": "Escríbase una carta como lo haría para un amigo querido",
  "compassion.touch": "Auto-alivio físico",
  "compassion.touchDesc": "Use el tacto para reconfortarse",
  "compassion.phrases": "Frases de amabilidad",
  "compassion.phrasesDesc": "Repita frases de compasión para usted mismo/a",
  "compassion.finishExercise": "Terminar el ejercicio",
  "compassion.nextStep": "Siguiente paso",
  "compassion.repeatInstruction": "Repita cada frase 3 veces, lenta y conscientemente. Haga clic en cada frase una vez que la haya repetido.",
  "compassion.writeHere": "Escriba aquí...",
  "compassion.backToExercises": "Volver a los ejercicios",

  // Assertiveness
  "assertiveness.title": "Asertividad",
  "assertiveness.subtitle": "Mejore su comunicación asertiva",
  "assertiveness.descMethod": "El método DESC",
  "assertiveness.fullResponse": "Su respuesta DESC completa:",
  "assertiveness.situationLabel": "Describa una situación donde tuvo dificultad para afirmarse",
  "assertiveness.situationPlaceholder": "Ejemplo: Durante una reunión de trabajo, mi colega me interrumpió varias veces...",
  "assertiveness.emotionsLabel": "¿Qué emociones sintió?",
  "assertiveness.emotionsPlaceholder": "Frustración, ira, vergüenza, ansiedad...",
  "assertiveness.styleQuestion": "¿Qué estilo de comunicación adoptó en esta situación?",
  "assertiveness.passive": "Pasivo",
  "assertiveness.aggressive": "Agresivo",
  "assertiveness.passiveAggressive": "Pasivo-agresivo",
  "assertiveness.assertive": "Asertivo",
  "assertiveness.descTechnique": "Una técnica estructurada para expresarse de manera asertiva.",
  "assertiveness.describe": "Describir",
  "assertiveness.describeDetail": "Describa los hechos objetivamente",
  "assertiveness.express": "Expresar",
  "assertiveness.expressDetail": "Exprese sus emociones con 'Yo'",
  "assertiveness.specify": "Especificar",
  "assertiveness.specifyDetail": "Especifique lo que desea",
  "assertiveness.consequences": "Consecuencias",
  "assertiveness.consequencesDetail": "Indique las consecuencias positivas",
  "assertiveness.reformulate": "Reformule con sus propias palabras",
  "assertiveness.reformulatePlaceholder": "Escriba cómo formularía su mensaje asertivo...",
  "assertiveness.reflectionLabel": "Reflexión: ¿Cómo se siente después de este ejercicio?",
  "assertiveness.reflectionPlaceholder": "¿Qué ha aprendido? ¿Se siente más seguro/a para usar esta técnica?",
  "assertiveness.saved": "¡Ejercicio de asertividad registrado!",
  "assertiveness.steps.situation": "La Situación",
  "assertiveness.steps.style": "Estilo Actual",
  "assertiveness.steps.desc": "Método DESC",
  "assertiveness.steps.practice": "Puesta en Práctica",

  // Self-reinforcement
  "reinforcement.title": "Autorrefuerzo",
  "reinforcement.subtitle": "Celebre sus logros y recompénsese",
  "reinforcement.newAccomplishment": "Nuevo logro",
  "reinforcement.whatAccomplished": "¿Qué ha logrado hoy?",
  "reinforcement.accomplishmentPlaceholder": "Describa lo que ha conseguido, incluso las pequeñas cosas...",
  "reinforcement.difficulty": "Nivel de dificultad",
  "reinforcement.easy": "Fácil",
  "reinforcement.medium": "Medio",
  "reinforcement.hard": "Difícil",
  "reinforcement.emotionsFelt": "¿Qué emociones siente?",
  "reinforcement.emotionsPlaceholder": "Ej: orgullo, satisfacción, alivio...",
  "reinforcement.chooseReward": "Elija una recompensa",
  "reinforcement.customReward": "O escriba su propia recompensa...",
  "reinforcement.celebrate": "Celebrar este logro",
  "reinforcement.myAccomplishments": "Mis logros",
  "reinforcement.noAccomplishments": "Ningún logro registrado",
  "reinforcement.startCelebrating": "Comience a celebrar sus éxitos",

  // Values exploration
  "values.title": "Exploración de valores",
  "values.subtitle": "Identifique y explore sus valores fundamentales",
  "values.pageSubtitle": "Descubra lo que realmente importa para usted (ACT - Steven C. Hayes)",
  "values.domainOf": "Dominio {current} de {total}",
  "values.whatImportant": "¿Qué es importante para usted en este ámbito?",
  "values.importancePlaceholder": "Describa lo que realmente importa para usted...",
  "values.howToAct": "¿Cómo le gustaría actuar de acuerdo con este valor?",
  "values.actionsPlaceholder": "¿Qué acciones concretas reflejarían este valor?",
  "values.ratingQuestion": "En una escala del 1 al 10, ¿cuánto vive actualmente según este valor?",
  "values.saved": "¡Exploración de valores registrada!",
  "values.domainsExplored": "dominios explorados",

  // Needs exploration
  "needs.title": "Exploración de necesidades",
  "needs.subtitle": "Identifique sus necesidades esenciales según Maslow",
  "needs.reflectionQuestions": "Preguntas de reflexión:",
  "needs.pageSubtitle": "Pirámide de Maslow - Identifique sus necesidades fundamentales",
  "needs.howSatisfied": "¿En qué medida está satisfecha esta necesidad?",
  "needs.notSatisfied": "Nada satisfecho",
  "needs.fullySatisfied": "Plenamente satisfecho",
  "needs.yourReflections": "Sus reflexiones sobre esta necesidad",
  "needs.reflectionsPlaceholder": "¿Qué falta? ¿Qué funciona bien?",
  "needs.saveExploration": "Guardar la exploración",
  "needs.saved": "¡Exploración de necesidades registrada!",
  "needs.physiological": "Necesidades Fisiológicas",
  "needs.safety": "Necesidades de Seguridad",
  "needs.belonging": "Necesidades de Pertenencia",
  "needs.esteem": "Necesidades de Estima",
  "needs.selfActualization": "Necesidades de Autorrealización",

  // Problem solving
  "problem.title": "Resolución de problemas",
  "problem.subtitle": "Resuelva sus dificultades paso a paso",
  "problem.pageSubtitle": "Un enfoque estructurado para superar las dificultades",
  "problem.step.problem": "Definir el Problema",
  "problem.step.problemDesc": "Describa claramente el problema a resolver",
  "problem.step.goals": "Objetivos",
  "problem.step.goalsDesc": "¿Qué desea lograr?",
  "problem.step.solutions": "Generar Soluciones",
  "problem.step.solutionsDesc": "Lluvia de ideas sin juicio",
  "problem.step.evaluate": "Evaluar Soluciones",
  "problem.step.evaluateDesc": "Sopesar pros y contras",
  "problem.step.plan": "Plan de Acción",
  "problem.step.planDesc": "Pasos concretos a seguir",
  "problem.whatProblem": "¿Cuál es el problema que enfrenta?",
  "problem.problemPlaceholder": "Describa el problema de manera clara y específica...",
  "problem.problemTip": "Sea preciso. En lugar de 'Estoy estresado', intente 'Me siento abrumado por la carga de trabajo en la oficina esta semana'.",
  "problem.whatGoal": "¿Qué desea lograr?",
  "problem.goalPlaceholder": "Describa su objetivo ideal...",
  "problem.smartTip": "Específico, Medible, Alcanzable, Realista, Temporal.",
  "problem.generateSolutions": "Genere tantas soluciones como sea posible, incluso las más locas. ¡No juzgue aún!",
  "problem.solution": "Solución",
  "problem.solutionPlaceholder": "Describa la solución...",
  "problem.addSolution": "Añadir una solución",
  "problem.evaluateIntro": "Evalúe cada solución listando ventajas e inconvenientes.",
  "problem.pros": "Ventajas (+)",
  "problem.prosPlaceholder": "Puntos positivos...",
  "problem.cons": "Inconvenientes (-)",
  "problem.consPlaceholder": "Puntos negativos...",
  "problem.chosenSolution": "Solución elegida:",
  "problem.none": "Ninguna",
  "problem.actionSteps": "Pasos de acción:",
  "problem.stepPlaceholder": "Describa el paso...",
  "problem.addStep": "Añadir un paso",
  "problem.saved": "¡Resolución de problema registrada!",

  // Qualities exploration
  "qualities.title": "Exploración de cualidades",
  "qualities.subtitle": "Refuerce su autoestima",
  "qualities.pageSubtitle": "Refuerce su autoestima reconociendo sus fortalezas",
  "qualities.suggestions": "Sugerencias de cualidades",
  "qualities.myQualities": "Mis Cualidades",
  "qualities.quality": "Cualidad",
  "qualities.qualityPlaceholder": "Nombre una cualidad que posee...",
  "qualities.examplePlaceholder": "Dé un ejemplo concreto donde demostró esta cualidad...",
  "qualities.sourcePlaceholder": "¿Quién le reconoció esta cualidad? (amigo, familia, colega...)",
  "qualities.addQuality": "Añadir una cualidad",
  "qualities.reflection": "Reflexión",
  "qualities.reflectionPlaceholder": "¿Cómo se siente después de listar estas cualidades? ¿Qué ha aprendido sobre usted mismo/a?",
  "qualities.saveQualities": "Guardar mis cualidades",
  "qualities.saved": "¡Exploración de cualidades registrada!",
  "qualities.addAtLeastOne": "Añada al menos una cualidad",
  "qualities.interpersonal": "Cualidades Relacionales",
  "qualities.intellectual": "Cualidades Intelectuales",
  "qualities.emotional": "Cualidades Emocionales",
  "qualities.moral": "Cualidades Morales",
  "qualities.practical": "Cualidades Prácticas",

  // Capabilities exploration
  "capabilities.title": "Exploración de Capacidades",
  "capabilities.subtitle": "Desarrolle su confianza reconociendo lo que sabe hacer",
  "capabilities.competenceAreas": "Áreas de competencia",
  "capabilities.pageSubtitle": "Desarrolle su confianza reconociendo lo que sabe hacer",
  "capabilities.myCapabilities": "Mis Capacidades",
  "capabilities.capability": "Capacidad",
  "capabilities.capabilityPlaceholder": "Nombre una capacidad o competencia...",
  "capabilities.currentLevel": "Nivel actual",
  "capabilities.learning": "En aprendizaje",
  "capabilities.competent": "Competente",
  "capabilities.proficient": "Dominado",
  "capabilities.expert": "Experto",
  "capabilities.evidencePlaceholder": "Prueba: describa una situación donde usó esta capacidad con éxito...",
  "capabilities.goalPlaceholder": "Objetivo de desarrollo (opcional): ¿cómo mejorar esta capacidad?",
  "capabilities.addCapability": "Añadir una capacidad",
  "capabilities.saveCapabilities": "Guardar mis capacidades",
  "capabilities.saved": "¡Exploración de capacidades registrada!",
  "capabilities.addAtLeastOne": "Añada al menos una capacidad",
  "capabilities.professional": "Competencias Profesionales",
  "capabilities.social": "Competencias Sociales",
  "capabilities.personal": "Competencias Personales",
  "capabilities.creative": "Competencias Creativas",
  "capabilities.physicalSkills": "Competencias Físicas",

  // Patient exercises view
  "patientExercises.assigned": "Ejercicios asignados",
  "patientExercises.standalone": "Ejercicios autónomos",
  "patientExercises.myExercises": "Mis ejercicios",
  "patientExercises.downloadPdf": "Descargar PDF",
  "psychoeducation.downloadPdf": "Descargar en PDF",
  "psychoeducation.downloadPdfHint": "Descargar este módulo en PDF (capítulos, ilustraciones, cuestionario y respuestas)",
  "psychoeducation.pdfError": "PDF no disponible",
  "patientExercises.paperVersion": "Versión papel",
  "patientExercises.paperVersionHint": "Descargar la ficha imprimible (PDF) para hacer este ejercicio en papel",
  "patientExercises.paperVersionError": "Ficha en papel no disponible por el momento",
  "patientExercises.entries": "entrada(s)",
  "patientExercises.responses": "Respuesta(s)",
  "patientExercises.noResponse": "Ninguna respuesta enviada",
  "patientExercises.noExercises": "Ningún ejercicio registrado",
  "patientExercises.completed": "Completado",
  "patientExercises.pending": "Pendiente",
  "patientExercises.entryRecorded": "Entrada registrada",

  // Patient management
  "patientMgmt.title": "Pacientes",
  "patientMgmt.subtitle": "Gestione sus pacientes y sus accesos",
  "patientMgmt.addNew": "Añadir un nuevo paciente",
  "patientMgmt.active": "Activo",
  "patientMgmt.inactive": "Inactivo",
  "patientMgmt.activate": "Activar",
  "patientMgmt.deactivate": "Desactivar",
  "patientMgmt.viewProgress": "Ver el progreso",
  "patientMgmt.viewExercises": "Ver los ejercicios",
  "patientMgmt.patientAdded": "¡Paciente añadido con éxito!",
  "patientMgmt.errorAdding": "Error al añadir",
  "patientMgmt.addPatient": "Añadir el paciente",
  "patientMgmt.addNewPatient": "Añadir un nuevo paciente",
  "patientMgmt.fullName": "Nombre completo",
  "patientMgmt.immediateAccess": "El paciente recibirá acceso inmediato a la plataforma.",
  "patientMgmt.patientList": "Lista de pacientes",
  "patientMgmt.newEmail": "Nuevo correo",
  "patientMgmt.emailUpdated": "¡Correo actualizado con éxito!",
  "patientMgmt.errorUpdating": "Error al actualizar",
  "patientMgmt.searchPatient": "Buscar un paciente...",
  "patientMgmt.noPatientFound": "Ningún paciente encontrado",
  "patientMgmt.activated": "Paciente activado",
  "patientMgmt.deactivated": "Paciente desactivado",
  "patientMgmt.tracking": "Seguimiento",
  "patientMgmt.pendingPatients": "Pacientes pendientes",
  "patientMgmt.pendingPatientsDesc": "Estos pacientes se registraron pero no están vinculados a ningún terapeuta.",
  "patientMgmt.claimPatient": "Vincular",
  "patientMgmt.patientClaimed": "Paciente vinculado con éxito",
  "patientMgmt.errorClaiming": "Error al vincular",
  "patientMgmt.unnamed": "Sin nombre",
  "patientMgmt.invitationCode": "Código de invitación",
  "patientMgmt.invitationCodeDesc": "Comparta este enlace con sus pacientes para que puedan registrarse.",
  "patientMgmt.copyLink": "Copiar enlace",
  "patientMgmt.linkCopied": "¡Enlace de invitación copiado!",
  "patientMgmt.qrScanDesc": "Escanee este código QR para acceder al formulario de registro.",
  "patientMgmt.downloadQR": "Descargar el código QR",
  "patientMgmt.refusePatient": "Rechazar",
  "patientMgmt.confirmRefuse": "¿Realmente desea rechazar a este paciente?",
  "patientMgmt.patientRefused": "Paciente rechazado",
  "patientMgmt.errorRefusing": "Error al rechazar",
  "patientMgmt.confirmDelete": "¿Eliminar definitivamente este paciente y todos sus datos?",
  "patientMgmt.patientDeleted": "Paciente eliminado definitivamente",
  "patientMgmt.errorDeleting": "Error al eliminar",

  // Patient progress
  "progress.title": "Progreso",
  "progress.notFound": "Paciente no encontrado",
  "progress.moodEntries": "Registros de ánimo",
  "progress.exercisesCompleted": "Ejercicios completados",
  "progress.emotionsProcessed": "Emociones procesadas",
  "progress.moodHistory": "Historial de ánimo",
  "progress.noMoodEntries": "Ningún registro de ánimo",
  "progress.thoughtRecords": "Registros de pensamientos",
  "progress.thought": "Pensamiento:",
  "progress.balancedThought": "Pensamiento equilibrado:",
  "progress.noEmotionRegisters": "Ningún registro de emociones",
  "progress.gratitudeEntries": "Entradas de gratitud",
  "progress.noGratitude": "Ninguna entrada de gratitud",
  "progress.assignedExercises": "Ejercicios asignados",
  "progress.noAssignments": "Ningún ejercicio asignado",
  "progress.averageMood": "Ánimo promedio",
  "progress.moodEvolution": "Evolución del ánimo (últimos 30 días)",
  "progress.notEnoughData": "Datos insuficientes",
  "progress.topEmotions": "Emociones más frecuentes",
  "progress.mood": "Ánimo",
  "progress.thoughts": "Pensamientos",
  "progress.gratitude": "Gratitud",
  "progress.exercises": "Ejercicios",
  "progress.moodHistoryTitle": "Historial de ánimo",
  "progress.thoughtRecordsTitle": "Registros de pensamientos",
  "progress.gratitudeJournal": "Diario de gratitud",
  "progress.assignedExercisesTitle": "Ejercicios asignados",
  "progress.situation": "Situación:",
  "progress.balancedThoughtLabel": "Pensamiento equilibrado:",
  "progress.viewExercises": "Ver ejercicios",
  "progress.reportGenerated": "Informe generado el",

  // Exercise library
  "library.title": "Biblioteca de ejercicios",
  "library.subtitle": "Explore y asigne ejercicios a sus pacientes",
  "library.customTitle": "Título personalizado (opcional)",
  "library.assign": "Asignar",
  "library.assigning": "Asignando...",
  "library.assigned": "¡Ejercicio asignado!",
  "library.currentAssignments": "Asignaciones actuales",
  "library.remove": "Retirar",
  "library.pending": "En curso",
  "library.completed": "Completado",
  "library.assignedToCount": "Asignado a {count} paciente(s)",
  "library.exerciseUnassigned": "Ejercicio retirado",
  "library.cognitive": "Cognitivo",
  "library.behavioral": "Comportamental",
  "library.monitoring": "Seguimiento",
  "library.act": "ACT",
  "library.mindfulness": "Atención plena",
  "library.positive": "Psicología positiva",
  "library.organization": "Organización",
  "library.selfAwareness": "Autoconocimiento",
  "library.barkleyParents": "Barkley — Padres",
  "library.barkleyChildren": "Barkley — Niños",
  "library.barkleyTeens": "Barkley — Adolescentes",
  "library.tdahAdulte": "TDAH Adultos",
  "library.barkleyParents": "Barkley — Padres",
  "library.barkleyChildren": "Barkley — Niños",
  "library.barkleyTeens": "Barkley — Adolescentes",
  "library.tdahAdulte": "TDAH Adulto",
  "library.selectPatient": "Seleccionar un paciente",
  "library.selectPatientError": "Por favor seleccione un paciente",
  "library.assignExercise": "Asignar un ejercicio",
  "library.assignTheExercise": "Asignar el ejercicio",
  "library.exerciseAssigned": "¡Ejercicio asignado con éxito!",
  "library.errorAssigning": "Error al asignar",
  "library.instructionsOptional": "Instrucciones (opcional)",
  "library.instructionsPlaceholder": "Instrucciones específicas para el paciente...",
  "library.titleExample": "Ej: Ejercicio de pensamiento #1",

  // Psychoeducation
  "psychoeducation.title": "Psicoeducación",
  "psychoeducation.subtitle": "Módulos teóricos",
  "psychoeducation.modules": "Módulos teóricos",
  "psychoeducation.assignModule": "Asignar un módulo",
  "psychoeducation.moduleAssigned": "Módulo asignado",
  "psychoeducation.moduleUnassigned": "Módulo retirado",
  "psychoeducation.noModulesAssigned": "Aún no se le ha asignado ningún módulo. Su terapeuta se los asignará próximamente.",
  "psychoeducation.pageSubtitle": "Comprender los fundamentos teóricos de la terapia cognitivo-conductual",
  "psychoeducation.aboutModule": "Acerca de este módulo",
  "psychoeducation.aboutModuleDesc": "La psicoeducación es una etapa esencial del recorrido terapéutico. Comprender los mecanismos de sus dificultades le da un poder de acción. Cada módulo presenta un modelo teórico fundamental, seguido de un cuestionario para evaluar su comprensión.",
  "psychoeducation.sections": "secciones",
  "psychoeducation.quiz": "Cuestionario",
  "psychoeducation.quizTitle": "Cuestionario de comprensión",
  "psychoeducation.checkAnswers": "Verificar mis respuestas",
  "psychoeducation.backToModules": "Volver a los módulos",
  "psychoeducation.correct": "correcto",
  "psychoeducation.section": "Sección",
  "psychoeducation.goToQuiz": "Ir al cuestionario",
  "psychoeducation.newerModulesTitle": "Modulos avanzados",
  "psychoeducation.classicModulesTitle": "Fundamentos teoricos",
  "psychoeducation.currentAssignments": "Pacientes asignados",
  "psychoeducation.addPatient": "Agregar un paciente",

  // Reminders
  "reminders.title": "Recordatorios",
  "reminders.subtitle": "Historial y gestión de recordatorios de ejercicios",
  "reminders.totalSent": "Recordatorios enviados (total)",
  "reminders.today": "Recordatorios hoy",
  "reminders.pendingReminders": "Pendientes de recordatorio",
  "reminders.autoReminders": "Recordatorios automáticos",
  "reminders.autoRemindersDesc": "Los recordatorios se envían automáticamente a los pacientes que no han completado sus ejercicios después de 3 días. Máximo un recordatorio por día por ejercicio.",
  "reminders.history": "Historial de recordatorios",
  "reminders.assigned": "Asignado:",
  "reminders.lastReminder": "Último recordatorio:",
  "reminders.resend": "Reenviar",
  "reminders.sentSuccess": "¡Recordatorio enviado con éxito!",
  "reminders.errorSending": "Error al enviar el recordatorio",
  "reminders.noReminders": "Ningún recordatorio enviado por el momento",
  "reminders.autoSendDesc": "Los recordatorios se enviarán automáticamente a los pacientes después de 3 días de inactividad",

  // Pomodoro
  "pomodoro.title": "Pomodoro",
  "pomodoro.subtitle": "Manténgase concentrado y productivo",
  "pomodoro.startFocus": "Iniciar una sesión de concentración",
  "pomodoro.sessions": "Sesiones anteriores",
  "pomodoro.pageSubtitle": "Técnica de productividad y concentración",
  "pomodoro.taskName": "Nombre de la tarea",
  "pomodoro.taskPlaceholder": "Ej: Revisión del curso...",
  "pomodoro.duration": "Duración (minutos)",
  "pomodoro.started": "¡Pomodoro iniciado!",
  "pomodoro.completed": "¡Pomodoro completado! Tome un descanso.",
  "pomodoro.enterTask": "Ingrese un nombre de tarea",
  "pomodoro.errorStarting": "Error al iniciar",
  "pomodoro.todayCount": "Pomodoros hoy",
  "pomodoro.recentSessions": "Sesiones recientes",
  "pomodoro.noSessions": "Ninguna sesión por el momento",

  // Subscription
  "subscription.trial": "Prueba gratuita",
  "subscription.daysLeft": "días restantes",

  // Common extras
  "common.error": "Error al guardar",
  "common.errorLoading": "Error al cargar",
  "common.continue": "Continuar",
  "common.finish": "Terminar",
  "common.start": "Iniciar",
  "common.pause": "Pausa",
  "common.resume": "Reanudar",
  "common.restart": "Reiniciar",
  "common.add": "Añadir",
  "common.refresh": "Actualizar",
  "common.search": "Buscar...",
  "common.select": "Seleccionar",
  "common.selected": "Seleccionado",
  "common.fillRequired": "Por favor complete todos los campos obligatorios",
  "common.selectAtLeastOne": "Seleccione al menos un elemento",
  "common.recentHistory": "Historial reciente",
  "common.noEntriesYet": "Ninguna entrada por el momento",
  "common.completed": "Completado",
  "common.pending": "Pendiente",
  "common.active": "Activo",
  "common.inactive": "Inactivo",
  "common.access": "Acceso",
  "common.instructions": "Instrucciones",
  "common.tip": "Consejo",
  "common.optional": "opcional",
  "common.examples": "Ejemplos",
  "common.domain": "Dominio",
  "common.of": "de",

  // AI suggestions
  "ai.title": "Sugerencias IA personalizadas",
  "ai.history": "Historial",
  "ai.description": "La IA analizará sus datos de ánimo y ejercicios recientes para sugerirle ejercicios TCC adaptados a su situación actual.",
  "ai.contextLabel": "Contexto adicional (opcional)",
  "ai.contextPlaceholder": "Describa cómo se siente hoy o una situación particular...",
  "ai.analyzing": "Analizando...",
  "ai.getSuggestions": "Obtener sugerencias",
  "ai.generated": "¡Sugerencias generadas!",
  "ai.errorGenerating": "Error al generar sugerencias",
  "ai.basedOn": "Basado en",
  "ai.entriesAnalyzed": "entradas analizadas",
  "ai.averageMood": "Ánimo promedio:",
  "ai.newSuggestions": "Nuevas sugerencias",
  "ai.noHistory": "Sin historial de sugerencias",
  "ai.avg": "Prom:",

  // MoodChart
  "chart.mood": "Ánimo:",
  "chart.notEnoughData": "Datos insuficientes para mostrar el gráfico",
  "chart.avg": "Prom:",

  // ExerciseIntro
  "exerciseIntro.objectives": "Objetivos del ejercicio",
  "exerciseIntro.understand": "Comprender el ejercicio",
  "exerciseIntro.foundation": "Fundamento:",

  // Pricing
  "pricing.alreadySubscribed": "Ya suscrito",
  "pricing.chooseAPlan": "Elija el plan que mejor se adapte a su práctica",
  "pricing.coveredByTherapist": "Cubierto por su terapeuta",
  "pricing.recommended": "Recomendado",
  "pricing.patientNote": "Los pacientes seguidos por un terapeuta con suscripción activa se benefician de acceso gratuito.",

  // ACT Psychoeducation module (Russ Harris)
  "psycho.act.title": "ACT — Terapia de Aceptación y Compromiso",
  "psycho.act.subtitle": "Basado en la obra de Russ Harris",
  "psycho.act.desc": "Módulo completo sobre la Terapia de Aceptación y Compromiso (ACT). Aprenda los 6 procesos de la flexibilidad psicológica.",

  "psycho.act.s1t": "1. ¿Qué es la ACT?",
  "psycho.act.s1c": "La ACT (Terapia de Aceptación y Compromiso) es una terapia conductual de 3ª ola desarrollada por Steven C. Hayes. A diferencia de los enfoques tradicionales que buscan reducir síntomas, la ACT no busca sentirse mejor, sino vivir mejor.\n\nLa ACT parte de una observación: el sufrimiento forma parte de la vida. No es la presencia de pensamientos o emociones difíciles lo que causa nuestros problemas, sino la forma en que los manejamos.\n\nEl objetivo de la ACT es desarrollar la flexibilidad psicológica: la capacidad de estar en contacto con el momento presente y actuar al servicio de nuestros valores.",

  "psycho.act.s2t": "2. El modelo Hexaflex: los 6 procesos",
  "psycho.act.s2c": "El ACT se organiza alrededor de 6 procesos interconectados, representados en un hexágono (Hexaflex):\n\n1. DEFUSIÓN COGNITIVA — Distanciarse de los pensamientos en lugar de creerlos literalmente. Los pensamientos son palabras e imágenes, no hechos.\n\n2. ACEPTACIÓN (Hacer espacio) — Acoger las emociones y sensaciones difíciles sin luchar contra ellas. Lo opuesto al evitamiento experiencial.\n\n3. CONTACTO CON EL MOMENTO PRESENTE — Estar plenamente atento al aquí y ahora, con apertura y curiosidad.\n\n4. EL YO OBSERVADOR (Yo como contexto) — Conectarse a esa parte de nosotros que observa sin juzgar. No somos nuestros pensamientos ni nuestras emociones — somos el contexto en el cual aparecen.\n\n5. VALORES — Clarificar lo que realmente importa para nosotros. Los valores son como una brújula que guía nuestras acciones.\n\n6. ACCIÓN COMPROMETIDA — Pasar a la acción en alineación con nuestros valores, incluso en presencia de pensamientos y emociones difíciles.",

  "psycho.act.s3t": "3. La evitación experiencial: la trampa",
  "psycho.act.s3c": "El evitamiento experiencial es el intento de suprimir, controlar o huir de las experiencias internas desagradables (pensamientos, emociones, recuerdos, sensaciones). Es el proceso central del sufrimiento psicológico según el ACT.\n\nEjemplos de evitamiento:\n• Consumir alcohol para no sentir ansiedad\n• Evitar situaciones sociales por miedo al juicio\n• Rumiar para intentar resolver un problema emocional\n• Distraerse constantemente para no pensar\n\nParadoja del control: Cuanto más luchamos contra una emoción, más se intensifica. Russ Harris utiliza la metáfora del 'monstruo en la arena movediza': cuanto más se debate, más se hunde.\n\nLa solución ACT no es combatir, sino observar y acoger estas experiencias mientras actuamos hacia lo que importa.",

  "psycho.act.s4t": "4. La Defusión cognitiva: desapegarse de los pensamientos",
  "psycho.act.s4c": "Tenemos aproximadamente 60,000 a 80,000 pensamientos por día. La fusión cognitiva es cuando tomamos nuestros pensamientos como la realidad absoluta. 'Soy inútil' se convierte en un hecho en lugar de un simple pensamiento.\n\nTécnicas de defusión (Russ Harris):\n\n• 'TENGO EL PENSAMIENTO DE QUE...' — Añada este prefijo delante de cualquier pensamiento difícil. 'Soy incompetente' se convierte en 'Tengo el pensamiento de que soy incompetente'. Esto crea una distancia instantánea.\n\n• HOJAS EN UN ARROYO — Visualice cada pensamiento como una hoja que flota en un arroyo y se aleja.\n\n• VOZ CÓMICA — Repita el pensamiento con una voz de dibujos animados. Esto reduce su impacto emocional.\n\n• GRACIAS MENTE — Cuando su mente produzca un pensamiento ansiógeno, simplemente diga 'Gracias mente, es muy interesante'.\n\nLa defusión no significa que los pensamientos desaparezcan. Significa que pierden su dominio sobre nuestros comportamientos.",

  "psycho.act.s5t": "5. La Aceptación y el Contacto con el momento presente",
  "psycho.act.s5c": "La aceptación en ACT no significa resignación o tolerancia pasiva. Es una apertura activa a las experiencias internas, incluso desagradables.\n\nLA TÉCNICA DE EXPANSIÓN (Hacer espacio):\n1. Observe la sensación en su cuerpo\n2. Respire hacia esa zona\n3. Haga espacio alrededor de la sensación\n4. Permítale estar ahí, sin luchar\n\nECHAR EL ANCLA (técnica ACE):\nCuando surge una tormenta emocional:\n• A — Aceptar: 'Noto que siento ansiedad'\n• C — Conectar: Empuje sus pies contra el suelo, estírese, mire a su alrededor\n• E — Comprometerse: Elija una acción alineada con sus valores\n\nEchar el ancla no calma la tormenta — pero le impide ser arrastrado. El contacto con el momento presente se entrena con ejercicios de atención plena: notar 5 cosas que ve, 4 que toca, 3 que escucha.",

  "psycho.act.s6t": "6. Los Valores: su brújula interior",
  "psycho.act.s6c": "Los valores son las direcciones de vida que importan para usted. Son diferentes de los objetivos:\n\n• Un OBJETIVO puede ser alcanzado (correr una maratón)\n• Un VALOR es una dirección continua (cuidar la salud)\n\nRuss Harris propone explorar los valores en diferentes áreas:\n• Relaciones (familia, pareja, amistad)\n• Trabajo / estudios\n• Ocio / creatividad\n• Salud / bienestar\n• Desarrollo personal\n• Comunidad / espiritualidad\n\nPara identificar sus valores, pregúntese:\n- '¿Qué tipo de persona quiero ser?'\n- 'Si pudiera actuar sin miedo, ¿qué haría?'\n- '¿Qué defendería incluso si fuera difícil?'\n\nEL PUNTO DE ELECCIÓN es una herramienta visual: frente a una situación difícil, usted elige entre movimientos de ALEJAMIENTO (huir, evitar) o de ACERCAMIENTO (avanzar hacia sus valores).",

  "psycho.act.s7t": "7. El Yo Observador y la Matriz ACT",
  "psycho.act.s7c": "EL YO OBSERVADOR:\nImagine que usted es el cielo. Los pensamientos y emociones son como las nubes — van y vienen, a veces oscuras, a veces ligeras. Pero el cielo siempre permanece intacto detrás de las nubes.\n\nUsted no es sus pensamientos, ni sus emociones, ni su historia. Usted es el contexto en el cual todo esto aparece.\n\nLA MATRIZ ACT:\nHerramienta simple y poderosa que divide la experiencia en 4 cuadrantes:\n\n       HACIA lo que importa ↑\n  Experiencias internas ← → Comportamientos\n       LEJOS de lo que importa ↓\n\n• Arriba a la derecha: Acciones hacia mis valores\n• Arriba a la izquierda: Lo que importa (personas, valores)\n• Abajo a la izquierda: Obstáculos internos (miedos, pensamientos, emociones)\n• Abajo a la derecha: Comportamientos de evitamiento\n\nLa matriz ayuda a tomar conciencia de nuestros patrones y a tomar decisiones más alineadas con nuestros valores.",

  "psycho.act.s8t": "8. La Acción Comprometida",
  "psycho.act.s8c": "El ACT siempre desemboca en la acción. Conocer los valores sin actuar no tiene sentido. La acción comprometida es:\n\n1. IDENTIFICAR un valor importante\n2. DEFINIR un objetivo SMART alineado\n3. ENCONTRAR el paso más pequeño posible\n4. ANTICIPAR los obstáculos internos\n5. COMPROMETERSE a actuar CON las dificultades, no SIN ellas\n\nLa disposición (willingness) es crucial en ACT: ¿está usted dispuesto(a) a acoger los pensamientos y emociones difíciles para avanzar hacia lo que importa? No es valor — es una elección consciente.\n\nRuss Harris resume el ACT en una frase: 'Aceptar lo que está fuera de su control personal, y comprometerse en acciones que enriquezcan su vida.'\n\nEl ACT es un viaje, no un destino. Cada día ofrece puntos de elección. En cada punto, usted puede elegir avanzar hacia la persona que quiere ser.",

  "psycho.act.q1q": "Según la ACT, ¿cuál es el objetivo principal de la terapia?",
  "psycho.act.q1a": "Eliminar los pensamientos negativos",
  "psycho.act.q1b": "Desarrollar la flexibilidad psicológica",
  "psycho.act.q1c": "Sentirse mejor en todas las circunstancias",
  "psycho.act.q1d": "Controlar las emociones",
  "psycho.act.q1e": "El ACT no busca eliminar los pensamientos o emociones negativas, sino desarrollar la flexibilidad psicológica: la capacidad de estar presente y actuar según los valores, incluso en presencia de dificultades internas.",

  "psycho.act.q2q": "¿Qué es la evitación experiencial?",
  "psycho.act.q2a": "Evitar situaciones peligrosas",
  "psycho.act.q2b": "Ignorar los consejos del terapeuta",
  "psycho.act.q2c": "Intentar suprimir o huir de las experiencias internas desagradables",
  "psycho.act.q2d": "Rechazar tomar medicamentos",
  "psycho.act.q2e": "La evitación experiencial es el intento de controlar o huir de nuestras experiencias internas. Paradójicamente, cuanto más luchamos, más se intensifica el sufrimiento.",

  "psycho.act.q3q": "En la técnica 'Tengo el pensamiento de que...', ¿cuál es el objetivo?",
  "psycho.act.q3a": "Crear distancia con el pensamiento para reducir su poder",
  "psycho.act.q3b": "Demostrar que el pensamiento es falso",
  "psycho.act.q3c": "Reemplazar el pensamiento por uno positivo",
  "psycho.act.q3d": "Analizar el pensamiento en profundidad",
  "psycho.act.q3e": "El prefijo 'Tengo el pensamiento de que...' crea una distancia entre usted y el pensamiento. Permanece presente, pero pierde su poder de dictar sus acciones. Es defusión, no reestructuración cognitiva.",

  "psycho.act.q4q": "¿Cuál es la diferencia entre un valor y un objetivo según la ACT?",
  "psycho.act.q4a": "Los valores son más fáciles de alcanzar que los objetivos",
  "psycho.act.q4b": "Los objetivos son más importantes",
  "psycho.act.q4c": "Un valor es una dirección continua, un objetivo se puede alcanzar",
  "psycho.act.q4d": "No hay diferencia",
  "psycho.act.q4e": "Un valor es como una dirección en una brújula — nunca se alcanza, uno avanza hacia él (ej: ser un padre amoroso). Un objetivo es un punto de llegada concreto (ej: leer un libro de crianza este mes). Los valores guían los objetivos.",

  // ACT Exercise names
  "nav.actExercises": "ACT",
  "act.droppingAnchor.title": "Echar el Ancla",
  "act.droppingAnchor.desc": "Técnica de anclaje ACT para volver al momento presente",
  "act.expansion.title": "Hacer Espacio (Expansión)",
  "act.expansion.desc": "Acoger las emociones difíciles sin luchar",
  "act.observerSelf.title": "El Yo Observador",
  "act.observerSelf.desc": "Conectarse con la parte que observa sin juzgar",
  "act.choicePoint.title": "El Punto de Elección",
  "act.choicePoint.desc": "Identificar lo que le aleja o acerca a sus valores",
  "act.matrix.title": "La Matriz ACT",
  "act.matrix.desc": "Analizar comportamientos: hacia o lejos de lo que importa",
  "act.committedAction.title": "Acción Comprometida",
  "act.committedAction.desc": "Definir y seguir acciones alineadas con sus valores",
  "act.realityWitness.title": "Sea testigo de la realidad",
  "act.realityWitness.desc": "Salir de la rumiación anclando la atención en lo real a través de los 5 sentidos",
  "act.choiceQuestion.title": "La pregunta de la elección",
  "act.choiceQuestion.desc": "¿Me aleja o me acerca a la persona que quiero ser?",
  "act.controlMyth.title": "El mito del control",
  "act.controlMyth.desc": "Distinguir lo que no controlo de lo que puedo controlar parcialmente",

  // TDAH Adulte
  "psycho.tdah.title": "TDAH en Adultos — Enfoque TCC",
  "psycho.tdah.subtitle": "Basado en el programa de Safren y la guía TCCMontréal",
  "psycho.tdah.desc": "Módulo completo sobre la comprensión y el manejo del TDAH en adultos mediante la Terapia Cognitivo-Conductual. Aprenda las estrategias de organización, atención y reestructuración cognitiva.",
  "psycho.tdah.s1t": "1. ¿Qué es el TDAH en adultos?",
  "psycho.tdah.s1c": "El Trastorno por Déficit de Atención con o sin Hiperactividad (TDAH) afecta aproximadamente al 4-5% de los adultos. Contrario a las creencias populares, el TDAH no desaparece en la edad adulta — evoluciona.\n\nLas tres presentaciones del TDAH:\n• INATENCIÓN PREDOMINANTE: dificultades para mantener la atención, distractibilidad, olvidos frecuentes, dificultades de organización\n• HIPERACTIVIDAD-IMPULSIVIDAD PREDOMINANTE: agitación interna o externa, impaciencia, interrupción de otros, toma de decisiones impulsivas\n• PRESENTACIÓN COMBINADA: los dos tipos de síntomas\n\nEl TDAH adulto suele acompañarse de:\n• Disregulación emocional (reacciones emocionales intensas y rápidas)\n• Dificultades con el sentido del tiempo (retrasos crónicos, subestimación de duraciones)\n• Hiperfocalización (absorción total en una tarea interesante, dificultad para salir de ella)\n• Baja memoria de trabajo (olvidar lo que íbamos a hacer al cambiar de habitación)",
  "psycho.tdah.s2t": "2. El modelo cognitivo-conductual del TDAH (Safren)",
  "psycho.tdah.s2c": "El programa de Safren et al. (2006) es el tratamiento TCC del TDAH adulto más estudiado y validado científicamente. Propone un modelo en tres niveles:\n\nNIVEL 1 — DÉFICITS NEUROBIOLÓGICOS:\nEl TDAH es un trastorno del neurodesarrollo. El cerebro TDAH presenta un déficit en dopamina y noradrenalina, afectando las funciones ejecutivas (planificación, inhibición, memoria de trabajo).\n\nNIVEL 2 — DIFICULTADES FUNCIONALES:\nEstos déficits neurobiológicos crean dificultades concretas: retrasos, olvidos, desorganización, procrastinación, dificultades para terminar las tareas.\n\nNIVEL 3 — CONSECUENCIAS PSICOLÓGICAS:\nLos fracasos repetidos desde la infancia generan pensamientos automáticos negativos: 'Soy perezoso', 'Nunca lo conseguiré', 'Todos los demás lo logran excepto yo'. Estos pensamientos alimentan la ansiedad, la depresión y la baja autoestima.\n\nLa TCC actúa en los 3 niveles: estrategias compensatorias (nivel 2) + reestructuración cognitiva (nivel 3), en complemento del tratamiento farmacológico si es necesario (nivel 1).",
  "psycho.tdah.s3t": "3. Impacto del TDAH en la vida diaria",
  "psycho.tdah.s3c": "El TDAH afecta todos los ámbitos de la vida adulta:\n\nTRABAJO:\n• Retrasos y ausencias\n• Dificultades para respetar los plazos\n• Proyectos inacabados\n• Conflictos con la jerarquía\n• Bajo rendimiento en relación al potencial\n\nRELACIONES:\n• Olvido de cumpleaños y compromisos\n• Interrupción de conversaciones\n• Reacciones emocionales desproporcionadas\n• Pareja percibida como « irresponsable »\n\nFINANZAS:\n• Compras impulsivas\n• Facturas con retraso u olvidadas\n• Dificultad para mantener un presupuesto\n\nSALUD:\n• Citas médicas olvidadas\n• Dificultad para mantener una higiene de vida regular\n• Trastornos del sueño frecuentes\n• Comorbilidades: ansiedad (50%), depresión (30-40%), adicciones\n\nImportante: estas dificultades NO son defectos de carácter. Son las consecuencias funcionales de un trastorno neurobiológico. La TCC le enseña estrategias compensatorias adaptadas.",
  "psycho.tdah.s4t": "4. Estilo de vida y TDAH",
  "psycho.tdah.s4c": "La higiene de vida es la base del tratamiento del TDAH. Sin fundamentos sólidos, las estrategias cognitivas y conductuales pierden eficacia.\n\nSUEÑO (el más impactante):\n• El TDAH perturba el ritmo circadiano — 75% de los adultos TDAH tienen trastornos del sueño\n• Acuéstese y levántese a la misma hora, incluso los fines de semana\n• No pantallas 1h antes de acostarse (la luz azul agrava los síntomas TDAH)\n• La privación de sueño agrava TODOS los síntomas del TDAH\n\nEJERCICIO FÍSICO:\n• El ejercicio aumenta la dopamina y la noradrenalina — los mismos neurotransmisores objetivo de los medicamentos TDAH\n• 30 minutos de ejercicio moderado tienen un efecto comparable a una pequeña dosis de estimulante\n• Privilegie la mañana: el ejercicio matutino mejora la atención durante las 4-6h siguientes\n\nALIMENTACIÓN:\n• Comidas regulares (la glucemia inestable agrava la inatención)\n• Proteínas en el desayuno (sostienen la atención)\n• Limitar el azúcar y la cafeína excesiva\n\nATENCIÓN PLENA:\n• La meditación de atención plena está validada científicamente para el TDAH adulto\n• Entrena la atención sostenida y la capacidad de notar las distracciones",
  "psycho.tdah.s5t": "5. Organización y planificación",
  "psycho.tdah.s5c": "La organización es el talón de Aquiles del TDAH. El programa de Safren propone estrategias concretas:\n\nEL SISTEMA ABC DE PRIORIZACIÓN:\n• A = Urgente Y importante (por hacer hoy)\n• B = Importante, no urgente (por planificar esta semana)\n• C = Secundario (puede esperar o ser delegado)\nRegla: nunca comience una tarea B si una tarea A no está terminada.\n\nLA AGENDA ÚNICA:\n• UN SOLO lugar para anotar TODO (no post-its desperdigados)\n• Consúltela mañana, mediodía y noche\n• Anote citas, tareas, recordatorios e ideas en el mismo lugar\n• Digital o papel — lo importante es la constancia\n\nEL SISTEMA DE GESTIÓN ÚNICO:\n• UN lugar para el correo entrante\n• UN momento fijo por semana para el procesamiento\n• Tres acciones posibles: procesar ahora, planificar, desechar\n\nREGLA DE LOS 2 MINUTOS:\nSi una tarea toma menos de 2 minutos, hágala inmediatamente. Si toma más, anótela en su agenda.\n\nLOS RECORDATORIOS:\n• Alarmas del teléfono para las citas importantes\n• Recordatorio la víspera Y el mismo día\n• Rutina de la noche: preparar el día siguiente (ropa, bolso, documentos)",
  "psycho.tdah.s6t": "6. Gestión de la distractibilidad",
  "psycho.tdah.s6c": "La distractibilidad es el síntoma más visible del TDAH adulto. Es causada por un déficit del filtro atencional: el cerebro TDAH tiene dificultades para ignorar los estímulos no pertinentes.\n\nESTRATEGIAS AMBIENTALES:\n• Trabaje de espaldas al movimiento y a las ventanas\n• Teléfono en modo avión o en otra habitación\n• Use auriculares anti-ruido o música sin letras\n• Escritorio despejado: mantenga solo lo que concierne a la tarea en curso\n• Señale a colegas/familia cuando necesita concentrarse\n\nESTRATEGIAS TEMPORALES:\n• Conozca su « capacidad atencional » (a menudo 15-25 min para el TDAH)\n• Trabaje en bloques cortos con pausas (técnica Pomodoro adaptada)\n• Planifique las tareas difíciles en su pico de atención (a menudo la mañana)\n• Use un cronómetro visible (el tiempo se vuelve concreto)\n\nESTRATEGIAS COGNITIVAS:\n• Cuando aparece una distracción, anótela en un « estacionamiento de ideas » y vuelva a su tarea\n• Practique el « reencuadre atencional »: « Noto que estoy distraído. Elijo volver a mi tarea. »\n• Use la técnica « solo 5 minutos »: comprométase a trabajar solo 5 min (la inercia al arrancar es el verdadero obstáculo)",
  "psycho.tdah.s7t": "7. Reestructuración cognitiva en el TDAH",
  "psycho.tdah.s7c": "Los adultos TDAH desarrollan esquemas de pensamiento negativos después de años de fracasos y críticas. El programa de Safren apunta específicamente a estos pensamientos automáticos.\n\nPENSAMIENTOS AUTOMÁTICOS TÍPICOS DEL TDAH:\n• « Soy perezoso / holgazán » → En realidad: déficit de dopamina, no de voluntad\n• « Todo el mundo lo logra excepto yo » → Sobregeneralización + comparación injusta\n• « No sirve de nada intentar, voy a fallar otra vez » → Predicción negativa\n• « Si no puedo hacerlo perfectamente, mejor no hacer nada » → Pensamiento todo-o-nada\n• « Debería ser capaz de hacer esto sin ayuda » → Exigencia irrealista\n\nLA TABLA DE REGISTRO DE PENSAMIENTOS:\n1. Situación desencadenante\n2. Pensamiento automático\n3. Emoción e intensidad (0-10)\n4. Tipo de error de pensamiento\n5. Pruebas a favor / en contra\n6. Pensamiento alternativo realista (integrando el TDAH como factor)\n7. Nueva emoción e intensidad\n\nClave: El pensamiento alternativo debe RECONOCER el TDAH como factor explicativo manteniendo la agencia. Ej: « Mi TDAH hace difícil la organización, Y puedo aprender estrategias compensatorias. »",
  "psycho.tdah.s8t": "8. Procrastinación y prevención de recaídas",
  "psycho.tdah.s8c": "LA PROCRASTINACIÓN EN EL TDAH:\nLa procrastinación TDAH es diferente de la procrastinación « ordinaria ». Está relacionada con:\n• El déficit de dopamina (el cerebro no produce suficiente motivación para las tareas no estimulantes)\n• La dificultad para iniciar (« parálisis de arranque »)\n• La aversión por la demora de gratificación\n• La subestimación del tiempo necesario\n\nTÉCNICAS ANTI-PROCRASTINACIÓN:\n• Descomponer en micro-etapas (5 min máximo cada una)\n• La técnica del « primer paso »: comprométase solo a hacer la primera micro-etapa\n• Recompensa inmediata después de cada micro-etapa\n• El « body doubling »: trabajar en presencia de alguien (incluso por video)\n• Hacer la tarea más estimulante (música, desafío personal, gamificación)\n\nPREVENCIÓN DE RECAÍDAS:\nEl TDAH es un trastorno CRÓNICO. Las estrategias funcionan mientras se mantengan.\n• Espere recaídas — forman parte del proceso\n• Cuando una estrategia falla, no la abandone: ajústela\n• Mantenga sus citas de seguimiento incluso cuando « todo va bien »\n• Rodéese: grupo de apoyo TDAH, coach, terapeuta\n• Sea benevolente consigo mismo: el TDAH es un maratón, no un sprint",
  "psycho.tdah.q1q": "Según el modelo de Safren, ¿cuál es el tercer nivel de las consecuencias del TDAH?",
  "psycho.tdah.q1a": "Dificultades de organización",
  "psycho.tdah.q1b": "Déficits neurobiológicos",
  "psycho.tdah.q1c": "Consecuencias psicológicas (pensamientos negativos, ansiedad, depresión)",
  "psycho.tdah.q1d": "Trastornos del sueño",
  "psycho.tdah.q1e": "El modelo de Safren describe 3 niveles: 1) Déficits neurobiológicos, 2) Dificultades funcionales, 3) Consecuencias psicológicas. Los fracasos repetidos generan pensamientos automáticos negativos que alimentan la ansiedad y la depresión.",
  "psycho.tdah.q2q": "En el sistema ABC, ¿qué representa una tarea A?",
  "psycho.tdah.q2a": "Una tarea secundaria",
  "psycho.tdah.q2b": "Una tarea urgente E importante para hacer hoy",
  "psycho.tdah.q2c": "Una tarea importante pero no urgente",
  "psycho.tdah.q2d": "Una tarea que se puede delegar",
  "psycho.tdah.q2e": "El sistema ABC clasifica las tareas: A = urgente + importante (hoy), B = importante pero no urgente (esta semana), C = secundaria. Nunca se comienza una tarea B si una tarea A no está terminada.",
  "psycho.tdah.q3q": "¿Por qué el ejercicio físico es particularmente beneficioso para el TDAH?",
  "psycho.tdah.q3a": "Aumenta la dopamina y noradrenalina, los mismos neurotransmisores que los medicamentos para TDAH",
  "psycho.tdah.q3b": "Cansa el cuerpo y reduce la hiperactividad",
  "psycho.tdah.q3c": "Solo mejora el sueño",
  "psycho.tdah.q3d": "No tiene efecto probado en el TDAH",
  "psycho.tdah.q3e": "El ejercicio físico aumenta la dopamina y la noradrenalina — los mismos neurotransmisores que los medicamentos para TDAH apuntan. 30 minutos de ejercicio moderado tienen un efecto comparable a una pequeña dosis de estimulante.",
  "psycho.tdah.q4q": "¿Cuál es la diferencia entre la procrastinación TDAH y la procrastinación «ordinaria»?",
  "psycho.tdah.q4a": "No hay diferencia",
  "psycho.tdah.q4b": "Es una elección consciente",
  "psycho.tdah.q4c": "La procrastinación TDAH está únicamente relacionada con el estrés",
  "psycho.tdah.q4d": "Está vinculada al déficit de dopamina y la dificultad para iniciar tareas no estimulantes",
  "psycho.tdah.q4e": "La procrastinación en el TDAH es neurobiológica: el cerebro no produce suficiente dopamina para motivar las tareas no estimulantes, creando una 'parálisis de arranque'. No es pereza.",

  "nav.tdahAdulte": "TDAH Adulto",
  "tdah.priorities.title": "Prioridades ABC",
  "tdah.priorities.desc": "Sistema de priorización de tareas A/B/C",
  "tdah.documents.title": "Gestión de Documentos",
  "tdah.documents.desc": "Sistema único de gestión de correo y facturas",
  "tdah.attention.title": "Capacidad Atencional",
  "tdah.attention.desc": "Evaluar y entrenar su capacidad de atención",
  "tdah.thoughts.title": "Pensamientos TDAH",
  "tdah.thoughts.desc": "Registro y reestructuración cognitiva",
  "tdah.procrastination.title": "Anti-Procrastinación",
  "tdah.procrastination.desc": "Descomposición de tareas en micro-pasos",
  "tdah.goals.title": "Objetivos y Motivación",
  "tdah.goals.desc": "Fijar objetivos realistas y mantener la motivación",

  // TDAH Kids Workbook
  "exercise.tdahKids.superpowers.title": "Super-Poderes Cosmicos",
  "exercise.tdahKids.superpowers.desc": "Descubre tus fuerzas secretas",
  "exercise.tdahKids.safetyBubble.title": "Burbuja Espacial",
  "exercise.tdahKids.safetyBubble.desc": "Crea tu espacio de calma",
  "exercise.tdahKids.relaxation.title": "Retorno a Orbita",
  "exercise.tdahKids.relaxation.desc": "Relajacion muscular",
  "exercise.tdahKids.radar.title": "Radar Galactico",
  "exercise.tdahKids.radar.desc": "Diario de sensaciones",
  "exercise.tdahKids.recharge.title": "Estacion de Recarga",
  "exercise.tdahKids.recharge.desc": "Momentos tranquilos y reconfortantes",
  "exercise.tdahKids.turbo.title": "Nave Turbo",
  "exercise.tdahKids.turbo.desc": "Comprende tu cerebro turbo",
  "exercise.tdahKids.mission.title": "Mision Espacial",
  "exercise.tdahKids.mission.desc": "Desafios de autocontrol",
  "exercise.tdahKids.superheroDay.title": "Dia de Astronauta",
  "exercise.tdahKids.superheroDay.desc": "Seguimiento diario de energia",
  "exercise.tdahKids.victories.title": "Estrellas de Victoria",
  "exercise.tdahKids.victories.desc": "Celebra tus logros",
  "exercise.tdahKids.questions.title": "Mensaje al Centro de Control",
  "exercise.tdahKids.questions.desc": "Preguntas para tu terapeuta",
  // Parent Task Board & Psychoeducation
  "exercise.parentTaskBoard.title": "Tablero de Misiones",
  "exercise.parentTaskBoard.desc": "Misiones diarias con insignias por ganar",
  "exercise.morningChecklist.title": "Checklist de la Manana",
  "exercise.morningChecklist.desc": "Lista de tareas para estructurar tu rutina matinal",
  "psychoed.tdahChild.title": "Comprender mi TDAH",
  "psychoed.tdahChild.desc": "Modulo ludico para comprender el TDAH",
  "psychoed.limitsChild.title": "Mi Jardin Secreto - Los Limites",
  "psychoed.limitsChild.desc": "Aprender los limites de forma ludica",
  "psychoed.limitsAdult.title": "Comunicar los Limites",
  "psychoed.limitsAdult.desc": "Tecnicas asertivas para defender tus limites",
  "psychoed.schemaTherapy.title": "Terapia de Esquemas",
  "psychoed.tcd.title": "TDC (Linehan)",
  "psychoed.dissociationTrauma.title": "Disociacion y Trauma",
  "psychoed.toc.title": "Comprender el TOC",
  "psychoed.toc.subtitle": "Trastorno Obsesivo Compulsivo: comprender y actuar",
  "psychoed.borderline.title": "Comprender el Trastorno Borderline",
  "psychoed.borderline.subtitle": "Trastorno de Personalidad Borderline: comprender para vivir mejor",
  "psychoed.erectileDysfunction.title": "Disfuncion erectil y ansiedad de rendimiento",
  "psychoed.erectileDysfunction.subtitle": "Comprender la ansiedad de rendimiento y practicar la focalizacion sensorial",
  "exercices.schemaTherapy.title": "Ejercicios Esquemas",
  "exercices.tcd.title": "Ejercicios TDC",
  "exercices.dissociationTrauma.title": "Ejercicios Disociacion",
  "nav.exercicesAvances": "Ejercicios Avanzados",

  // Schema Exercises Page
  "schemaEx.pageTitle": "Ejercicios: Terapia de Esquemas",
  "schemaEx.pageSubtitle": "Ejercicios practicos para identificar y transformar tus esquemas",
  "schemaEx.journal.name": "Diario de esquemas",
  "schemaEx.journal.desc": "Identifique sus esquemas diariamente detectando situaciones que activan reacciones emocionales intensas.",
  "schemaEx.journal.situation": "Situacion desencadenante",
  "schemaEx.journal.situationPh": "Describa la situacion (quien, que, cuando, donde)",
  "schemaEx.journal.emotion": "Emocion sentida e intensidad (0-10)",
  "schemaEx.journal.emotionPh": "Ej: Tristeza (8/10), ira (5/10)",
  "schemaEx.journal.thoughts": "Pensamientos automaticos",
  "schemaEx.journal.thoughtsPh": "Que pensamientos surgieron? Ej: 'Nadie se preocupa por mi'",
  "schemaEx.journal.schema": "Esquema probablemente activado",
  "schemaEx.journal.schemaPh": "Ej: Abandono, Imperfeccion, Fracaso, Carencia afectiva...",
  "schemaEx.journal.reaction": "Reaccion comportamental",
  "schemaEx.journal.reactionPh": "Que hizo? (sumision, evitacion o compensacion)",
  "schemaEx.memo.name": "Ficha memo-flash",
  "schemaEx.memo.desc": "Cree una tarjeta portatil para contrarrestar su esquema cuando se active.",
  "schemaEx.memo.voice": "Lo que dice el esquema",
  "schemaEx.memo.voicePh": "Ej: 'Nadie me quiere de verdad'",
  "schemaEx.memo.why": "Por que es un esquema, no la realidad",
  "schemaEx.memo.whyPh": "Liste las pruebas contra esta creencia",
  "schemaEx.memo.realistic": "Lo que es mas realista",
  "schemaEx.memo.realisticPh": "Ej: 'Algunas personas me quieren sinceramente'",
  "schemaEx.memo.action": "Lo que puedo hacer ahora",
  "schemaEx.memo.actionPh": "Un comportamiento sano y concreto",
  "schemaEx.dialogue.name": "Dialogo interior",
  "schemaEx.dialogue.desc": "Haga dialogar su lado esquema y su lado sano para cuestionar las creencias automaticas.",
  "schemaEx.dialogue.schemaSide": "Lado esquema (lo que dice)",
  "schemaEx.dialogue.schemaSidePh": "Deje que el esquema se exprese plenamente...",
  "schemaEx.dialogue.healthySide": "Lado sano (respuesta del Adulto Sano)",
  "schemaEx.dialogue.healthySidePh": "Responda con empatia y firmeza...",
  "schemaEx.dialogue.schemaReply": "Esquema (respuesta)",
  "schemaEx.dialogue.schemaReplyPh": "Que responde el esquema?",
  "schemaEx.dialogue.healthyFinal": "Lado sano (palabra final)",
  "schemaEx.dialogue.healthyFinalPh": "Concluya con una perspectiva equilibrada",
  "schemaEx.letter.name": "Carta al Nino Vulnerable",
  "schemaEx.letter.desc": "Escriba a la parte nino de usted mismo como un acto de reparentalidad interior.",
  "schemaEx.letter.letter": "Su carta al nino interior",
  "schemaEx.letter.letterPh": "Querido/a pequeno/a [nombre]...\nReconozca su sufrimiento, valide sus emociones, tranquilicelo/a...",
  "schemaEx.letter.response": "Respuesta del nino (opcional)",
  "schemaEx.letter.responsePh": "Que responderia el nino?",
  "schemaEx.imagery.name": "Imagineria y reparentalidad",
  "schemaEx.imagery.desc": "Acceda a un recuerdo de infancia y transformelo aportando una experiencia reparadora.",
  "schemaEx.imagery.scene": "Escena de infancia (describa la imagen)",
  "schemaEx.imagery.scenePh": "El lugar, las personas, lo que siente en su cuerpo de nino...",
  "schemaEx.imagery.intervention": "Intervencion del Adulto Sano",
  "schemaEx.imagery.interventionPh": "Como interviene su yo adulto para proteger al nino?",
  "schemaEx.imagery.transformed": "Escena transformada",
  "schemaEx.imagery.transformedPh": "Como cambia la escena cuando se satisface la necesidad del nino?",
  "schemaEx.imagery.feeling": "Sensacion despues del ejercicio",
  "schemaEx.imagery.feelingPh": "Que sintio al abrir los ojos?",

  // TCD Exercises Page
  "tcdEx.pageTitle": "Ejercicios: TDC (Terapia Dialectico Conductual)",
  "tcdEx.pageSubtitle": "Habilidades de regulacion emocional y tolerancia al malestar",
  "tcdEx.chain.name": "Analisis en cadena",
  "tcdEx.chain.desc": "Descomponga la secuencia completa entre un desencadenante y un comportamiento problematico.",
  "tcdEx.chain.behavior": "Comportamiento problematico",
  "tcdEx.chain.behaviorPh": "Describa precisamente el comportamiento a analizar",
  "tcdEx.chain.trigger": "Evento desencadenante",
  "tcdEx.chain.triggerPh": "Quien, que, cuando, donde?",
  "tcdEx.chain.vulnerability": "Factores de vulnerabilidad",
  "tcdEx.chain.vulnerabilityPh": "Falta de sueno, hambre, estres, enfermedad, conflicto...",
  "tcdEx.chain.chain": "Eslabones de la cadena (pensamientos, emociones, sensaciones, acciones)",
  "tcdEx.chain.chainPh": "Detalle cada paso entre el desencadenante y el comportamiento...",
  "tcdEx.chain.consequences": "Consecuencias (corto y largo plazo)",
  "tcdEx.chain.consequencesPh": "Corto plazo: alivio? Largo plazo: empeoramiento?",
  "tcdEx.chain.skills": "Habilidades TDC alternativas",
  "tcdEx.chain.skillsPh": "En que eslabones podria haber usado una habilidad? Cual?",
  "tcdEx.stop.name": "STOP y TIP",
  "tcdEx.stop.desc": "Tecnicas de crisis para atravesar un momento de dolor intenso sin empeorar la situacion.",
  "tcdEx.stop.crisis": "Situacion de crisis",
  "tcdEx.stop.crisisPh": "Describa la situacion y la intensidad emocional (0-10)",
  "tcdEx.stop.steps": "Aplicacion del STOP",
  "tcdEx.stop.stepsPh": "S (Parar) — T (Tomarse un momento) — O (Observar) — P (Proceder con atencion plena)",
  "tcdEx.stop.tip": "Tecnica TIP utilizada",
  "tcdEx.stop.tipPh": "Temperatura (agua fria), Ejercicio intenso, Respiracion pausada, Relajacion muscular...",
  "tcdEx.stop.outcome": "Resultado",
  "tcdEx.stop.outcomePh": "Como se siente despues? Ha bajado la intensidad?",
  "tcdEx.acceptance.name": "Aceptacion radical y media sonrisa",
  "tcdEx.acceptance.desc": "Practique la aceptacion completa de la realidad y las tecnicas corporales asociadas.",
  "tcdEx.acceptance.situation": "Situacion a aceptar",
  "tcdEx.acceptance.situationPh": "Que realidad le cuesta aceptar?",
  "tcdEx.acceptance.signs": "Signos de no-aceptacion",
  "tcdEx.acceptance.signsPh": "Amargura, rumiacion, tension corporal, deseo de negar...",
  "tcdEx.acceptance.steps": "Pasos de aceptacion practicados",
  "tcdEx.acceptance.stepsPh": "Observar la lucha, reconocer la realidad, identificar las causas, aceptar con el cuerpo...",
  "tcdEx.acceptance.body": "Practica corporal",
  "tcdEx.acceptance.bodyPh": "Media sonrisa, manos voluntarias — describa su experiencia",
  "tcdEx.acceptance.result": "Efecto sentido",
  "tcdEx.acceptance.resultPh": "Como se siente despues de la practica?",
  "tcdEx.facts.name": "Verificar los hechos y actuar a la inversa",
  "tcdEx.facts.desc": "Evalue si su emocion corresponde a los hechos y, si no, actue a la inversa.",
  "tcdEx.facts.emotion": "Emocion sentida e intensidad",
  "tcdEx.facts.emotionPh": "Ej: Ira (8/10)",
  "tcdEx.facts.triggerFacts": "Hechos objetivos de la situacion",
  "tcdEx.facts.triggerFactsPh": "Que paso realmente? (sin interpretacion)",
  "tcdEx.facts.interpretations": "Mis interpretaciones",
  "tcdEx.facts.interpretationsPh": "Que suposiciones hice? Estan basadas en hechos?",
  "tcdEx.facts.matchesFacts": "La emocion corresponde a los hechos?",
  "tcdEx.facts.matchesFactsPh": "Si (resolucion de problema) o No (actuar a la inversa)",
  "tcdEx.facts.oppositeAction": "Accion opuesta realizada",
  "tcdEx.facts.oppositeActionPh": "Que hizo a la inversa del impulso? YENDO A FONDO",
  "tcdEx.dear.name": "DEAR MAN",
  "tcdEx.dear.desc": "Directrices de eficacia para el objetivo: obtener lo que quieres.",
  "tcdEx.dear.context": "Situacion y objetivo",
  "tcdEx.dear.contextPh": "Describa la situacion y lo que quiere obtener",
  "tcdEx.dear.describe": "D - Describir (los hechos)",
  "tcdEx.dear.describePh": "Ej: 'Me dijiste que estarias en casa para cenar pero llegaste a las 23h.'",
  "tcdEx.dear.describeHint": "Describa la SITUACION actual (si es necesario). Atenerse a los hechos. Diga a la persona exactamente a que esta reaccionando.",
  "tcdEx.dear.express": "E - Expresar (sentimientos y opiniones)",
  "tcdEx.dear.expressPh": "Ej: 'Cuando llegas tan tarde a casa, me preocupo por ti.'",
  "tcdEx.dear.expressHint": "Exprese sus SENTIMIENTOS y OPINIONES sobre la situacion. No asuma que la persona sabe lo que siente. Use 'yo quiero' en lugar de 'tu deberias'.",
  "tcdEx.dear.assert": "A - Afirmar (peticion o rechazo claro)",
  "tcdEx.dear.assertPh": "Ej: 'Me gustaria mucho que me llamaras si vas a llegar tarde.'",
  "tcdEx.dear.assertHint": "Afirmese PIDIENDO o RECHAZANDO claramente. No asuma que otros van a adivinar. Recuerde que los demas no pueden leer su mente.",
  "tcdEx.dear.reinforce": "R - Reforzar (consecuencias positivas)",
  "tcdEx.dear.reinforcePh": "Ej: 'Me sentiria tan aliviada y mucho mas facil de convivir si lo hicieras.'",
  "tcdEx.dear.reinforceHint": "Refuerce (recompense) a la persona por adelantado presentandole los efectos positivos. Si es necesario, precise las consecuencias negativas.",
  "tcdEx.dear.mindful": "M - Mantener la plena conciencia",
  "tcdEx.dear.mindfulPh": "Como mantuvo su posicion? Uso la tecnica del 'disco rayado'?",
  "tcdEx.dear.mindfulHint": "Centrese EN SUS OBJETIVOS. Mantenga su posicion. No se deje distraer. No se salga del tema. Disco rayado: siga pidiendo, rechazando o expresando su opinion, una y otra vez. Ignore los ataques.",
  "tcdEx.dear.confident": "A - Con seguridad",
  "tcdEx.dear.confidentPh": "Como mostro seguridad? (tono, contacto visual, postura)",
  "tcdEx.dear.confidentHint": "Aparente ser competente y EFICAZ. Use un tono y actitud confiados; establezca contacto visual adecuado. No tartamudee, no susurre, no mire al suelo, no retroceda.",
  "tcdEx.dear.negotiate": "N - Negociar (alternativas)",
  "tcdEx.dear.negotiatePh": "Ej: 'Y si me enviaras un mensaje cuando creas que llegaras tarde?'",
  "tcdEx.dear.negotiateHint": "Este dispuesto a DAR PARA RECIBIR. Proponga y pida otras soluciones al problema. Reduzca su peticion. Diga no, pero proponga una alternativa.",
  "tcdEx.dear.debrief": "Debriefing despues de la interaccion (opcional)",
  "tcdEx.dear.debriefPh": "Que funciono bien? Que mejorar?",
  "tcdEx.give.name": "GIVE",
  "tcdEx.give.desc": "Directrices de eficacia para la relacion: mantener la relacion.",
  "tcdEx.give.context": "Situacion relacional",
  "tcdEx.give.contextPh": "Describa la situacion y la relacion que quiere preservar",
  "tcdEx.give.gentle": "G - Ser Amable",
  "tcdEx.give.gentlePh": "Como fue agradable y respetuoso? Que evito?",
  "tcdEx.give.gentleHint": "SEA AGRADABLE y respetuoso. Sin ataques. Sin amenazas. Sin juicios. Sin faltas de respeto.",
  "tcdEx.give.interest": "I - Mostrar Interes",
  "tcdEx.give.interestPh": "Como mostro interes por la otra persona?",
  "tcdEx.give.interestHint": "ESCUCHE y MUESTRE INTERES por la otra persona y su punto de vista. Mire a la persona, mantenga contacto visual. No interrumpa. Sea paciente.",
  "tcdEx.give.validate": "V - Validar",
  "tcdEx.give.validatePh": "Como mostro que comprende los sentimientos de la otra persona?",
  "tcdEx.give.validateHint": "A traves de sus PALABRAS y ACCIONES, muestre que comprende los sentimientos y pensamientos de la persona. Pongase en su lugar.",
  "tcdEx.give.easy": "E - Ser Cordial",
  "tcdEx.give.easyPh": "Como uso el humor o puso a la persona comoda?",
  "tcdEx.give.easyHint": "Use el humor. SONRIA. Ponga a la persona comoda. No se tome demasiado en serio. Sea diplomatico.",
  "tcdEx.give.debrief": "Debriefing (opcional)",
  "tcdEx.give.debriefPh": "Como se vio afectada la relacion? Que aprendio?",
  "tcdEx.fast.name": "FAST",
  "tcdEx.fast.desc": "Directrices de eficacia para el respeto propio: mantener el respeto propio.",
  "tcdEx.fast.context": "Situacion en juego",
  "tcdEx.fast.contextPh": "Describa la situacion donde su respeto propio esta en juego",
  "tcdEx.fast.fair": "F - Ser Justo",
  "tcdEx.fast.fairPh": "Como fue honesto consigo mismo y con la otra persona?",
  "tcdEx.fast.fairHint": "Sea HONESTO consigo mismo y con la OTRA persona. Recuerde VALIDAR SUS PROPIOS sentimientos y deseos.",
  "tcdEx.fast.apologies": "A - No disculparse innecesariamente",
  "tcdEx.fast.apologiesPh": "Se disculpo excesivamente? Por que no deberia disculparse?",
  "tcdEx.fast.apologiesHint": "No se disculpe en exceso. No se disculpe por estar vivo o por hacer una peticion. No se disculpe por tener una opinion. No PAREZCA AVERGONZADO.",
  "tcdEx.fast.values": "S - Sostener sus valores",
  "tcdEx.fast.valuesPh": "Que valores defendio en esta situacion?",
  "tcdEx.fast.valuesHint": "Permanezca fiel a SUS VALORES. No sacrifique sus valores o su integridad por razones que no sean MUY importantes.",
  "tcdEx.fast.truthful": "T - Transmitir con honestidad",
  "tcdEx.fast.truthfulPh": "Como fue honesto sin exagerar?",
  "tcdEx.fast.truthfulHint": "No mienta. No se presente como indefenso cuando no lo es. No exagere y no invente excusas.",
  "tcdEx.fast.debrief": "Debriefing (opcional)",
  "tcdEx.fast.debriefPh": "Como se sintio despues? Se preservo su respeto propio?",

  // Dissociation Exercises Page
  "dissocEx.pageTitle": "Ejercicios: Disociacion y Trauma",
  "dissocEx.pageSubtitle": "Tecnicas de anclaje, estabilizacion y trabajo con las partes",
  "dissocEx.grounding.name": "Anclaje y retorno al presente",
  "dissocEx.grounding.desc": "Tecnica 5-4-3-2-1 para reconectarse con el momento presente en caso de disociacion.",
  "dissocEx.grounding.see5": "5 cosas que veo (en detalle)",
  "dissocEx.grounding.see5Ph": "Describa 5 cosas visibles con detalles (color, forma, tamano...)",
  "dissocEx.grounding.hear4": "4 cosas que escucho",
  "dissocEx.grounding.hear4Ph": "Describa 4 sonidos que percibe ahora mismo",
  "dissocEx.grounding.touch3": "3 cosas que toco",
  "dissocEx.grounding.touch3Ph": "Describa 3 sensaciones tactiles (textura, temperatura...)",
  "dissocEx.grounding.smell2": "2 cosas que huelo",
  "dissocEx.grounding.smell2Ph": "Describa 2 olores percibidos",
  "dissocEx.grounding.taste1": "1 cosa que saboreo",
  "dissocEx.grounding.taste1Ph": "Describa 1 sabor",
  "dissocEx.grounding.orientation": "Orientacion temporal",
  "dissocEx.grounding.orientationPh": "Mi nombre, la fecha, la hora, el lugar, y: 'En este momento, estoy a salvo'",
  "dissocEx.grounding.effectiveness": "Eficacia (0-10)",
  "dissocEx.grounding.effectivenessPh": "Que tan efectivo fue el anclaje? Volvieron las sensaciones?",
  "dissocEx.safe.name": "El lugar seguro interior",
  "dissocEx.safe.desc": "Cree un refugio interior de seguridad y calma, activable en caso de angustia.",
  "dissocEx.safe.visual": "Lo que veo en mi lugar seguro",
  "dissocEx.safe.visualPh": "Colores, luz, formas, espacio...",
  "dissocEx.safe.sounds": "Lo que escucho",
  "dissocEx.safe.soundsPh": "Sonidos de la naturaleza, musica, silencio...",
  "dissocEx.safe.touch": "Lo que toco y siento en mi cuerpo",
  "dissocEx.safe.touchPh": "Texturas, temperatura, calor, ligereza, relajacion...",
  "dissocEx.safe.smells": "Lo que huelo (olores)",
  "dissocEx.safe.smellsPh": "Olores asociados a este lugar",
  "dissocEx.safe.keyword": "Palabra clave o gesto asociado",
  "dissocEx.safe.keywordPh": "Una palabra o gesto que active el sentimiento de seguridad",
  "dissocEx.safe.body": "Sensacion corporal de seguridad",
  "dissocEx.safe.bodyPh": "Donde en su cuerpo siente la seguridad?",
  "dissocEx.parts.name": "Trabajar con las partes (IFS)",
  "dissocEx.parts.desc": "Identifique y comuniquese con una parte protectora o herida de su psique.",
  "dissocEx.parts.identified": "Parte identificada",
  "dissocEx.parts.identifiedPh": "Describa la parte (ej: 'la parte que se adormece', 'el critico interior')",
  "dissocEx.parts.role": "Su rol protector",
  "dissocEx.parts.rolePh": "De que intenta protegerme esta parte?",
  "dissocEx.parts.communication": "Comunicacion con la parte",
  "dissocEx.parts.communicationPh": "Que dice? De que tiene miedo? Que necesita?",
  "dissocEx.parts.reassurance": "Tranquilizacion desde el Self",
  "dissocEx.parts.reassurancePh": "Lo que su Self (esencia tranquila) dice a esta parte...",
  "dissocEx.parts.newRole": "Nuevo rol propuesto (opcional)",
  "dissocEx.parts.newRolePh": "Aceptaria un rol diferente, menos extremo?",
  "dissocEx.window.name": "Ventana de tolerancia",
  "dissocEx.window.desc": "Evalue su posicion en la ventana de tolerancia y practique la regulacion.",
  "dissocEx.window.state": "Posicion actual",
  "dissocEx.window.statePh": "Hiperactivacion (ansiedad, panico, ira) / En la ventana (presente, equilibrado) / Hipoactivacion (entumecimiento, vacio)",
  "dissocEx.window.signs": "Signos corporales observados",
  "dissocEx.window.signsPh": "Corazon acelerado, musculos tensos, pensamientos acelerados O entumecimiento, fatiga, desconexion...",
  "dissocEx.window.trigger": "Lo que me saco de la ventana",
  "dissocEx.window.triggerPh": "Evento, pensamiento, recuerdo, interaccion...",
  "dissocEx.window.strategy": "Estrategia usada para volver a la ventana",
  "dissocEx.window.strategyPh": "Hiperactivacion: respiracion, anclaje, lugar seguro / Hipoactivacion: movimiento, estimulacion sensorial, caminata",
  "dissocEx.window.result": "Resultado",
  "dissocEx.window.resultPh": "Volvi a la ventana? En cuanto tiempo?",

  // Shared exercise form labels
  "exerciseForm.save": "Guardar",
  "exerciseForm.back": "Volver",
  "exerciseForm.history": "Historial",
  "exerciseForm.sessions": "sesion(es)",
  "exerciseForm.fillOne": "Por favor complete al menos un campo",
  "exerciseForm.saved": "Ejercicio guardado",
  "exerciseForm.saveError": "Error al guardar el ejercicio",

  // Psychoeducation Module UI
  "psychoed.notFound": "Modulo no encontrado.",
  "psychoed.back": "Volver",
  "psychoed.progress": "Progreso",
  "psychoed.chapters": "capitulos",
  "psychoed.chapter": "Capitulo",
  "psychoed.quizChild": "Quiz!",
  "psychoed.quizAdult": "Pregunta de reflexion",
  "psychoed.correctChild": "Bravo! ",
  "psychoed.correctAdult": "Correcto! ",
  "psychoed.wrongChild": "No del todo! ",
  "psychoed.wrongAdult": "No exactamente. ",
  "psychoed.prev": "Anterior",
  "psychoed.next": "Siguiente",
  "psychoed.saving": "Guardando...",
  "psychoed.complete": "Completar el modulo!",
  "psychoed.completed": "Modulo completado! Bravo!",
  "psychoed.saveError": "Error al guardar",
  "psychoed.historyTitle": "Historial",

  // === Barkley titles/descriptions ===
  "barkley.identityCard.title": "Tarjeta de identidad TDAH",
  "barkley.identityCard.desc": "Identificar las situaciones difíciles y las funciones ejecutivas implicadas",
  "barkley.specialMoment.title": "Momento Especial",
  "barkley.specialMoment.desc": "Seguimiento diario del momento especial padre-hijo",
  "barkley.instructions.title": "Instrucciones Eficaces",
  "barkley.instructions.desc": "Transformar sus instrucciones para hacerlas positivas y claras",
  "barkley.tokenSystem.title": "Sistema de Puntos",
  "barkley.tokenSystem.desc": "Implementar y seguir un sistema de refuerzo positivo",
  "barkley.crisisPlan.title": "Plan de Gestión de Crisis",
  "barkley.crisisPlan.desc": "Construir un protocolo personalizado para gestionar las crisis",
  "barkley.abcAnalysis.title": "Análisis ABC Barkley",
  "barkley.abcAnalysis.desc": "Analizar los antecedentes, comportamientos y consecuencias",
  "barkley.childVolcano.title": "Mi Volcán Interior",
  "barkley.childVolcano.desc": "Identificar las señales de enfado y elegir una estrategia para calmarse",
  "barkley.childAutonomy.title": "Mi Temporizador de Autonomía",
  "barkley.childAutonomy.desc": "Entrenarse para quedarse solo/a en una actividad elegida",
  "barkley.childSuperpowers.title": "Mis Superpoderes",
  "barkley.childSuperpowers.desc": "Descubre tus fortalezas y cualidades",
  "barkley.childSolutions.title": "La Rueda de Soluciones",
  "barkley.childSolutions.desc": "Elegir una estrategia ante un problema",
  "barkley.childSuccess.title": "Mi Cuadro de Logros",
  "barkley.childSuccess.desc": "Anota cada día tus logros, incluso los pequeños",
  "barkley.childDetective.title": "El Detective de las Instrucciones",
  "barkley.childDetective.desc": "Reformular una instrucción con tus propias palabras",
  "barkley.teenSituation.title": "Mi Análisis de Situación",
  "barkley.teenSituation.desc": "Analiza una situación con tus pensamientos y emociones",
  "barkley.teenPlanner.title": "Mi Planificación Semanal",
  "barkley.teenPlanner.desc": "Construye y sigue tu planificación semanal",
  "barkley.teenEmotionJournal.title": "Diario de Emociones Exprés",
  "barkley.teenEmotionJournal.desc": "Anota una emoción al día con su detonante",
  "barkley.teenSmartGoals.title": "Mis Objetivos SMART",
  "barkley.teenSmartGoals.desc": "Define y sigue objetivos concretos",
  "barkley.teenCNV.title": "Comunicación No Violenta",
  "barkley.teenCNV.desc": "Formula peticiones en 4 pasos (CNV)",
  "barkley.teenWeeklyReview.title": "Mi Balance Semanal",
  "barkley.teenWeeklyReview.desc": "Autobalance rápido de la semana",
  "barkley.history": "Historial",
  "barkley.saved": "¡Ejercicio guardado!",

  // === Exercise names/descriptions ===
  "exercise.cognitive_restructuring": "Reestructuración cognitiva",
  "exercise.cognitive_restructuring.desc": "Identifique y modifique sus esquemas de pensamiento",

  // === ExerciseData (intro cards for each exercise) ===
  "exerciseData.emotion_register.title": "Registro de emociones",
  "exerciseData.emotion_register.obj1": "Identificar y nombrar con precisión las emociones sentidas",
  "exerciseData.emotion_register.obj2": "Cuestionar la proporcionalidad de la emoción ante la situación",
  "exerciseData.emotion_register.obj3": "Externalizar la emoción para crear una distancia terapéutica",
  "exerciseData.emotion_register.obj4": "Desarrollar respuestas emocionales más adaptadas",
  "exerciseData.emotion_register.explanation": "El registro de emociones es una herramienta de regulación emocional basada en el cuestionamiento socrático. En lugar de sufrir sus emociones, aprende a observarlas, cuestionarlas y externalizarlas. Al escribir directamente a su emoción como si fuera una entidad separada, crea una distancia que le permite no caer en una actitud negativa y elegir una respuesta más adaptada.",
  "exerciseData.emotion_register.foundation": "Método socrático — Regulación emocional (Beck, Greenberger & Padesky)",

  "exerciseData.behavioral_activation.title": "Activación conductual",
  "exerciseData.behavioral_activation.obj1": "Aumentar las actividades agradables y gratificantes",
  "exerciseData.behavioral_activation.obj2": "Romper el ciclo de evitación e inactividad",
  "exerciseData.behavioral_activation.obj3": "Mejorar el estado de ánimo a través de la acción",
  "exerciseData.behavioral_activation.obj4": "Desarrollar una rutina diaria equilibrada",
  "exerciseData.behavioral_activation.explanation": "La activación conductual se basa en el principio de que nuestros comportamientos influyen directamente en nuestro estado de ánimo. Cuando nos sentimos deprimidos, tendemos a aislarnos y evitar actividades, lo que agrava el estado emocional. Al planificar progresivamente actividades significativas, podemos revertir este ciclo negativo.",
  "exerciseData.behavioral_activation.foundation": "Jacobson et al. — Activación conductual (1996)",

  "exerciseData.mood_tracking.title": "Seguimiento del estado de ánimo",
  "exerciseData.mood_tracking.obj1": "Tomar conciencia de sus estados emocionales",
  "exerciseData.mood_tracking.obj2": "Identificar patrones y detonantes emocionales",
  "exerciseData.mood_tracking.obj3": "Medir la evolución del estado de ánimo a lo largo del tiempo",
  "exerciseData.mood_tracking.obj4": "Facilitar la comunicación con el terapeuta",
  "exerciseData.mood_tracking.explanation": "El seguimiento diario del estado de ánimo es una herramienta esencial de la TCC. Al anotar regularmente su nivel de ánimo y sus emociones, desarrolla una mejor conciencia emocional. Esto permite identificar patrones, detonantes recurrentes y medir objetivamente sus progresos durante la terapia.",
  "exerciseData.mood_tracking.foundation": "Beck et al. — Auto-monitoreo en TCC (1979)",

  "exerciseData.pomodoro.title": "Técnica Pomodoro",
  "exerciseData.pomodoro.obj1": "Mejorar la concentración y la productividad",
  "exerciseData.pomodoro.obj2": "Reducir la procrastinación y la ansiedad asociada a las tareas",
  "exerciseData.pomodoro.obj3": "Aprender a gestionar el tiempo de forma eficaz",
  "exerciseData.pomodoro.obj4": "Integrar pausas regulares para el bienestar",
  "exerciseData.pomodoro.explanation": "La técnica Pomodoro divide el trabajo en intervalos de concentración (25 minutos) seguidos de pausas cortas. Este método es especialmente útil en TCC para pacientes con ansiedad de rendimiento o procrastinación, ya que hace las tareas menos intimidantes al dividirlas en segmentos manejables.",
  "exerciseData.pomodoro.foundation": "Francesco Cirillo — Técnica Pomodoro (años 1980)",

  "exerciseData.cognitive_defusion.title": "Defusión cognitiva",
  "exerciseData.cognitive_defusion.obj1": "Distanciarse de sus pensamientos negativos",
  "exerciseData.cognitive_defusion.obj2": "Reducir el impacto emocional de los pensamientos",
  "exerciseData.cognitive_defusion.obj3": "Observar sus pensamientos sin identificarse con ellos",
  "exerciseData.cognitive_defusion.obj4": "Desarrollar una flexibilidad psicológica",
  "exerciseData.cognitive_defusion.explanation": "La defusión cognitiva es una técnica de la terapia de aceptación y compromiso (ACT). En lugar de intentar cambiar el contenido de los pensamientos, nos enseña a modificar nuestra relación con ellos. El objetivo es ver los pensamientos como simples eventos mentales, y no como verdades absolutas.",
  "exerciseData.cognitive_defusion.foundation": "Steven Hayes — ACT y defusión cognitiva (1999)",

  "exerciseData.meditation.title": "Meditación de atención plena",
  "exerciseData.meditation.obj1": "Desarrollar la atención al momento presente",
  "exerciseData.meditation.obj2": "Reducir el estrés y la ansiedad",
  "exerciseData.meditation.obj3": "Mejorar la regulación emocional",
  "exerciseData.meditation.obj4": "Cultivar una actitud de no-juicio",
  "exerciseData.meditation.explanation": "La meditación de atención plena consiste en prestar atención intencionada al momento presente, sin juzgar. Integrada a la TCC en forma de MBCT (Terapia Cognitiva Basada en Mindfulness), ayuda a prevenir recaídas depresivas y a gestionar mejor la ansiedad desarrollando una conciencia desprendida de sus pensamientos y emociones.",
  "exerciseData.meditation.foundation": "Jon Kabat-Zinn — MBSR (1979) / Segal, Williams, Teasdale — MBCT (2002)",

  "exerciseData.gratitude.title": "Diario de gratitud",
  "exerciseData.gratitude.obj1": "Orientar la atención hacia los aspectos positivos",
  "exerciseData.gratitude.obj2": "Contrarrestar el sesgo de negatividad natural",
  "exerciseData.gratitude.obj3": "Aumentar el bienestar subjetivo",
  "exerciseData.gratitude.obj4": "Reforzar las relaciones sociales positivas",
  "exerciseData.gratitude.explanation": "El diario de gratitud es un ejercicio de psicología positiva integrado en la TCC. Al anotar regularmente las cosas por las que está agradecido/a, entrena su cerebro para notar más los aspectos positivos de su vida. Esto ayuda a contrarrestar la tendencia natural del cerebro a centrarse en lo negativo.",
  "exerciseData.gratitude.foundation": "Robert Emmons — Investigación sobre la gratitud (2003)",

  "exerciseData.self_compassion.title": "Autocompasión",
  "exerciseData.self_compassion.obj1": "Desarrollar una actitud benévola hacia uno mismo",
  "exerciseData.self_compassion.obj2": "Reducir la autocrítica excesiva",
  "exerciseData.self_compassion.obj3": "Reforzar la resiliencia emocional",
  "exerciseData.self_compassion.obj4": "Aceptar sus imperfecciones con humanidad",
  "exerciseData.self_compassion.explanation": "La autocompasión implica tratarse con la misma benevolencia que ofrecería a un amigo querido que atraviesa una dificultad. Comprende tres componentes: la benevolencia hacia uno mismo, el reconocimiento de nuestra humanidad compartida, y la atención plena a nuestros sufrimientos sin identificarse excesivamente con ellos.",
  "exerciseData.self_compassion.foundation": "Kristin Neff — Autocompasión (2003)",

  "exerciseData.values_exploration.title": "Exploración de valores",
  "exerciseData.values_exploration.obj1": "Identificar sus valores fundamentales",
  "exerciseData.values_exploration.obj2": "Evaluar la alineación entre sus acciones y sus valores",
  "exerciseData.values_exploration.obj3": "Definir acciones concretas guiadas por sus valores",
  "exerciseData.values_exploration.obj4": "Dar sentido y dirección a su vida",
  "exerciseData.values_exploration.explanation": "La exploración de valores es un ejercicio clave de la ACT. Los valores son como una brújula que guía nuestras elecciones y acciones. A diferencia de los objetivos, nunca se alcanzan pero nos dan una dirección. Al clarificar lo que realmente importa para usted, puede tomar decisiones más alineadas con su ser profundo.",
  "exerciseData.values_exploration.foundation": "Russ Harris — ACT Made Simple (2009)",

  "exerciseData.needs_exploration.title": "Exploración de necesidades",
  "exerciseData.needs_exploration.obj1": "Identificar sus necesidades fundamentales no satisfechas",
  "exerciseData.needs_exploration.obj2": "Comprender la jerarquía de las necesidades humanas",
  "exerciseData.needs_exploration.obj3": "Evaluar el nivel de satisfacción de cada necesidad",
  "exerciseData.needs_exploration.obj4": "Planificar acciones para responder mejor a sus necesidades",
  "exerciseData.needs_exploration.explanation": "Basado en la pirámide de Maslow, este ejercicio le ayuda a evaluar en qué medida sus necesidades fundamentales están satisfechas. En TCC, comprender sus necesidades no satisfechas permite identificar las fuentes de malestar y definir acciones concretas para mejorar su calidad de vida en cada nivel.",
  "exerciseData.needs_exploration.foundation": "Abraham Maslow — Jerarquía de necesidades (1943)",

  "exerciseData.problem_solving.title": "Resolución de problemas",
  "exerciseData.problem_solving.obj1": "Estructurar el enfoque ante los problemas",
  "exerciseData.problem_solving.obj2": "Generar varias soluciones alternativas",
  "exerciseData.problem_solving.obj3": "Evaluar objetivamente las ventajas e inconvenientes",
  "exerciseData.problem_solving.obj4": "Elaborar un plan de acción concreto",
  "exerciseData.problem_solving.explanation": "La terapia de resolución de problemas es un enfoque estructurado que ayuda a enfrentar las dificultades de manera sistemática. Es especialmente útil cuando uno se siente abrumado o bloqueado. Al descomponer un problema complejo en pasos manejables, se recupera un sentimiento de control y competencia.",
  "exerciseData.problem_solving.foundation": "D'Zurilla & Goldfried — Problem-Solving Therapy (1971)",

  "exerciseData.qualities_exploration.title": "Exploración de cualidades",
  "exerciseData.qualities_exploration.obj1": "Reconocer y valorar sus cualidades personales",
  "exerciseData.qualities_exploration.obj2": "Contrarrestar la tendencia a centrarse en sus defectos",
  "exerciseData.qualities_exploration.obj3": "Reforzar la autoestima de manera realista",
  "exerciseData.qualities_exploration.obj4": "Identificar las cualidades a desarrollar más",
  "exerciseData.qualities_exploration.explanation": "Este ejercicio le ayuda a identificar y reconocer sus cualidades personales. En TCC, las personas con baja autoestima tienden a minimizar sus cualidades y amplificar sus defectos. Al documentar concretamente sus cualidades con ejemplos, construye una imagen de sí mismo/a más equilibrada y realista.",
  "exerciseData.qualities_exploration.foundation": "Christine Padesky — Modelo de resiliencia basado en las fortalezas (2012)",

  "exerciseData.capabilities_exploration.title": "Exploración de competencias",
  "exerciseData.capabilities_exploration.obj1": "Inventariar sus competencias en diferentes ámbitos",
  "exerciseData.capabilities_exploration.obj2": "Reconocer sus niveles de dominio",
  "exerciseData.capabilities_exploration.obj3": "Identificar las competencias a desarrollar",
  "exerciseData.capabilities_exploration.obj4": "Reforzar el sentimiento de autoeficacia",
  "exerciseData.capabilities_exploration.explanation": "La exploración de competencias ayuda a elaborar un inventario realista de lo que sabe hacer. El sentimiento de autoeficacia — la creencia en su capacidad para realizar tareas — es un factor clave del bienestar psicológico. Al identificar sus competencias y planificar su desarrollo, refuerza su confianza en sí mismo/a.",
  "exerciseData.capabilities_exploration.foundation": "Albert Bandura — Autoeficacia (1977)",

  "exerciseData.assertiveness.title": "Comunicación asertiva",
  "exerciseData.assertiveness.obj1": "Identificar su estilo de comunicación habitual",
  "exerciseData.assertiveness.obj2": "Aprender la técnica DESC para afirmarse",
  "exerciseData.assertiveness.obj3": "Expresar sus necesidades respetando a los demás",
  "exerciseData.assertiveness.obj4": "Desarrollar relaciones interpersonales más sanas",
  "exerciseData.assertiveness.explanation": "La asertividad es la capacidad de expresar sus necesidades, opiniones y emociones de manera directa y respetuosa. La técnica DESC (Describir, Expresar, Especificar, Consecuencias) es una herramienta estructurada para formular mensajes asertivos. Es especialmente útil en situaciones de conflicto o cuando cuesta establecer límites.",
  "exerciseData.assertiveness.foundation": "Sharon Anthony Bower — Asserting Yourself (1976)",

  "exerciseData.self_reinforcement.title": "Autorrefuerzo",
  "exerciseData.self_reinforcement.obj1": "Reconocer y celebrar sus logros",
  "exerciseData.self_reinforcement.obj2": "Desarrollar un sistema de recompensas saludables",
  "exerciseData.self_reinforcement.obj3": "Reforzar los comportamientos positivos",
  "exerciseData.self_reinforcement.obj4": "Aumentar la motivación intrínseca",
  "exerciseData.self_reinforcement.explanation": "El autorrefuerzo se basa en los principios del condicionamiento operante. Al recompensarse tras cumplir una tarea difícil o adoptar un comportamiento positivo, aumenta la probabilidad de reproducir ese comportamiento. Es una herramienta poderosa para mantener la motivación y construir nuevos hábitos.",
  "exerciseData.self_reinforcement.foundation": "B.F. Skinner — Refuerzo positivo (1938)",

  "exerciseData.cognitive_restructuring.title": "Reestructuración cognitiva",
  "exerciseData.cognitive_restructuring.obj1": "Identificar los esquemas de pensamiento disfuncionales",
  "exerciseData.cognitive_restructuring.obj2": "Cuestionar las creencias irracionales",
  "exerciseData.cognitive_restructuring.obj3": "Desarrollar pensamientos más realistas y adaptados",
  "exerciseData.cognitive_restructuring.obj4": "Reducir los síntomas ansiosos y depresivos",
  "exerciseData.cognitive_restructuring.explanation": "La reestructuración cognitiva es el núcleo de la TCC. Consiste en identificar los pensamientos automáticos negativos y los esquemas cognitivos disfuncionales, luego examinarlos críticamente para desarrollar alternativas más realistas y adaptadas. Este proceso modifica progresivamente las creencias fundamentales que mantienen el sufrimiento psicológico.",
  "exerciseData.cognitive_restructuring.foundation": "Aaron Beck — Tríada cognitiva y esquemas (1979)",

  // === Meditation guided exercises (instructions) ===
  "meditation.breathing.inst1": "Siéntese cómodamente con la espalda recta",
  "meditation.breathing.inst2": "Cierre suavemente los ojos",
  "meditation.breathing.inst3": "Inspire lentamente por la nariz, contando hasta 4",
  "meditation.breathing.inst4": "Mantenga la respiración durante 4 segundos",
  "meditation.breathing.inst5": "Expire lentamente por la boca, contando hasta 6",
  "meditation.breathing.inst6": "Repita este ciclo durante 5 minutos",
  "meditation.bodyScan.inst1": "Acuéstese cómodamente",
  "meditation.bodyScan.inst2": "Cierre los ojos y respire profundamente",
  "meditation.bodyScan.inst3": "Lleve la atención a sus pies, observe las sensaciones",
  "meditation.bodyScan.inst4": "Suba gradualmente: tobillos, pantorrillas, rodillas...",
  "meditation.bodyScan.inst5": "Continúe hasta la parte superior de la cabeza",
  "meditation.bodyScan.inst6": "Termine tomando conciencia de todo su cuerpo",
  "meditation.gratitudeMed.inst1": "Póngase cómodo/a",
  "meditation.gratitudeMed.inst2": "Tome tres respiraciones profundas",
  "meditation.gratitudeMed.inst3": "Piense en tres cosas por las que está agradecido/a",
  "meditation.gratitudeMed.inst4": "Sienta la gratitud en su corazón",
  "meditation.gratitudeMed.inst5": "Visualice estos momentos positivos",
  "meditation.gratitudeMed.inst6": "Termine con una sonrisa interior",
  "meditation.innerCalm.inst1": "Encuentre un lugar tranquilo",
  "meditation.innerCalm.inst2": "Siéntese en una posición cómoda",
  "meditation.innerCalm.inst3": "Concéntrese en su respiración natural",
  "meditation.innerCalm.inst4": "Deje pasar sus pensamientos como nubes",
  "meditation.innerCalm.inst5": "No juzgue, solo observe",
  "meditation.innerCalm.inst6": "Vuelva suavemente a su respiración si se pierde",
  "meditation.sleepPrep.inst1": "Acuéstese en su cama",
  "meditation.sleepPrep.inst2": "Cierre los ojos y relaje la mandíbula",
  "meditation.sleepPrep.inst3": "Suelte toda la tensión de los hombros",
  "meditation.sleepPrep.inst4": "Imagine una luz suave que le envuelve",
  "meditation.sleepPrep.inst5": "Cada respiración le relaja más",
  "meditation.sleepPrep.inst6": "Déjese llevar hacia el sueño",

  // === Psychoeducation: CBT Model ===
  "psycho.cbt.title": "El Modelo de la TCC",
  "psycho.cbt.subtitle": "Terapias Cognitivas y Conductuales",
  "psycho.cbt.desc": "Comprender el vínculo entre pensamientos, emociones y comportamientos",
  "psycho.cbt.s1t": "Introducción a las TCC",
  "psycho.cbt.s1c": "Las Terapias Cognitivas y Conductuales (TCC) son un conjunto de tratamientos psicológicos validados científicamente, recomendados por la Alta Autoridad de Salud (HAS) y la Organización Mundial de la Salud (OMS). Desarrolladas en los años 1960 por Aaron Beck y Albert Ellis, se basan en un principio fundamental: nuestros pensamientos influyen en nuestras emociones, que a su vez influyen en nuestros comportamientos. Este círculo puede ser virtuoso o vicioso. A diferencia de las terapias analíticas, las TCC se concentran en el presente, son estructuradas, y apuntan a objetivos concretos. El terapeuta y el paciente trabajan en colaboración activa, como un equipo. Las TCC han demostrado su eficacia en el tratamiento de la depresión, de los trastornos ansiosos, de las fobias, del TOC, del TEPT, de los trastornos alimentarios y de numerosas otras patologías.",
  "psycho.cbt.s2t": "El triángulo cognitivo",
  "psycho.cbt.s2c": "El modelo central de la TCC es el « triángulo cognitivo » que ilustra la interacción entre tres componentes: los pensamientos (cogniciones), las emociones y los comportamientos. He aquí cómo funciona: una situación desencadena pensamientos automáticos, que generan emociones, que provocan comportamientos. Ejemplo concreto: su amigo no responde a su mensaje (situación) -> « Me tiene rencor, no cuento para él » (pensamiento automático) -> ansiedad, tristeza (emociones) -> usted envía 10 mensajes seguidos o no lo vuelve a contactar (comportamiento). En TCC, se aprende a intervenir en cada vértice de este triángulo. Se puede modificar el pensamiento (reestructuración cognitiva), regular la emoción (técnicas de relajación) o cambiar el comportamiento (activación conductual). Modificar un solo elemento impacta a los otros dos.",
  "psycho.cbt.s3t": "Las distorsiones cognitivas",
  "psycho.cbt.s3c": "Aaron Beck identificó errores de razonamiento recurrentes llamados « distorsiones cognitivas ». No son mentiras deliberadas, sino filtros automáticos que deforman nuestra percepción de la realidad. Las principales distorsiones son: (1) Pensamiento todo-o-nada: ver las cosas en blanco o negro, sin matiz (« Si no es perfecto, es malo »). (2) Catastrofización: imaginar el peor escenario posible (« Si fallo en este examen, mi vida está arruinada »). (3) Sobregeneralización: sacar una conclusión general de un solo evento (« Fallé en esta cita, siempre fallo en todo »). (4) Lectura de pensamientos: suponer lo que otros piensan sin prueba (« Él piensa que soy incompetente »). (5) Descalificación de lo positivo: rechazar las experiencias positivas (« Me felicitaron por cortesía »). Reconocer estos sesgos es el primer paso para corregirlos.",
  "psycho.cbt.s4t": "Las tres olas de la TCC",
  "psycho.cbt.s4c": "La TCC ha evolucionado en tres olas sucesivas, cada una enriqueciendo a la precedente. La 1ª ola (años 1950-60) es conductual: se concentra en los comportamientos observables, el condicionamiento (Pavlov, Skinner) y las técnicas de exposición. La 2ª ola (años 1960-80) integra la cognición gracias a los trabajos de Beck y Ellis: se interesa por los pensamientos automáticos, los esquemas cognitivos y la reestructuración cognitiva. La 3ª ola (años 2000 hasta hoy) añade la aceptación, la atención plena y los valores. Incluye la ACT (Terapia de Aceptación y Compromiso de Hayes), la MBCT (Terapia Cognitiva basada en la Atención Plena), y la terapia de esquemas de Young. Esta última ola ya no busca controlar los pensamientos negativos sino modificar nuestra relación con ellos.",
  "psycho.cbt.q1q": "¿Cuál es el principio fundamental de la TCC?",
  "psycho.cbt.q1a": "Nuestros comportamientos están determinados únicamente por nuestra infancia",
  "psycho.cbt.q1b": "Nuestros pensamientos influyen en nuestras emociones y comportamientos",
  "psycho.cbt.q1c": "Las emociones son incontrolables",
  "psycho.cbt.q1d": "Solo los medicamentos pueden tratar los trastornos psicológicos",
  "psycho.cbt.q1e": "La TCC se basa en la idea de que nuestros pensamientos influyen en nuestras emociones y comportamientos, y que al modificar nuestros patrones de pensamiento, podemos cambiar nuestras respuestas emocionales y conductuales.",
  "psycho.cbt.q2q": "¿Qué es una distorsión cognitiva?",
  "psycho.cbt.q2a": "Un trastorno neurológico",
  "psycho.cbt.q2b": "Un error de razonamiento recurrente que distorsiona la realidad",
  "psycho.cbt.q2c": "Una mentira deliberada",
  "psycho.cbt.q2d": "Un síntoma de esquizofrenia",
  "psycho.cbt.q2e": "Las distorsiones cognitivas son sesgos sistemáticos en el procesamiento de la información, no mentiras deliberadas. Todos las tenemos, pero en exceso mantienen el sufrimiento psicológico.",

  // === Psychoeducation: Anxiety ===
  "psycho.anx.title": "Modelo Cognitivo de la Ansiedad",
  "psycho.anx.subtitle": "Comprender y gestionar la ansiedad",
  "psycho.anx.desc": "Los mecanismos cognitivos que mantienen la ansiedad",
  "psycho.anx.s1t": "¿Qué es la ansiedad?",
  "psycho.anx.s1c": "Según Aaron Beck (1976), la ansiedad no es causada directamente por las situaciones mismas, sino por nuestra interpretación de estas situaciones. El modelo cognitivo de la ansiedad se basa en un doble sesgo: una sobreestimación sistemática del peligro («Es muy peligroso») y una subestimación de las propias capacidades para hacerle frente («No voy a lograrlo»). Este desequilibrio entre amenaza percibida y recursos percibidos crea el estado ansioso. Por ejemplo, para un examen: una persona ansiosa pensará «Voy a fallar todo, las preguntas serán imposibles» (sobreestimación) mientras piensa «Soy incapaz de prepararme correctamente» (subestimación).",
  "psycho.anx.s2t": "El círculo vicioso de la ansiedad",
  "psycho.anx.s2c": "Las personas ansiosas desarrollan «esquemas de peligro»: estructuras cognitivas profundas centradas en la vulnerabilidad y la amenaza, formadas a menudo durante la infancia (sobreprotección parental, experiencias traumáticas, aprendizaje vicario). Estos esquemas funcionan como filtros: un evento neutro es automáticamente interpretado como amenazante. Por ejemplo, una mirada de un colega será percibida como juicio, un pequeño retraso será interpretado como una señal de catástrofe inminente. Estos esquemas son selectivos: captan únicamente las informaciones que confirman el peligro e ignoran las señales de seguridad. Esto es lo que llamamos el sesgo atencional hacia la amenaza.",
  "psycho.anx.s3t": "Los pensamientos ansiosos",
  "psycho.anx.s3c": "La ansiedad se auto-mantiene por un círculo vicioso en 5 etapas: (1) Percepción de una amenaza (real o imaginada). (2) Activación fisiológica: el cuerpo se prepara para el peligro (aceleración cardíaca, transpiración, tensiones musculares, hiperventilación). (3) Interpretación catastrófica de las sensaciones: «¡Mi corazón late rápido, estoy teniendo un infarto!». (4) Aumento de la ansiedad y reforzamiento del esquema de peligro. (5) Comportamientos de evitación o de seguridad que procuran un alivio temporal pero impiden verificar que el peligro no era real. Este círculo vicioso está en el centro del trastorno de pánico, de la agorafobia y del trastorno de ansiedad generalizada.",
  "psycho.anx.s4t": "Estrategias de gestión",
  "psycho.anx.s4c": "Los pensamientos automáticos en la ansiedad tienen características específicas. A menudo comienzan con «¿Y si...?» (¿y si tengo una crisis de pánico? ¿y si me juzgan?). Sobrestiman tanto la probabilidad como la gravedad del escenario temido. Son rápidos, involuntarios y parecen totalmente creíbles en el momento. Las técnicas de la TCC para combatirlos incluyen: el cuestionamiento socrático («¿Cuál es la probabilidad real?»), la descentración («¿Qué le diría a un amigo?»), la técnica de la flecha descendente para identificar las creencias profundas, y la exposición graduada para probar las predicciones ansiosas en la realidad.",
  "psycho.anx.q1q": "¿Qué mantiene la ansiedad según el modelo cognitivo?",
  "psycho.anx.q1a": "Únicamente factores genéticos",
  "psycho.anx.q1b": "La sobreestimación del peligro y la subestimación de los recursos",
  "psycho.anx.q1c": "Comer demasiado azúcar",
  "psycho.anx.q1d": "Dormir poco",
  "psycho.anx.q1e": "Según Beck, la ansiedad se mantiene por un doble sesgo: sobreestimamos el peligro real de la situación y subestimamos nuestra capacidad para hacerle frente.",
  "psycho.anx.q2q": "¿Por qué los comportamientos de evitación refuerzan la ansiedad?",
  "psycho.anx.q2a": "Porque nos hace más valientes",
  "psycho.anx.q2b": "Porque impide que descubramos que podemos manejar la situación",
  "psycho.anx.q2c": "Porque aumenta la frecuencia cardíaca",
  "psycho.anx.q2d": "Porque nos hace dormir mal",
  "psycho.anx.q2e": "La evitación alivia a corto plazo pero impide el aprendizaje correctivo: nunca descubrimos que la situación temida era menos peligrosa de lo que pensábamos, ni que podíamos hacerle frente.",

  // === Psychoeducation: Depression ===
  "psycho.dep.title": "Modelo Cognitivo de la Depresión",
  "psycho.dep.subtitle": "Comprender los mecanismos depresivos",
  "psycho.dep.desc": "La tríada cognitiva de Beck y los esquemas depresivos",
  "psycho.dep.s1t": "La tríada cognitiva",
  "psycho.dep.s1c": "Aaron Beck (1967) identificó tres tipos de pensamientos negativos característicos de la depresión, que denominó la « tríada cognitiva ». (1) Visión negativa de sí mismo: « No sirvo para nada, no valgo nada, soy una carga para los demás ». (2) Visión negativa del mundo: « El mundo es injusto, nada va bien, nadie puede ayudarme ». (3) Visión negativa del futuro: « Nada mejorará nunca, es sin esperanza, para qué intentar ». Estos tres componentes se refuerzan mutuamente y crean un filtro negativo global a través del cual la persona deprimida interpreta toda su experiencia. La tríada cognitiva está en el corazón de la comprensión y del tratamiento de la depresión en TCC.",
  "psycho.dep.s2t": "Los esquemas depresivos",
  "psycho.dep.s2c": "Los esquemas depresógenos son creencias profundas y rígidas formadas desde la infancia a partir de las experiencias precoces (críticas parentales, rechazo, negligencia, pérdida). Permanecen latentes hasta ser activados por un evento estresante (pérdida de empleo, ruptura, fracaso). Ejemplos de esquemas: « No soy digno de ser amado » (esquema de incompetencia), « Si los otros me conocieran realmente, me rechazarían » (esquema de defectuosidad), « Debo ser perfecto para ser aceptable » (esquema de estándares elevados). Una vez activados, estos esquemas provocan un flujo de pensamientos automáticos negativos que confirman la tríada cognitiva. La terapia de esquemas de Jeffrey Young (1990) ha desarrollado técnicas específicas para modificar estas estructuras profundas.",
  "psycho.dep.s3t": "El ciclo de la depresión",
  "psycho.dep.s3c": "La depresión se auto-mantiene por un círculo vicioso poderoso: los pensamientos negativos (« No sirvo para nada, nada tiene sentido ») conllevan una baja de motivación y de energía, que provoca una reducción de las actividades (abandono del deporte, aislamiento social, negligencia de los pasatiempos). Esta inactividad priva a la persona de fuentes de placer y de logro, lo que « confirma » los pensamientos negativos (« Ya ves, no soy capaz de nada »). El aislamiento social reduce también el apoyo de los allegados. Este círculo puede ser roto por la activación conductual: retomar actividades agradables, incluso sin motivación inicial, para recrear experiencias positivas que contradigan los pensamientos negativos.",
  "psycho.dep.s4t": "Los pensamientos automáticos",
  "psycho.dep.s4c": "El tratamiento cognitivo de la depresión sigue una progresión estructurada. Fase 1: Psicoeducación y activación conductual - el paciente aprende el modelo y retoma actividades gratificantes. Fase 2: Identificación de los pensamientos automáticos - el paciente utiliza una tabla de pensamientos para detectar los pensamientos negativos recurrentes. Fase 3: Reestructuración cognitiva - los pensamientos automáticos son examinados como hipótesis, no como hechos. Se buscan las pruebas a favor y en contra, y se formulan pensamientos alternativos. Fase 4: Modificación de los esquemas profundos - el trabajo se centra en las creencias fundamentales. Los meta-análisis muestran que la TCC es tan eficaz como los antidepresivos para las depresiones leves a moderadas, con una tasa de recaída más baja a largo plazo.",
  "psycho.dep.q1q": "¿Cuáles son los tres elementos de la tríada cognitiva de Beck?",
  "psycho.dep.q1a": "Tres técnicas de relajación",
  "psycho.dep.q1b": "Una visión negativa de uno mismo, del mundo y del futuro",
  "psycho.dep.q1c": "Tres tipos de medicamentos antidepresivos",
  "psycho.dep.q1d": "Tres fases de la terapia",
  "psycho.dep.q1e": "La tríada cognitiva de Beck describe cómo la persona deprimida ve negativamente a sí misma, al mundo que la rodea y a su futuro. Esta triple perspectiva negativa mantiene el estado depresivo.",
  "psycho.dep.q2q": "¿Cómo la activación conductual ayuda contra la depresión?",
  "psycho.dep.q2a": "Recetando medicamentos",
  "psycho.dep.q2b": "Rompiendo el ciclo de inactividad y aumentando experiencias positivas",
  "psycho.dep.q2c": "Eliminando todos los pensamientos negativos",
  "psycho.dep.q2d": "Evitando todas las situaciones difíciles",
  "psycho.dep.q2e": "La activación conductual rompe el ciclo depresivo aumentando progresivamente las actividades gratificantes, lo que genera experiencias positivas que contrarrestan los pensamientos negativos.",

  // === Psychoeducation: Conditioning ===
  "psycho.cond.title": "Condicionamiento y Aprendizaje",
  "psycho.cond.subtitle": "Los fundamentos conductuales de la TCC",
  "psycho.cond.desc": "Comprender cómo se aprenden y desaprenden los comportamientos",
  "psycho.cond.s1t": "El condicionamiento clásico",
  "psycho.cond.s1c": "Ivan Pavlov (1849-1936) descubrió el condicionamiento clásico al estudiar la salivación de los perros. Principio: cuando un estímulo neutro (una campana) se asocia de manera repetida con un estímulo incondicional (comida), el estímulo neutro termina por desencadenar solo la respuesta (salivación). En psicopatología, este mecanismo explica la adquisición de las fobias y del TEPT: un evento traumatizante (accidente de coche) asocia el miedo a estímulos neutros (coches, carreteras). Posteriormente, estos estímulos desencadenan solos la respuesta de miedo. El caso del «Pequeño Albert» (Watson, 1920) demostró experimentalmente que las fobias podían ser adquiridas por condicionamiento clásico, abriendo el camino a los tratamientos por exposición.",
  "psycho.cond.s2t": "El condicionamiento operante",
  "psycho.cond.s2c": "B.F. Skinner (1904-1990) mostró que los comportamientos son moldeados por sus consecuencias. Cuatro mecanismos clave: (1) Refuerzo positivo: agregar algo agradable para aumentar un comportamiento (elogio después de un esfuerzo). (2) Refuerzo negativo: retirar algo desagradable para aumentar un comportamiento (la evitación alivia la ansiedad, por lo que evitamos más). (3) Castigo positivo: agregar algo desagradable para disminuir un comportamiento (crítica después de un error). (4) Castigo negativo: retirar algo agradable para disminuir un comportamiento (retirar un privilegio). El refuerzo negativo es el mecanismo más importante en psicopatología porque explica el mantenimiento de los comportamientos de evitación en la ansiedad.",
  "psycho.cond.s3t": "El aprendizaje social",
  "psycho.cond.s3c": "El tratamiento de las fobias y del TEPT por exposición progresiva deriva directamente de los principios de Pavlov. El principio: cuando se expone repetitivamente a una persona al estímulo temido sin que la consecuencia negativa se produzca, la asociación miedo-estímulo se debilita progresivamente. Es la extinción. La exposición puede ser: in vivo (situación real), en imaginación, en realidad virtual, o interoceptiva (para el trastorno de pánico - se provocan las sensaciones físicas temidas). La clave del éxito es permanecer en la situación el tiempo suficiente para que la ansiedad disminuya naturalmente (habituación). La huida o la evitación durante la exposición refuerza el miedo. La exposición es uno de los tratamientos más eficaces en psicoterapia, con tasas de éxito del 70-90% para las fobias específicas.",
  "psycho.cond.s4t": "Aplicaciones en TCC",
  "psycho.cond.s4c": "La evitación es el mecanismo central que mantiene la ansiedad, y funciona por refuerzo negativo. Aquí está la trampa: cuando evitamos una situación ansiógena, sentimos un alivio inmediato (la ansiedad baja). Este alivio «recompensa» al cerebro y refuerza el comportamiento de evitación. El problema: nunca tenemos la oportunidad de verificar que la situación no es realmente peligrosa. La evitación se extiende progresivamente: primero evitamos el ascensor, luego los pisos altos, luego los edificios, luego ya no salimos de casa. Este fenómeno de «generalización de la evitación» puede llevar a la agorafobia severa. En TCC, invertimos este mecanismo por la exposición graduada, enfrentando progresivamente las situaciones evitadas.",
  "psycho.cond.q1q": "¿Por qué la evitación mantiene la ansiedad?",
  "psycho.cond.q1a": "Porque fortalece los músculos",
  "psycho.cond.q1b": "Porque el alivio temporal refuerza el comportamiento de evitación (refuerzo negativo)",
  "psycho.cond.q1c": "Porque requiere mucha energía",
  "psycho.cond.q1d": "Porque es visible para los demás",
  "psycho.cond.q1e": "La evitación se mantiene por refuerzo negativo: el alivio inmediato que sentimos al evitar es una recompensa que fortalece el comportamiento de evitación, impidiendo la extinción del miedo.",
  "psycho.cond.q2q": "¿Qué es la extinción en condicionamiento clásico?",
  "psycho.cond.q2a": "La desaparición de una especie animal",
  "psycho.cond.q2b": "La reducción progresiva de una respuesta cuando el estímulo se presenta sin consecuencia negativa",
  "psycho.cond.q2c": "Un castigo severo",
  "psycho.cond.q2d": "Una técnica de relajación",
  "psycho.cond.q2e": "La extinción ocurre cuando un estímulo condicionado se presenta repetidamente sin la consecuencia negativa esperada, lo que reduce gradualmente la respuesta de miedo. Es el principio base de la exposición.",

  // === Psychoeducation: Darwin (Emotions) ===
  "psycho.darwin.title": "Las Emociones Universales",
  "psycho.darwin.subtitle": "Darwin y la función de las emociones",
  "psycho.darwin.desc": "El papel adaptativo de las emociones en la supervivencia humana",
  "psycho.darwin.s1t": "Las emociones básicas",
  "psycho.darwin.s1c": "En su obra « La Expresión de las emociones en el hombre y los animales » (1872), Charles Darwin propuso que las emociones básicas son universales, biológicamente programadas y compartidas por todos los seres humanos, cualquiera que sea su cultura. Las expresiones faciales de la alegría, la tristeza, la ira, el miedo, el asco y la sorpresa son idénticas en todo el mundo. Paul Ekman (1971) confirmó esta teoría estudiando pueblos aislados de Nueva Guinea que nunca habían tenido contacto con la civilización occidental: expresaban y reconocían las mismas emociones básicas. Esta universalidad indica que las emociones tienen raíces biológicas profundas, heredadas de nuestros ancestros, y no son simples construcciones culturales.",
  "psycho.darwin.s2t": "La función del miedo",
  "psycho.darwin.s2c": "Para Darwin, cada emoción ha evolucionado para cumplir una función específica de supervivencia. El miedo moviliza el organismo para huir o paralizarse ante el peligro (respuesta fight-flight-freeze). La ira da la energía para defenderse y proteger su territorio. El asco protege de la ingestión de sustancias tóxicas o de la contaminación por enfermedades. La tristeza señala la pérdida y atrae el apoyo social de los cercanos. La alegría refuerza los comportamientos benéficos y favorece los vínculos sociales. La sorpresa prepara el organismo para procesar rápidamente un evento inesperado. Incluso las emociones que consideramos como « negativas » son en realidad herramientas de adaptación esenciales. El problema no es la emoción en sí misma, sino su intensidad o su duración cuando se vuelve desproporcionada en relación a la situación.",
  "psycho.darwin.s3t": "La función de la tristeza",
  "psycho.darwin.s3c": "Se distinguen 6 emociones primarias (o básicas): alegría, tristeza, ira, miedo, asco y sorpresa. Son innatas, rápidas, automáticas y universales. Las emociones secundarias (o complejas) son combinaciones de emociones primarias enriquecidas por la cognición y el aprendizaje social. Ejemplos: la vergüenza (miedo + tristeza + cognición social), la culpabilidad (tristeza + ira hacia uno mismo), el orgullo (alegría + autoestima), los celos (miedo + ira + apego), la nostalgia (alegría + tristeza). Robert Plutchik (1980) propuso la « rueda de las emociones » que ilustra cómo las emociones primarias se combinan para formar emociones más complejas, como los colores primarios crean nuevos matices. En TCC, es crucial aprender a identificar y nombrar precisamente sus emociones (granularidad emocional) porque esto permite regularlas mejor.",
  "psycho.darwin.s4t": "Regulación emocional en TCC",
  "psycho.darwin.s4c": "El enfoque evolucionista de Darwin tiene implicaciones terapéuticas fundamentales. (1) Normalizar las emociones: el objetivo de la TCC no es eliminar las emociones « negativas » (que son normales y útiles) sino reducir su intensidad cuando se vuelven desproporcionadas. Tener miedo en un avión es normal; no poder tomar más el avión es un problema. (2) Distinguir emoción y pensamiento: las emociones son respuestas automáticas del cuerpo (latidos del corazón, tensión muscular). Los pensamientos son la interpretación que hacemos de ellos. En TCC, se trabaja sobre los pensamientos para modificar la respuesta emocional. (3) Desarrollar la inteligencia emocional: aprender a identificar, nombrar, aceptar y regular sus emociones es una competencia clave enseñada en TCC. La investigación muestra que simplemente nombrar una emoción (« affect labeling ») reduce su intensidad.",
  "psycho.darwin.q1q": "¿Cuál es la función del miedo según Darwin?",
  "psycho.darwin.q1a": "Castigarnos por nuestros errores",
  "psycho.darwin.q1b": "Protegernos de los peligros activando la respuesta de supervivencia",
  "psycho.darwin.q1c": "Mecanismos de supervivencia que tienen una función adaptativa",
  "psycho.darwin.q1d": "Hacernos más inteligentes",
  "psycho.darwin.q1e": "El miedo tiene una función adaptativa: nos protege de los peligros preparando al cuerpo para luchar o huir. Es una emoción de supervivencia esencial.",
  "psycho.darwin.q2q": "¿Cuántas emociones básicas universales identificó Ekman?",
  "psycho.darwin.q2a": "Tres",
  "psycho.darwin.q2b": "Seis (alegría, tristeza, miedo, ira, asco, sorpresa)",
  "psycho.darwin.q2c": "6 (alegría, tristeza, ira, miedo, asco, sorpresa)",
  "psycho.darwin.q2d": "Dos (positiva y negativa)",
  "psycho.darwin.q2e": "Paul Ekman identificó seis emociones básicas universales: alegría, tristeza, miedo, ira, asco y sorpresa, reconocidas en todas las culturas del mundo.",

  // === Psychoeducation: Grey (Schemas) ===
  "psycho.grey.title": "Los Esquemas de Young",
  "psycho.grey.subtitle": "Terapia de esquemas",
  "psycho.grey.desc": "Comprender los esquemas precoces inadaptados y su influencia",
  "psycho.grey.s1t": "¿Qué es un esquema precoz?",
  "psycho.grey.s1c": "Jeffrey Alan Grey (1982) propuso una teoría neurobiológica de la personalidad basada en dos sistemas cerebrales fundamentales que regulan nuestro comportamiento frente a las recompensas y a los castigos. El BAS (Behavioral Activation System / Sistema de Activación Comportamental) nos impulsa hacia las recompensas, mientras que el BIS (Behavioral Inhibition System / Sistema de Inhibición Comportamental) nos frena ante las amenazas. Cada individuo posee un equilibrio único entre estos dos sistemas, lo que explica las diferencias de temperamento y de vulnerabilidad a los trastornos psicológicos. Esta teoría es uno de los modelos más influyentes en psicología de la personalidad.",
  "psycho.grey.s2t": "Los dominios de esquemas",
  "psycho.grey.s2c": "El BAS se activa por las señales de recompensa, de no-castigo y de evasión del castigo. Neurobiológicamente, está asociado a las vías dopaminérgicas (circuito de la recompensa). Cuando el BAS se activa, genera emociones positivas (esperanza, entusiasmo, anticipación del placer) y comportamientos de aproximación y de búsqueda activa. Un BAS muy reactivo está asociado a la extraversión, el optimismo y la toma de riesgos. En cambio, un BAS hipoactivo puede contribuir a la depresión (anhedonia, pérdida de motivación, ausencia de placer). La activación comportamental en TCC busca justamente reestimular el BAS en las personas deprimidas.",
  "psycho.grey.s3t": "Los modos de afrontamiento",
  "psycho.grey.s3c": "El BIS se activa por las señales de castigo, de no-recompensa, de novedad y de estímulos innatos de miedo. Está asociado al circuito septohipocámpico y a la serotonina. Cuando el BIS se activa, produce una inhibición del comportamiento en curso, un aumento de la vigilancia y de la atención, y una activación fisiológica (arousal). Emocionalmente, esto se traduce en ansiedad y aprensión. Un BIS hiperactivo está fuertemente asociado al neuroticismo, a la ansiedad crónica, a las fobias y al trastorno de ansiedad generalizada. Los ansiolíticos (benzodiazepinas) actúan reduciendo la actividad del BIS, lo que confirma el modelo de Grey.",
  "psycho.grey.s4t": "Aplicaciones terapéuticas",
  "psycho.grey.s4c": "El modelo de Grey tiene implicaciones terapéuticas directas. Para la depresión (BAS hipoactivo): la activación comportamental busca aumentar los comportamientos de aproximación y las experiencias de recompensa para reestimular el BAS. Para la ansiedad (BIS hiperactivo): la exposición gradual busca reducir la sensibilidad del BIS a los estímulos amenazantes. Para las adicciones (BAS hiperactivo): el trabajo se centra en la regulación de la impulsividad y la búsqueda de recompensas saludables. Comprender su perfil BAS/BIS ayuda al paciente a entender mejor sus reacciones automáticas y a desarrollar estrategias adaptadas. Un cuestionario (BIS/BAS Scales de Carver & White, 1994) permite evaluar su propio perfil.",
  "psycho.grey.q1q": "¿Qué es un esquema precoz inadaptado?",
  "psycho.grey.q1a": "Un plan de estudio escolar",
  "psycho.grey.q1b": "Un patrón disfuncional formado en la infancia que influye en toda la vida",
  "psycho.grey.q1c": "Un diagnóstico médico",
  "psycho.grey.q1d": "Un tipo de medicamento",
  "psycho.grey.q1e": "Un esquema precoz inadaptado es un patrón profundo compuesto de recuerdos, emociones y cogniciones formado en la infancia que se reactiva a lo largo de la vida y mantiene el sufrimiento psicológico.",
  "psycho.grey.q2q": "¿Cuáles son las tres estrategias de afrontamiento según Young?",
  "psycho.grey.q2a": "Comer, dormir y hacer ejercicio",
  "psycho.grey.q2b": "Capitulación, evitación y sobrecompensación",
  "psycho.grey.q2c": "Meditación, yoga y respiración",
  "psycho.grey.q2d": "Pensamiento positivo, gratitud y humor",
  "psycho.grey.q2e": "Las tres estrategias de afrontamiento son: la capitulación (someterse al esquema), la evitación (huir) y la sobrecompensación (actuar de manera opuesta). Aunque dan alivio a corto plazo, mantienen el esquema a largo plazo.",

  // === Psychoeducation: Barkley ADHD ===
  "psycho.barkley.title": "Modelo de Barkley — TDAH",
  "psycho.barkley.subtitle": "Comprender el TDAH según Russell Barkley",
  "psycho.barkley.desc": "Un programa en 8 sesiones para ayudar a los padres de niños con TDAH a adaptar su marco educativo y restaurar una relación positiva.",
  "psycho.barkley.s1t": "Sesión 1 — Comprender el TDAH y el Programa Barkley",
  "psycho.barkley.s1c": "El TDAH (Trastorno por Déficit de Atención con o sin Hiperactividad) es un trastorno del neurodesarrollo frecuente (aproximadamente 1 niño por clase). No se debe a una «mala educación». Las dificultades provienen en gran parte de funciones ejecutivas frágiles:\n\n• Memoria de trabajo: el «post-it en la cabeza» que retiene la consigna.\n• Inhibición: el «freno» que impide decir o hacer inmediatamente lo que viene.\n• Flexibilidad: la capacidad de «cambiar de vía» cuando se debe pasar de una actividad a otra.\n\nEl programa Barkley es un coaching parental que le da estrategias concretas para disminuir los conflictos y restaurar una relación positiva. No lo juzga, lo entrena.\n\nEjercicio: Tarjeta de identidad del TDAH de su hijo — Enumere 3 a 5 situaciones frecuentes difíciles (deberes, comidas, acostarse…). Para cada situación, identifique el comportamiento observado, las funciones ejecutivas en juego, y lo que usted siente.",
  "psycho.barkley.s2t": "Sesión 2 — Restablecer la comunicación: los «Momentos Especiales»",
  "psycho.barkley.s2c": "Con un niño con TDAH, a menudo terminamos comunicándonos solo a través de los problemas. El objetivo es reinstalar momentos donde simplemente estén bien juntos.\n\n10 a 20 minutos de calidad todos los días, es más poderoso que una gran salida de vez en cuando.\n\nReglas del Momento Especial:\n• Un solo niño a la vez (exclusividad)\n• Nada de teléfono / televisión / tareas domésticas al mismo tiempo\n• Es el niño quien elige la actividad (dentro de un marco aceptable)\n• El padre describe, comenta, felicita, pero da el menor número de órdenes posible\n• Se evitan los temas que molestan (escuela, comportamiento…)\n\nAl final del momento, concluya con una frase positiva: «Me gustó mucho jugar contigo.»\n\nSeguimiento: Anote cada día si el momento tuvo lugar, la actividad, y el nivel de agrado (0-10) para usted y para el niño.",
  "psycho.barkley.s3t": "Sesión 3 — Aprender a dar consignas eficaces",
  "psycho.barkley.s3c": "Muchos conflictos provienen de una inadecuación entre la manera de dar las consignas y las capacidades atencionales del niño con TDAH.\n\nReglas básicas:\n1. Acercarse físicamente, ponerse a la altura del niño\n2. Captar la atención: ojos en los ojos, menos distracciones (pantalla apagada…)\n3. Formular la consigna: clara, corta, positiva («guarda tus zapatos» en lugar de «deja de dejar tirados tus zapatos»)\n4. Una sola consigna a la vez; si la tarea es compleja, dividirla en etapas\n5. Pedir al niño que repita la consigna («¿Puedes decirme qué debes hacer?»)\n6. Permanecer en el lugar unos segundos para ver si comienza\n\nEjemplo de transformación:\n«¡Puedes dejar de hacer cualquier cosa por la mañana!» → «Cuando suene el despertador, te vistes primero, luego vienes a desayunar.»\n\nEjercicio: Anote 5 frases que dice a menudo y reformúlelas para hacerlas más cortas, positivas y específicas.",
  "psycho.barkley.s4t": "Sesión 4 — Ayudar al niño a estar solo y respetar el lugar de cada uno",
  "psycho.barkley.s4c": "El objetivo es disminuir la sensación «nunca nos deja tranquilos» y desarrollar la autonomía del niño.\n\nEjercicio — Los «Tiempos en que papá/mamá está ocupado(a)»:\n1. Anuncie al niño lo que va a hacer («Voy a telefonear»)\n2. Precise lo que no debe hacer (venir a hablar, interrumpir)\n3. Proponga lo que puede hacer en su lugar (colorear, legos, lectura…)\n4. Al principio, regrese al cabo de 1 minuto para felicitar: «Gracias, no me molestaste, te ocupas bien solo.»\n5. Luego váyase y regrese al cabo de 3-5 minutos, etc.\n\nHerramienta práctica: Un pequeño reloj de arena o timer visual — «Cuando la arena esté abajo, puedes volver a hablarme.»\n\nCada día, elija 1 situación para entrenarse y alargue progresivamente la duración.",
  "psycho.barkley.s5t": "Sesión 5 — Implementar un sistema de puntos / fichas",
  "psycho.barkley.s5c": "El objetivo es pasar de los «recordatorios y gritos» a un sistema de refuerzo positivo estructurado.\n\nEtapas:\n1. Construir un cuadro con los días en columnas y los comportamientos dirigidos en filas (+ una fila BONUS)\n2. Elegir máximo 3 comportamientos para comenzar, formulados positivamente:\n   • «Vengo a la mesa tan pronto como me llaman»\n   • «Guardo mis cosas de la escuela en mi mochila por la noche»\n   • «Respeto el tiempo de pantalla decidido con mis padres»\n3. Definir las recompensas con el niño:\n   • Pequeñas recompensas diarias (elegir el dibujo animado, 10 min de juego con papá/mamá…)\n   • Grandes recompensas semanales (película en familia, pequeño objeto, actividad elegida)\n4. Tipo de cambio: 1 buena casilla = 1 punto, 10 puntos = 1 pequeña recompensa, 30 puntos = 1 grande\n5. En caso de fracaso: no humillar, simplemente no dar el punto, luego recordar la regla\n\nProbar el sistema durante 7 días sin modificar las reglas durante el proceso.",
  "psycho.barkley.s6t": "Sesión 6 — Manejar la ira y la oposición: Time-out / Aislamiento",
  "psycho.barkley.s6c": "La oposición es en parte normal en el desarrollo, pero exacerbada en el TDAH. El niño con TDAH a menudo está emocionalmente desbordado: el objetivo del time-out es crear un espacio de retorno a la calma, no castigar.\n\nProtocolo en 5 etapas:\n1. Prevención: consignas simples, marco estable, humor, evitar palabras humillantes\n2. Si la oposición comienza: acercarse, contacto visual, recordar la regla, proponer una alternativa\n3. Si la crisis aumenta: anunciar el tiempo de retiro («ahora estás muy enojado, vamos a hacer un tiempo de calma»), acompañar sin hablar demasiado\n4. Durante el time-out: no discutir a través de la puerta, volver solo por razones de seguridad\n5. Después de la crisis: hablar en frío, privilegiar la reparación en lugar del castigo (ordenar, limpiar, poner la mesa…)\n\nEjercicio: Construir un «Plan de manejo de crisis» personalizado en 3 columnas — señales de alerta, lo que haré sistemáticamente, lo que ya no haré.\n\nAuto-observación: después de cada crisis, anote el desencadenante, lo que hizo diferente, y lo que le gustaría mejorar.",
  "psycho.barkley.s7t": "Sesión 7 — Manejar los comportamientos en lugares públicos",
  "psycho.barkley.s7c": "El objetivo es generalizar los progresos hechos en casa hacia las tiendas, restaurantes, transportes, etc.\n\nLa «Salida Entrenamiento»:\n\nAntes de la salida:\n1. Elegir un lugar simple para comenzar (pequeña compra, paseo corto)\n2. Detenerse frente al lugar y recordar 3 reglas máximo («me quedo cerca de papá/mamá, no toco, no pido comprar cosas»)\n3. Pedir al niño que repita las reglas\n4. Anunciar la recompensa si las reglas son respetadas y la consecuencia si no\n\nDurante la salida:\n• Identificar desde la entrada un lugar posible de time-out (rincón tranquilo, banco…)\n• Multiplicar los cumplidos discretos («gracias por quedarte cerca de mí»)\n\nDespués de la salida:\n• Hacer un balance: «¿qué fue fácil? ¿difícil?»\n• Dar la recompensa rápidamente si las reglas han sido globalmente respetadas\n\nHaga 1 a 2 salidas entrenamiento por semana, incluso muy cortas.",
  "psycho.barkley.q1q": "Según Barkley, ¿cuál es el déficit central del TDAH?",
  "psycho.barkley.q1a": "Un déficit de inteligencia",
  "psycho.barkley.q1b": "Un déficit de inhibición conductual que afecta la autorregulación",
  "psycho.barkley.q1c": "Un déficit de memoria a largo plazo",
  "psycho.barkley.q1d": "Un déficit visual",
  "psycho.barkley.q1e": "Barkley sitúa el déficit de inhibición conductual en el centro del TDAH. Esta dificultad para inhibir respuestas impulsivas afecta en cascada a las funciones ejecutivas: memoria de trabajo, autorregulación emocional, planificación.",
  "psycho.barkley.q2q": "¿Por qué se recomiendan las instrucciones positivas con niños con TDAH?",
  "psycho.barkley.q2a": "Porque a los niños les gusta que les feliciten",
  "psycho.barkley.q2b": "Porque las instrucciones claras y positivas compensan el déficit de inhibición describiendo lo que se espera",
  "psycho.barkley.q2c": "Porque las instrucciones negativas son siempre ineficaces",
  "psycho.barkley.q2d": "Porque es una obligación legal",
  "psycho.barkley.q2e": "Los niños con TDAH tienen dificultades para inhibir las respuestas automáticas. Las instrucciones claras, cortas y formuladas en positivo les dicen exactamente lo que se espera, compensando parcialmente el déficit de autorregulación.",
  "psycho.barkley.q3q": "¿Cuál es la mejor forma de dar una instrucción a un niño con TDAH?",
  "psycho.barkley.q3a": "Gritar desde otra habitación para que escuche bien",
  "psycho.barkley.q3b": "Dar varias instrucciones a la vez para ganar tiempo",
  "psycho.barkley.q3c": "Acercarse, captar la atención, dar una instrucción corta y positiva",
  "psycho.barkley.q3d": "Escribir todas las instrucciones en un papel y dárselo al niño",
  "psycho.barkley.q3e": "Hay que acercarse físicamente, captar la atención (mirada a los ojos), formular una instrucción corta, clara y en positivo. Esto compensa el déficit de inhibición del niño con TDAH.",
  "psycho.barkley.q4q": "¿Cuál es el objetivo principal del time-out en el programa Barkley?",
  "psycho.barkley.q4a": "Castigar al niño para que entienda su error",
  "psycho.barkley.q4b": "Crear un espacio de retorno a la calma, no un castigo",
  "psycho.barkley.q4c": "Aislar al niño el mayor tiempo posible",
  "psycho.barkley.q4d": "Asustar al niño para que obedezca",
  "psycho.barkley.q4e": "El time-out es un espacio de retorno a la calma. El niño con TDAH a menudo se ve desbordado por sus emociones y necesita un lugar seguro para regularse, no un castigo.",
  "psycho.barkley.s8t": "Sesión 8 — Anticipar las recaídas y Plan de autoguía",
  "psycho.barkley.s8c": "El objetivo es aprender a analizar usted mismo los nuevos problemas que surgirán (nueva clase, adolescencia, nuevos contextos…).\n\nLa herramienta clave es el análisis ABC:\n• A — Antecedentes: lo que pasa justo antes (contexto, consigna, fatiga…)\n• B — Comportamiento: lo que el niño hace precisamente\n• C — Consecuencias: lo que hacen los adultos / lo que el niño obtiene (atención, evitación, ganancia de una pantalla…)\n\nPara cada problema:\n1. Completar 3 líneas ABC sobre episodios similares\n2. Identificar qué antecedentes pueden ser modificados\n3. Identificar qué consecuencias refuerzan involuntariamente el comportamiento\n4. Construir un mini plan de acción combinando las herramientas de las sesiones anteriores\n\nMensajes finales:\n• El comportamiento del niño depende mucho de los antecedentes y de las consecuencias inmediatas\n• El objetivo no es un niño «perfecto» sino reducir las crisis, mejorar la relación, y apaciguar el clima familiar\n• Usted progresa paso a paso — cada pequeño cambio cuenta.",

  // Navigation sidebar sections
  "nav.myBadges": "Mis Insignias",
  "nav.barkleyParent": "TDAH Ninos - Guia Parental",
  "nav.barkleyChild": "TDAH Ninos - Ejercicios (6-12 anos)",
  "nav.barkleyTeen": "Ejercicios para adolescentes (12-17 años)",
  "nav.tdahKidsWorkbook": "Cuaderno Galactico TDAH",
  "nav.psychoed": "Psicoeducacion",

  // Patient dashboard
  "patient.privacyBanner": "Tus ejercicios son privados por defecto. Despues de cada ejercicio, puedes elegir compartirlo con tu terapeuta.",
  "patient.manageSharing": "Gestionar mis compartidos",

  // Badges
  "badge.premier_pas": "Primer Paso",
  "badge.explorateur": "Explorador",
  "badge.super_heros_tdah": "Super-Heroe TDAH",
  "badge.gardien_jardin": "Guardian del Jardin",
  "badge.quiz_master": "Maestro del Quiz",
  "badge.regulier": "Constante",
  "badge.champion": "Campeon",
  "badge.collectionneur": "Coleccionista",
  "badge.genereux": "Generoso",
  "badge.earned": "Insignias ganadas",
  "badge.toUnlock": "Insignias por desbloquear",
  "badge.noBadges": "Todavia no tienes insignias",
  "badge.noBadgesDesc": "Completa ejercicios para desbloquear tus primeras insignias! Cada insignia representa una nueva etapa de tu camino.",

  // Parent Task Board
  "parentTask.title": "Tablero de Misiones",
  "parentTask.todayMissions": "Misiones del dia",
  "parentTask.totalMissions": "Misiones totales",
  "parentTask.badgesEarned": "Insignias ganadas",
  "parentTask.streak": "Dias seguidos",
  "parentTask.missionBadges": "Insignias de Mision",
  "parentTask.nextBadge": "Proxima insignia",
  "parentTask.apprentice": "Aprendiz Astronauta",
  "parentTask.pilot": "Piloto Espacial",
  "parentTask.commander": "Comandante Galactico",
  "parentTask.hero": "Heroe del Espacio",
  "parentTask.legend": "Leyenda Cosmica",
  "parentTask.master": "Maestro del Universo",
  "parentTask.subtitle": "Completa tus misiones para ganar insignias!",
  "parentTask.missionComplete": "Mision cumplida!",
  "parentTask.newBadge": "Nueva Insignia!",
  "parentTask.allDone": "Todas las misiones del dia estan completas!",
  "parentTask.addMission": "Anadir una mision...",
  "parentTask.thisWeek": "Esta semana",
  "parentTask.missions": "misiones",
  "parentTask.great": "Genial!",
  "badge.new": "Nuevo!",
  "badge.newBadgeUnlocked": "Nueva insignia desbloqueada!",
  "badge.newBadgesUnlocked": "{count} nuevas insignias desbloqueadas!",
  "common.viewAll": "Ver todo",
  "common.errorGeneric": "Error",
  "common.saving": "Guardando...",
  "checklist.title": "Checklist de la Manana",
  "checklist.myTasks": "Mis tareas de la manana",
  "checklist.dailyNotes": "Notas del dia",
  "checklist.notesPlaceholder": "Como fue tu manana? (opcional)",
  "checklist.saved": "Checklist guardado!",
  "checklist.errorSaving": "Error al guardar",
  "checklist.addTask": "Anadir una tarea...",
  "checklist.tasks": "tareas",
  "checklist.history": "Historial (ultimos 14 dias)",
  "checklist.noHistory": "Sin historial por el momento",
  "checklist.perfect": "Perfecto!",
  "checklist.great": "Muy bien!",
  "checklist.keepGoing": "Sigue asi!",
  "checklist.courage": "Animo!",
  "install.title": "Instalar Kintsugi TCC",
  "install.subtitle": "Acceso rapido desde tu pantalla de inicio",
  "install.howTo": "Como hacerlo",
  "install.install": "Instalar",
  "install.screenTitle": "Instalar en tu pantalla",
  "install.step1": "Pulsa el boton",
  "install.share": "Compartir",
  "install.step1b": "en la parte inferior de Safari",
  "install.step2": "Desplazate y pulsa",
  "install.addToHome": "En pantalla de inicio",
  "install.step3": "Pulsa",
  "install.add": "Anadir",
  "install.step3b": "en la parte superior derecha",
  "install.understood": "Entendido",

  // === Missing translations added ===

  // Assertiveness
  "assertiveness.aggressive.consequence": "Conflictos, aislamiento, culpabilidad",
  "assertiveness.aggressive.description": "Imponer necesidades sin considerar a los demas",
  "assertiveness.aggressive.examples": "Tienes que hacer eso!,Siempre es igual contigo,Nunca entiendes nada",
  "assertiveness.assertive.consequence": "Relaciones sanas, respeto mutuo, confianza en uno mismo",
  "assertiveness.assertive.description": "Expresar necesidades respetando a los demas",
  "assertiveness.assertive.examples": "Siento... cuando tu...,Necesitaria...,Entiendo tu punto de vista, y pienso que...",
  "assertiveness.descPlaceholderC": "Esto nos permitiria tener intercambios mas constructivos...",
  "assertiveness.descPlaceholderD": "Cuando me interrumpiste durante la reunion...",
  "assertiveness.descPlaceholderE": "Me senti frustrado/a y no escuchado/a...",
  "assertiveness.descPlaceholderS": "Me gustaria poder terminar mis frases antes de que respondas...",
  "assertiveness.examplesLabel": "Ejemplos:",
  "assertiveness.passive.consequence": "Frustracion, resentimiento, falta de respeto a uno mismo",
  "assertiveness.passive.description": "Evitar conflictos, no expresar necesidades",
  "assertiveness.passive.examples": "No digo nada,No importa,Como quieras",
  "assertiveness.passiveAggressive.consequence": "Malentendidos, tensiones, relaciones superficiales",
  "assertiveness.passiveAggressive.description": "Expresar hostilidad indirectamente",
  "assertiveness.passiveAggressive.examples": "Claro, como siempre...,No no, todo bien (suspiro),Haz lo que quieras",
  "auth.quote": "La mayor gloria no es nunca caer, sino levantarse cada vez.",

  // Capabilities
  "capabilities.creative.ex": "Innovacion,Diseno,Escritura,Artistico",
  "capabilities.personal.ex": "Gestion del tiempo,Adaptabilidad,Aprendizaje,Organizacion",
  "capabilities.physicalSkills.ex": "Deporte,Danza,Bricolaje,Cocina",
  "capabilities.professional.ex": "Gestion de proyectos,Comunicacion,Liderazgo,Resolucion de problemas",
  "capabilities.social.ex": "Escucha activa,Negociacion,Trabajo en equipo,Networking",

  // Cognitive Restructuring
  "cogRestructuring.actionPlan": "Plan de accion",
  "cogRestructuring.actionPlanPlaceholder": "Que puede hacer concretamente tras esta reflexion?",
  "cogRestructuring.alternativePlaceholder": "Ej: Quiza esta ocupado, no tengo suficiente informacion para concluir...",
  "cogRestructuring.emotionIntensityAfter": "Intensidad emocional despues de la reestructuracion",
  "cogRestructuring.emotionIntensityBefore": "Intensidad emocional antes de la reestructuracion",
  "cogRestructuring.evidenceAgainst": "Pruebas en contra de este pensamiento",
  "cogRestructuring.evidenceAgainstPlaceholder": "Que hechos objetivos contradicen este pensamiento?",
  "cogRestructuring.evidenceFor": "Pruebas a favor de este pensamiento",
  "cogRestructuring.evidenceForPlaceholder": "Que hechos objetivos apoyan este pensamiento?",
  "cogRestructuring.fillRequired": "Por favor, rellene la situacion y el pensamiento automatico",
  "cogRestructuring.high": "Intenso",
  "cogRestructuring.history": "Historial",
  "cogRestructuring.low": "Bajo",
  "cogRestructuring.newEntry": "Nueva reestructuracion",
  "cogRestructuring.noEntries": "Ninguna entrada por ahora",
  "cogRestructuring.pageSubtitle": "Identifique sus distorsiones cognitivas y desarrolle pensamientos alternativos mas equilibrados",
  "cogRestructuring.saved": "Reestructuracion cognitiva guardada!",
  "cogRestructuring.situationPlaceholder": "Ej: En una reunion, mi colega no respondio a mi mensaje...",
  "cogRestructuring.startRestructuring": "Comience por identificar un pensamiento automatico negativo",
  "cogRestructuring.step.alternative": "Pensamiento alternativo",
  "cogRestructuring.step.alternativeDesc": "Formule un pensamiento mas equilibrado y realista",
  "cogRestructuring.step.distortions": "Distorsiones cognitivas",
  "cogRestructuring.step.distortionsDesc": "Identifique los sesgos de razonamiento presentes en su pensamiento",
  "cogRestructuring.step.emotions": "Emociones sentidas",
  "cogRestructuring.step.emotionsDesc": "Identifique las emociones relacionadas con este pensamiento",
  "cogRestructuring.step.evidence": "Examen de pruebas",
  "cogRestructuring.step.evidenceDesc": "Analice objetivamente las pruebas a favor y en contra de su pensamiento",
  "cogRestructuring.step.situation": "Situacion",
  "cogRestructuring.step.situationDesc": "Describa la situacion que desencadeno sus pensamientos negativos",
  "cogRestructuring.step.thought": "Pensamiento automatico",
  "cogRestructuring.step.thoughtDesc": "Que pensamiento le vino espontaneamente?",
  "cogRestructuring.thoughtPlaceholder": "Ej: Me ignora, nadie me respeta...",
  "cogRestructuring.title": "Reestructuracion Cognitiva",

  // Self-Compassion
  "compassion.letter.prompt1": "Describa una situacion dificil que esta viviendo",
  "compassion.letter.prompt2": "Que le diria a un amigo querido en esta situacion?",
  "compassion.letter.prompt3": "Escribase esas mismas palabras de consuelo",
  "compassion.phrase1": "Que este a salvo",
  "compassion.phrase2": "Que sea feliz",
  "compassion.phrase3": "Que tenga buena salud",
  "compassion.phrase4": "Que viva con facilidad",
  "compassion.phrase5": "Merezco amor y compasion",
  "compassion.phrase6": "Me acepto tal como soy",
  "compassion.touch.step1": "Coloque una mano sobre su corazon",
  "compassion.touch.step2": "Sienta el calor de su mano",
  "compassion.touch.step3": "Respire profundamente",
  "compassion.touch.step4": "Digase: 'Estoy pasando un momento dificil'",
  "compassion.touch.step5": "Luego: 'Merezco compasion'",
  "compassion.touch.step6": "Permanezca asi unos minutos",

  // Consent
  "consent.dataProtection": "Proteccion de sus datos",
  "consent.message": "Al usar Kintsugi TCC, acepta nuestra politica de privacidad y el procesamiento de sus datos de salud conforme al RGPD.",

  // Session Report fields
  "cr.agenda_objectifs": "Agenda / Objetivos",
  "cr.ameliorations_progres": "Mejoras / Progreso",
  "cr.analyse_chaine": "Analisis en cadena",
  "cr.analyse_chaine_abc": "Analisis ABC",
  "cr.analyse_chaine_sorc": "Analisis SORC",
  "cr.analyse_tcc": "Analisis TCC",
  "cr.anamnese": "Anamnesis",
  "cr.echelles_administrees": "Escalas administradas",
  "cr.editHint": "Todos los campos rellenados son editables arriba.",
  "cr.evaluation_dsm5": "Evaluacion DSM-5",
  "cr.evaluations_standardisees": "Evaluaciones estandarizadas",
  "cr.exercices": "Ejercicios",
  "cr.experiences_comportementales": "Experimentos conductuales",
  "cr.fields": "campos",
  "cr.humeur_symptomes": "Estado de animo / Sintomas",
  "cr.hypothese_clinique_generale": "Hipotesis clinica general",
  "cr.hypothese_diagnostic_principal": "Diagnostico principal",
  "cr.hypotheses_diagnostics_differentiels": "Diagnosticos diferenciales",
  "cr.informations_generales": "Informacion general",
  "cr.initial": "Entrevista inicial",
  "cr.interventions": "Intervenciones",
  "cr.notes_libres": "Notas libres",
  "cr.nouveaux_exercices": "Nuevos ejercicios",
  "cr.objectifs_smart": "Objetivos SMART",
  "cr.objectifs_therapeutiques": "Objetivos terapeuticos",
  "cr.pensees_automatiques": "Pensamientos automaticos",
  "cr.plan_prochaine_seance": "Plan proxima sesion",
  "cr.problematiques": "Problematicas",
  "cr.processus_cibles": "Procesos objetivo",
  "cr.protocole_therapeutique": "Protocolo terapeutico",
  "cr.recommandations_suivi": "Recomendaciones de seguimiento",
  "cr.revue_exercices": "Revision de ejercicios",
  "cr.revue_semaine": "Revision de la semana",
  "cr.saveError": "Error al guardar el informe",
  "cr.saved": "Informe guardado",
  "cr.situation_pensees_emotions": "Situacion-Pensamientos-Emociones",
  "cr.strategies_therapeutiques": "Estrategias terapeuticas",
  "cr.suivi": "Sesion de seguimiento",

  // Cognitive Defusion
  "defusion.clouds.inst1": "Imagine su mente como un cielo azul infinito",
  "defusion.clouds.inst2": "Los pensamientos son nubes que atraviesan ese cielo",
  "defusion.clouds.inst3": "Algunas nubes son oscuras, otras claras",
  "defusion.clouds.inst4": "Usted es el cielo, no las nubes",
  "defusion.clouds.inst5": "Las nubes pasan, el cielo siempre permanece",
  "defusion.leaves.inst1": "Cierre los ojos e imagine un arroyo tranquilo",
  "defusion.leaves.inst2": "Vea hojas flotando suavemente en el agua",
  "defusion.leaves.inst3": "Cuando llegue un pensamiento, coloquelo en una hoja",
  "defusion.leaves.inst4": "Observe la hoja alejarse lentamente",
  "defusion.leaves.inst5": "No retenga las hojas, dejelas ir",
  "defusion.leaves.inst6": "Continue durante 5-10 minutos",
  "defusion.prefix.inst1": "Tome un pensamiento negativo, por ejemplo 'Soy inutil'",
  "defusion.prefix.inst2": "Anada el prefijo: 'Tengo el pensamiento de que soy inutil'",
  "defusion.prefix.inst3": "Luego: 'Noto que tengo el pensamiento de que soy inutil'",
  "defusion.prefix.inst4": "Note como esto crea distancia",
  "defusion.prefix.inst5": "Usted no es sus pensamientos, los observa",
  "defusion.silly.inst1": "Identifique un pensamiento que le perturba",
  "defusion.silly.inst2": "Repitalo en voz alta con voz de dibujos animados",
  "defusion.silly.inst3": "Pruebe diferentes voces: robot, cantando, muy lento...",
  "defusion.silly.inst4": "Note como esto cambia su relacion con el pensamiento",
  "defusion.silly.inst5": "El pensamiento sigue ahi, pero tiene menos poder",
  "defusion.thankMind.inst1": "Cuando surja un pensamiento negativo",
  "defusion.thankMind.inst2": "Diga internamente: 'Gracias, mente, por este pensamiento'",
  "defusion.thankMind.inst3": "Reconozca que su mente intenta protegerle",
  "defusion.thankMind.inst4": "Luego traiga gentilmente su atencion al presente",
  "defusion.thankMind.inst5": "Esta tecnica reduce la lucha contra los pensamientos",

  // Distortions
  "distortion.allOrNothing": "Pensamiento todo-o-nada",
  "distortion.allOrNothing.desc": "Ver las cosas en blanco o negro, sin matices",
  "distortion.catastrophizing": "Catastrofizacion",
  "distortion.catastrophizing.desc": "Imaginar el peor escenario posible",
  "distortion.emotionalReasoning": "Razonamiento emocional",
  "distortion.emotionalReasoning.desc": "Creer que lo que sentimos refleja la realidad",
  "distortion.fortuneTelling": "Prediccion del futuro",
  "distortion.fortuneTelling.desc": "Predecir negativamente el futuro sin pruebas",
  "distortion.labeling": "Etiquetado",
  "distortion.labeling.desc": "Definirse por un solo evento negativo",
  "distortion.magnification": "Magnificacion / Minimizacion",
  "distortion.magnification.desc": "Exagerar lo negativo o minimizar lo positivo",
  "distortion.mindReading": "Lectura de mente",
  "distortion.mindReading.desc": "Suponer lo que otros piensan sin pruebas",
  "distortion.overgeneralization": "Sobregeneralizacion",
  "distortion.overgeneralization.desc": "Sacar una conclusion general de un solo evento",
  "distortion.personalization": "Personalizacion",
  "distortion.personalization.desc": "Sentirse responsable de cosas fuera de su control",
  "distortion.shouldStatements": "Los 'deberia'",
  "distortion.shouldStatements.desc": "Imponerse reglas rigidas e irrealistas",

  // Needs
  "needs.belonging.description": "Amor, amistad, intimidad, familia",
  "needs.belonging.q1": "Tiene relaciones de amistad satisfactorias?",
  "needs.belonging.q2": "Se siente amado/a y apoyado/a?",
  "needs.belonging.q3": "Forma parte de un grupo o comunidad?",
  "needs.belonging.q4": "Sus relaciones intimas le realizan?",
  "needs.esteem.description": "Respeto, reconocimiento, confianza en si mismo",
  "needs.esteem.q1": "Se siente respetado/a por los demas?",
  "needs.esteem.q2": "Esta orgulloso/a de sus logros?",
  "needs.esteem.q3": "Tiene confianza en sus capacidades?",
  "needs.esteem.q4": "Se siente valorado/a en su trabajo?",
  "needs.physiological.description": "Alimentacion, agua, sueno, salud, refugio",
  "needs.physiological.q1": "Duerme lo suficiente?",
  "needs.physiological.q2": "Come de manera equilibrada?",
  "needs.physiological.q3": "Tiene una vivienda estable y comoda?",
  "needs.physiological.q4": "Su salud fisica es satisfactoria?",
  "needs.safety.description": "Seguridad financiera, empleo, salud, propiedad",
  "needs.safety.q1": "Se siente seguro/a financieramente?",
  "needs.safety.q2": "Su empleo es estable?",
  "needs.safety.q3": "Se siente fisicamente seguro/a?",
  "needs.safety.q4": "Tiene un sentimiento de estabilidad en su vida?",
  "needs.selfActualization.description": "Creatividad, realizacion, cumplimiento del potencial",
  "needs.selfActualization.q1": "Persigue sus pasiones e intereses?",
  "needs.selfActualization.q2": "Tiene la sensacion de realizarse?",
  "needs.selfActualization.q3": "Utiliza plenamente sus talentos?",
  "needs.selfActualization.q4": "Contribuye a algo mas grande que usted?",

  // Maslow pyramid examples
  "needs.physiological.examples": "Sueno reparador / Descanso / Calma / Menos estimulacion",
  "needs.safety.examples": "Previsibilidad / Estabilidad / Seguridad financiera / Material",
  "needs.belonging.examples": "Reconocimiento / Valoracion / Afecto / Apoyo emocional",
  "needs.esteem.examples": "Autoestima / Estimulacion / Novedad / Sentido / Comprension",
  "needs.selfActualization.examples": "Ser escuchado / Comprendido / Poder de eleccion / Decision / Tiempo para mi",

  // Pyramid card
  "needs.pyramidTitle": "Piramide de necesidades de Maslow",
  "needs.pyramidHint": "Haga clic en un nivel para explorar sus necesidades",
  "needs.evaluateSection": "Evalue la satisfaccion de cada dimension (1 a 10)",

  // Specific needs table
  "needs.tableTitle": "Tabla: Exploracion de las necesidades fundamentales",
  "needs.tableHint": "Agregue sus necesidades especificas en esta categoria. Puede agregar tantas como sean necesarias.",
  "needs.col.specific": "Necesidad especifica",
  "needs.col.specific.placeholder": "Ej. Dormir 8h por noche",
  "needs.col.nourished": "Esta necesidad esta cubierta?",
  "needs.col.response": "Como podria responder mejor a ella?",
  "needs.col.response.placeholder": "Acciones concretas…",
  "needs.col.priority": "Prioridad",
  "needs.col.deadline": "Plazo",
  "needs.nourished.yes": "Si",
  "needs.nourished.no": "No",
  "needs.nourished.partial": "Un poco",
  "needs.priority.high": "Alta",
  "needs.priority.medium": "Media",
  "needs.priority.low": "Baja",
  "needs.addRow": "Agregar una necesidad",

  // Patient exercises
  "patientExercises.assignedCount": "{count} ejercicio(s) asignado(s)",
  "patientExercises.balancedThought": "Pensamiento equilibrado:",
  "patientExercises.difficultyLabel": "Dificultad:",
  "patientExercises.generating": "Generando...",
  "patientExercises.moreEntries": "... y {count} entrada(s) mas",
  "patientExercises.problemLabel": "Problema:",
  "patientExercises.rewardLabel": "Recompensa:",
  "patientExercises.standaloneCount": "{count} entrada(s) autonoma(s)",
  "patientExercises.thoughts": "Pensamientos:",

  // Pomodoro
  "pomodoro.addTask": "Anadir tarea",
  "pomodoro.allDone": "Dia terminado!",
  "pomodoro.dayPlannerSubtitle": "Planifique y ejecute sus pomodori del dia",
  "pomodoro.deferTask": "Aplazar",
  "pomodoro.deferred": "Aplazado",
  "pomodoro.effectiveWork": "de trabajo efectivo",
  "pomodoro.longBreak": "Pausa larga (min)",
  "pomodoro.longBreakHint": "La pausa larga se activa automaticamente despues de 4 pomodori",
  "pomodoro.longBreakLabel": "Pausa larga",
  "pomodoro.maxReached": "Maximo alcanzado (8h de trabajo efectivo)",
  "pomodoro.min": "min",
  "pomodoro.newPlan": "Nuevo plan",
  "pomodoro.objectivePh": "Objetivo: que quiere lograr?",
  "pomodoro.planCreated": "Plan creado!",
  "pomodoro.planTasks": "Tareas del dia",
  "pomodoro.resume": "Reanudar",
  "pomodoro.reviewPh": "Que logro? Como fue?",
  "pomodoro.reviewTitle": "Balance del pomodoro",
  "pomodoro.settings": "Ajustes",
  "pomodoro.shortBreak": "Pausa corta (min)",
  "pomodoro.skipBreak": "Saltar pausa",
  "pomodoro.startBreak": "Iniciar pausa",
  "pomodoro.startDay": "Iniciar el dia",
  "pomodoro.submitReview": "Validar y continuar",
  "pomodoro.taskDeferred": "Tarea aplazada",
  "pomodoro.taskList": "Lista de tareas",
  "pomodoro.workDuration": "Trabajo (min)",

  // Profile & subscription
  "profile.manageSubscription": "Gestionar mi suscripcion",
  "progress.averageMoodValue": "{value}/10",
  "progress.noReports": "No hay informes de sesion para este paciente",
  "progress.noReportsHint": "Genere un informe desde la pestana Informes",
  "progress.sessionReportsTitle": "Informes de sesion",

  // Qualities
  "qualities.emotional.ex": "Calma,Resiliente,Optimista,Paciente,Sensible",
  "qualities.intellectual.ex": "Curioso,Creativo,Analitico,Perspicaz,Reflexivo",
  "qualities.interpersonal.ex": "Empatico,Atento,Generoso,Leal,Bondadoso",
  "qualities.moral.ex": "Honesto,Integro,Justo,Responsable,Humilde",
  "qualities.practical.ex": "Organizado,Fiable,Perseverante,Ingenioso,Eficiente",

  // Self-reinforcement
  "reinforcement.describeAccomplishment": "Describa su logro",
  "reinforcement.reflectionPlaceholder": "Que aprendio sobre usted mismo/a?",
  "reinforcement.reward1": "Tomar un momento de relajacion",
  "reinforcement.reward2": "Escuchar mi musica favorita",
  "reinforcement.reward3": "Dar un paseo",
  "reinforcement.reward4": "Llamar a un amigo",
  "reinforcement.reward5": "Disfrutar de una buena comida",
  "reinforcement.reward6": "Ver un episodio de mi serie",
  "reinforcement.reward7": "Leer unas paginas de un libro",
  "reinforcement.reward8": "Hacer una actividad creativa",

  // Subscription
  "subscription.failedMessage": "El pago no se completo. Por favor, intentelo de nuevo.",
  "subscription.retry": "Reintentar",
  "subscription.success": "Pago exitoso!",
  "subscription.successMessage": "Su suscripcion esta ahora activa. Disfrute de todas las funcionalidades.",
  "subscription.verifying": "Verificando el pago...",

  // Trial banner
  "trialBanner.dontLoseAccess": "Suscribase para no perder el acceso.",
  "trialBanner.subscribePrompt": "Suscribase para recuperar el acceso a todas las funcionalidades.",
  "trialBanner.trialExpired": "Prueba expirada",
  "trialBanner.trialExpiredMessage": "Su prueba gratuita ha expirado",

  // Values
  "values.domain.community": "Comunidad/Ciudadania",
  "values.domain.community.desc": "Compromiso social, voluntariado, contribucion a la sociedad",
  "values.domain.education": "Educacion/Aprendizaje",
  "values.domain.education.desc": "Curiosidad, desarrollo personal, adquisicion de conocimientos",
  "values.domain.environment": "Medio ambiente/Naturaleza",
  "values.domain.environment.desc": "Conexion con la naturaleza, ecologia, respeto del medio ambiente",
  "values.domain.family": "Familia",
  "values.domain.family.desc": "Relaciones familiares, paternidad, ser buen padre/hijo/hermano",
  "values.domain.friends": "Amistad",
  "values.domain.friends.desc": "Amistades, relaciones sociales, pertenencia a un grupo",
  "values.domain.health": "Salud/Bienestar",
  "values.domain.health.desc": "Salud fisica y mental, equilibrio de vida",
  "values.domain.leisure": "Ocio",
  "values.domain.leisure.desc": "Actividades recreativas, hobbies, placeres",
  "values.domain.relationships": "Relaciones Intimas",
  "values.domain.relationships.desc": "Relaciones amorosas, intimidad, conexion emocional",
  "values.domain.spirituality": "Espiritualidad",
  "values.domain.spirituality.desc": "Conexion espiritual, sentido de la vida, trascendencia",
  "values.domain.work": "Trabajo/Carrera",
  "values.domain.work.desc": "Logro profesional, contribucion, desarrollo",
};

export default es;
